<template>
     <div class="tab-pane fade" :class="{'show active': current_step === 3}" id="luminaire-line-configurator-step" role="tabpanel" aria-labelledby="luminaire-line-configurator-step-tab">
        <h2 class="text-white">{{ planningFormFields.title }}</h2>
        <div class="tab-pane fade show active" id="llt-accordion" role="tabpanel" aria-labelledby="llt-tab">
            <ValidationObserver ref="lltForm" v-slot="{ handleSubmit }" >
                <form class="planning-data-form" @submit.prevent="handleSubmit(onSubmit)" @change="calculateLuminationLineForm" @input="calculateLuminationLineForm">
                    <div class="accordion md-accordion pt-4" id="ltt-accordion" role="tablist" aria-multiselectable="true">

                        <!-- BELEUCHTUNGSLÄNGE -->
                        <div class="card ltt-steps">
                            <!-- Card header -->
                            <card-header id="heading-luminaire-line-length" href="ltt-step-luminaire-line-length">
                                <span>{{ product_configurator_id === 1 ? $t('Total length of lighting line') : $t('Total length of track system') }} <i
                                    class="fas fa-check-circle text-primary" v-if="luminationLengthValid && mountingRailStepIsValid"></i></span>
                            </card-header>
                            <!-- Card body -->
                            <div id="ltt-step-luminaire-line-length" class="show" role="tabpanel" aria-labelledby="heading-ltt-step-luminaire-line-length" data-parent="#ltt-accordion">
                                <div class="card-body px-0 py-3">
                                    <div class="container-fluid px-0 text-white">
                                        <!-- LUMINATION LENGTH -->

                                        <ValidationProvider
                                            :name="product_configurator_id === 1 ? $t('Lighting length') : $t('Track system length')"
                                            rules="required|numeric|min_value:2"
                                            tag="div"
                                            class="row"
                                            v-slot="{ errors }">
                                            <div class="col-5">
                                                <img class="img-fluid pb-3" :src="luminaireLengthImage" :alt="product_configurator_id === 1 ? $t('Lighting length') : $t('Track system length')">
                                            </div>
                                            <div class="form-group col-7 pt-5">
                                                <input v-model.number="luminaireLineFormFields.lumination_length_suggestion" type="number" name="lumination_length" class="form-control" :placeholder="product_configurator_id === 1 ? $t('Lighting length in m') : $t('Track system length in m')">
                                                <p class="text-white exact-length-indicator">
                                                    <span v-if="calculatedExactLength < 1.68">{{ $t('Minimum length 1.68 m') }}</span>
                                                </p>
                                                <span class="text-danger">{{ errors[0] }}</span>
                                                <div class="alert alert-danger" v-if="(luminaireLineFormErrors && luminaireLineFormErrors.lumination_length)">
                                                    {{ luminaireLineFormErrors.lumination_length[0] }}
                                                </div>
                                            </div>
                                        </ValidationProvider>

                                        <!-- MOUNTING RAIL LENGTH SUGGESTINS -->
                                        <div class="form-group" v-if="luminaireLineFormFields.lumination_length_suggestion && luminaireLineFormFields.lumination_length_suggestion >= 1.68">
                                            <h5 class="text-white">{{ product_configurator_id === 1 ? $t('Possible lighting lengths') : $t('Possible track system lengths') }}:</h5>
                                            <div class="form-check" v-for="lengthSuggestion in calculatedLengthSuggestionPrices">
                                                <input class="form-check-input" type="radio"
                                                       :id="'lumination_length-' + lengthSuggestion.luminationLength"
                                                       v-model.number="luminaireLineFormFields.lumination_length"
                                                       :value="lengthSuggestion.luminationLength"
                                                       @change="resetMountingRailConfiguration('all')">
                                                <label class="form-check-label text-white" :for="'lumination_length-' + lengthSuggestion.luminationLength">
                                                    {{ (lengthSuggestion.luminationLength / 100) }} m <span v-if="$can('view_prices')">(€ {{ (lengthSuggestion.price - (lengthSuggestion.price * user.user_project_discount / 100) ).toFixed(2) }})</span>
                                                </label>
                                            </div>
                                            <div class="alert alert-danger" v-if="luminaireLineFormErrors && luminaireLineFormErrors.lumination_length">
                                                {{ luminaireLineFormErrors.lumination_length[0] }}
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
                            <!-- Accordion card -->

                            <!-- LED & BLINDMODULE / Mounting rails with connectors -->
                            <div class="card ltt-steps">
                                <!-- Card header -->
                                <card-header href="ltt-step-led-blind-modules" id="heading-led-blind-modules">
                                    <span>{{ product_configurator_id === 1 ? $t('LED modules and mounting rails') : $t('Mounting rails and electical connectors') }} <i class="fas fa-check-circle text-primary" v-if="(product_configurator_id === 1 && ledAndBlindModuleValid && mountingRailStepIsValid) || (product_configurator_id === 3 && mountingRailWithConnectorsStepIsValid && mountingRailStepIsValid)"></i></span>
                                </card-header>
                                <!-- Card body -->
                                <div id="ltt-step-led-blind-modules" class="collapse" role="tabpanel" aria-labelledby="heading-ltt-step-led-blind-modules" data-parent="#ltt-accordion">
                                    <div class="card-body px-0 py-3">

                                        <!-- NUMBER OF LED MODULES -->
                                        <div class="container-fluid px-0 text-white">
                                            <ValidationProvider :name="$t('Number of LED modules')"
                                                                :rules="`required|numeric|min_value:${product_configurator_id === 1 ? 1 : 0}|max_value:${luminaireLineFormFields.number_of_modules_total}`"
                                                                tag="div"
                                                                immediate
                                                                class="row pb-3"
                                                                v-slot="{ errors }"
                                                                v-if="product_configurator_id === 1 ">
                                                <div class="col-3">
                                                    <img :src="selectedSerie === 'eco' ? asset('img/luminaire-selection-tool/led-modul-symbolbild-v2.png') : asset('img/luminaire-selection-tool/led-modul-symbolbild-max-v2.png')" :alt="$t('LED module')" class="img-fluid">
                                                </div>
                                                <div class="form-group col-9 pt-3">
                                                    <h5 class="text-white">{{ $t('How many LED modules should be installed') }}?</h5>
                                                    <input type="number" name="number_of_led_modules" class="form-control" :placeholder="$t('Number of LED modules')" :min="product_configurator_id === 1 ? 1 : 0"
                                                           v-model.number="luminaireLineFormFields.number_of_led_modules"
                                                           :max="luminaireLineFormFields.number_of_modules_total ? luminaireLineFormFields.number_of_modules_total : 1"
                                                           @input="lltGoToNextSection($event, 'ltt-step-luminaire-electrical-feeds', errors, !blindModuleStepIsValid)">
                                                    <p class="text-light" v-if="luminaireLineFormFields.lumination_length">
                                                        {{ $t('Maximum number of LED modules') }}: {{ luminaireLineFormFields.number_of_modules_total }}
                                                    </p>
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                    <div class="alert alert-danger" v-if="luminaireLineFormErrors && luminaireLineFormErrors.number_of_led_modules">
                                                        {{ luminaireLineFormErrors.number_of_led_modules[0] }}
                                                    </div>
                                                </div>
                                            </ValidationProvider>
                                            <p class="text-light" v-if="product_configurator_id === 1 && luminaireLineFormFields.type_of_blind_modules && luminaireLineFormFields.number_of_led_modules > 0">{{ $t('Number of blind modules required') }}: {{ luminaireLineFormFields.number_of_blind_modules }}</p>
                                        </div>

                                        <!-- EMERGENCY LIGHT -->
                                        <div class="container-fluid px-0 text-white mt-3" v-if="product_configurator_id === 1">
                                            <h4 class="text-white">{{ $t('Emergency light') }} <i class="fas fa-check-circle text-primary small" v-if="emergencyLightValid"></i><i class="fas fa-times-circle text-danger small" v-else></i></h4>
                                            <ValidationProvider :name="$t('Emergency light')"
                                                                rules="numeric"
                                                                tag="div"
                                                                class="row"
                                                                v-slot="{ errors }">
                                                <div class="col-6 col-md-4 form-group llt-emergency-light" v-for="emergency_light in luminaireLineProducts.emergency_lights">
                                                    <div class="custom-control custom-radio image-checkbox text-left">
                                                        <input type="radio" class="custom-control-input"
                                                               :name="'module-name-' + emergency_light.id"
                                                               :id="'module-name-' + emergency_light.id"
                                                               v-model.number="luminaireLineFormFields.type_of_emergency_light"
                                                               :value="emergency_light.id"
                                                               @click="emergencyLightDeselectIfSelected(emergency_light.id)">
                                                        <label class="custom-control-label btn btn-dark" :for="'module-name-' + emergency_light.id" :class="{ 'active': luminaireLineFormFields.type_of_emergency_light === emergency_light.id}">
                                                            <img :src="asset('productimages/' + ($i18n.locale === 'en' && emergency_light.picture_file_name_en ? emergency_light.picture_file_name_en : emergency_light.picture_file_name))" :alt="$t(emergency_light.title)" class="img-fluid" v-if="emergency_light.picture_file_name">
                                                            <p class="text-white pt-3">{{ $t(emergency_light.title) }} <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="emergency_light.tooltip" v-if="emergency_light.tooltip"></i><br><span class="small" v-if="$can('view_prices')">€ {{ emergency_light.price }} / {{ $t('pcs.') }}</span></p>
                                                        </label>
                                                    </div>
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>

                                            <ValidationProvider :name="$t('Number of emergency lights')"
                                                                :rules="`numeric|min_value:1|max_value:${luminaireLineFormFields.number_of_led_modules}`"
                                                                tag="div"
                                                                class="row"
                                                                v-slot="{ errors }" v-if="luminaireLineFormFields.type_of_emergency_light">
                                                <div class="form-group col-sm-12 mb-3">
                                                    <h5 class="text-white">{{ $t('Number of emergency lights') }}</h5>
                                                    <input v-model.number="luminaireLineFormFields.number_of_emergency_lights" name="number_of_emergency_lights" type="number" class="form-control w-50" :placeholder="$t('Number of emergency lights')" :max="luminaireLineFormFields.number_of_led_modules">
                                                    <div class="alert alert-danger text-right" v-if="luminaireLineFormErrors && luminaireLineFormErrors.number_of_emergency_lights">
                                                        {{ luminaireLineFormErrors.number_of_emergency_lights[0] }}
                                                    </div>
                                                    <div class="text-danger">{{ errors[0] }}</div>
                                                </div>
                                            </ValidationProvider>

                                            <!-- FIXED INSTALLATION IN 1.68 MOUNTING RAIL -->
                                            <div  v-if="luminaireLineFormFields.type_of_emergency_light && luminaireLineFormFields.number_of_emergency_lights >= 1">
                                                <input type="checkbox" id="emergency_light_standalone" v-model="luminaireLineFormFields.emergency_light_standalone">
                                                 <!-- Todo: Fixed groß und m für meter und deutsche übersetzung kommt per mail -->
                                                <label for="emergency_light_standalone">{{ $t('Fixed installation in 1.68m mounting rail') }}</label>
                                            </div>

                                        </div>

                                            <!-- MOUNTING RAIL CONFIGURATION -->
                                        <div class="mt-3" v-if="luminaireLineFormFields.lumination_length">
                                            <h4 class="text-white">{{ $t('Mounting rail configuration') }}</h4>
                                            <div class="container-fluid px-0 mx-0 mb-5">
                                                <div class="row">
                                                    <div class="col-6 col-md-4 form-group" v-for="(mountingRailSuggestion, index) in mountingRailTypeSuggestions" v-if="mountingRailSuggestion">
                                                        <div class="custom-control custom-radio image-checkbox text-left">
                                                            <input type="radio" class="custom-control-input"
                                                                   :name="'mounting-rail-suggestion-' + index"
                                                                   :id="'mounting-rail-suggestion-' + index"
                                                                   v-model.number="selectedMountingRailTypeSuggestion"
                                                                   :value="index"
                                                                   @change="resetMountingRailConfiguration('all'),lltGoToNextSection($event, 'ltt-step-led-blind-modules', false, false)" >

                                                            <label class="custom-control-label btn btn-dark" :class="{ 'active': selectedMountingRailTypeSuggestion === index}" :for="'mounting-rail-suggestion-' + index">
                                                                <p class="mb-0 lead"><strong>{{ index === 'optimal' ? $t('Optimal') : '' }}{{ index === 'second' ? $t('Option 3.36 m') : '' }}{{ index === 'third' ? $t('Option 1.68 m') : '' }}</strong></p>
                                                                <p class="mb-0">
                                                                    <span class="d-block" v-for="railConfiguraiton of mountingRailSuggestion" v-if="railConfiguraiton.counter > 0">{{ railConfiguraiton.counter }}x {{ $t('Mounting rail') }} {{ railConfiguraiton.luminationType / 100 }} m</span>
                                                                </p>
                                                                <p class="mb-0" v-if="$can('view_prices')">
                                                                    <span v-if="product_configurator_id === 3">{{ $t('from')}} </span><span>€ {{ ( getMountingRailPrice(mountingRailSuggestion) - (getMountingRailPrice(mountingRailSuggestion) * user.user_project_discount / 100) ).toFixed(2) }}</span>
                                                                </p>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Number of mounting rails and electrical connectors -->
                                        <div class="container-fluid px-0 text-white">
                                            <ValidationProvider v-for="(mounting_rail, index) in luminaireLineProducts.mountingrails_with_connectors"
                                                            v-if="product_configurator_id === 3 && mountingRailTypeSuggestions[selectedMountingRailTypeSuggestion] && mountingRailTypeSuggestions[selectedMountingRailTypeSuggestion].find(el => el.luminationType === mounting_rail.size_x)"
                                                            :name="$t(mounting_rail.title)"
                                                            :rules="`required|numeric|min_value:${0}|max_value:${!getDynamicModel('number_of_', mounting_rail.db_title) ? getMissingMountingRailsByType(mounting_rail.size_x).missing : getDynamicModel('number_of_', mounting_rail.db_title) + getMissingMountingRailsByType(mounting_rail.size_x).missing}`"
                                                            :key="mounting_rail.id"
                                                            tag="div"
                                                            v-slot="{ errors }">

                                                <div class="row" v-if="checkIfFirstMountingRailOfThisLength(mounting_rail.size_x) === index">
                                                    <div class="form-group col-12">
                                                        <h5 class="pt-3">{{ $t(getMountingRailConfigurationByTitle(mounting_rail.title) ? getMountingRailConfigurationByTitle(mounting_rail.title).title : '') }}:</h5>
                                                        <p class="mb-0 small">{{ getMissingMountingRailsByType(mounting_rail.size_x).needed }} {{ $t('needed') }} | {{ getMissingMountingRailsByType(mounting_rail.size_x).missing }} {{ $t('missing') }} | <a href="#" @click.prevent="resetMountingRailConfiguration(mounting_rail)">{{ $t('reset') }}</a></p>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="form-group col-8">
                                                        <h6 class="m-0">{{ $t('Number of mounting rails with')}} {{ $t(getMountingRailConfigurationByTitle(mounting_rail.title) ? getMountingRailConfigurationByTitle(mounting_rail.title).connectors : '') }}:</h6>
                                                        <p class="small text-light m-0" v-if="$can('view_prices') && mounting_rail.price">€ {{ mounting_rail.price }} / {{ $t('Pcs.') }}</p>
                                                    </div>
                                                    <div class="form-group col-4">
                                                        <input type="number" :name="'number_of_' + mounting_rail.db_title" class="form-control" :placeholder="$t('Quantity')" :min="0"
                                                               :value="getDynamicModel('number_of_', mounting_rail.db_title)"
                                                               :max="!getDynamicModel('number_of_', mounting_rail.db_title)
                                                                        ? getMissingMountingRailsByType(mounting_rail.size_x).missing
                                                                        : getDynamicModel('number_of_', mounting_rail.db_title) + getMissingMountingRailsByType(mounting_rail.size_x).missing"
                                                               @input="setDynamicModel('number_of_', mounting_rail.db_title, $event.target.value), autoPopulateMountingRails(getDynamicModel('number_of_', mounting_rail.db_title), getMissingMountingRailsByType(mounting_rail.size_x).missing, 'number_of_', mounting_rail.db_title), lltGoToNextSection($event, 'ltt-step-luminaire-electrical-feeds', errors, !mountingRailWithConnectorsStepIsValid)">
                                                        <span class="text-danger">{{ errors[0] }}</span>
                                                        <div class="alert alert-danger" v-if="luminaireLineFormErrors && getDynamicError('number_of_', mounting_rail.db_title)">
                                                            {{ getDynamicError('number_of_', mounting_rail.db_title)[0] }}
                                                        </div>
                                                    </div>
                                                </div>

                                        </ValidationProvider>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Accordion card -->

                            <!-- EINSPEISUNGEN -->
                            <div class="card ltt-steps">
                                <!-- Card header -->
                                <card-header href="ltt-step-luminaire-electrical-feeds" id="heading-luminaire-electrical-feeds">
                                    <span>{{ $t('Electrical feeds') }} <i class="fas fa-check-circle text-primary" v-if="electricalFeedsValid"></i></span>
                                </card-header>
                                <!-- Card body -->
                                <div id="ltt-step-luminaire-electrical-feeds" class="collapse" role="tabpanel" aria-labelledby="heading-ltt-step-luminaire-electrical-feeds" data-parent="#ltt-accordion">
                                    <div class="card-body px-0 py-3">
                                        <!-- EINSPEISUNGEN -->
                                        <div class="container-fluid px-0 text-white">
                                            <!-- Anzahl Einspeisungen Anfang/Ende -->
                                            <div class="container-fluid w-100 mb-3">
                                                <div class="row">
                                                    <p class="text-light">{{ $t('Number of electrical feeds required') }}: {{ luminaireLineFormFields.number_of_electrical_feeds_per_line }}</p>
                                                </div>
                                                <div class="row electrical-feeds-row">
                                                    <!--  ANFANG -->
                                                    <ValidationProvider vid="number_of_electrical_feeds_start"
                                                                        :name="$t('Number of electrical feeds beginning')"
                                                                        :rules="`required|numeric|number_of_electrical_feeds:@number_of_electrical_feeds_start,@number_of_electrical_feeds_middle,@number_of_electrical_feeds_end,${luminaireLineFormFields.number_of_electrical_feeds_per_line}`"
                                                                        v-slot="{ errors }"
                                                                        tag="div"
                                                                        class="col-4 m-0 py-0 px-1">
                                                        <img class="img-fluid pb-4" :src="selectedSerie === 'eco' ? asset('img/luminaire-selection-tool/Einspeisungen_Ausschnitt-anfang_v2.png') : asset('img/luminaire-selection-tool/max-v2-einspeisung-anfang.png')">
                                                        <div class="form-group m-0 p-0">
                                                            <input v-model.number="number_of_electrical_feeds_start_total" name="number_of_electrical_feeds_start" type="number" class="form-control w-50" :placeholder="$t('Beginning')" @input="autoPopulateElectricalFeeds">
                                                            <div class="alert alert-danger" v-if="luminaireLineFormErrors && luminaireLineFormErrors.number_of_electrical_feeds_start">
                                                                {{ luminaireLineFormErrors.number_of_electrical_feeds_start[0] }}
                                                            </div>
                                                            <div class="text-danger" v-if="errors && errors[0]">{{ $t(errors[0]) }}: {{ luminaireLineFormFields.number_of_electrical_feeds_per_line}}</div>
                                                            <p class="small text-light m-1" v-if="$can('view_prices') && luminaireLineProducts.electrical_feeds && luminaireLineProducts.electrical_feeds.find(electricalFeed => electricalFeed.product_subtype.includes('electrical_feed_start'))">€ {{ luminaireLineProducts.electrical_feeds.find(electricalFeed => electricalFeed.title.includes('beginning')).price }}/ {{ $t('Pcs.') }}</p>
                                                        </div>
                                                    </ValidationProvider>
                                                    <!--  MITTE -->
                                                    <ValidationProvider vid="number_of_electrical_feeds_middle"
                                                                        :name="$t('Number of electrical center feeds')"
                                                                        :rules="`required|numeric|number_of_electrical_feeds:@number_of_electrical_feeds_start,@number_of_electrical_feeds_middle,@number_of_electrical_feeds_end,${luminaireLineFormFields.number_of_electrical_feeds_per_line}`"
                                                                        v-slot="{ errors }"
                                                                        tag="div"
                                                                        class="col-4 m-0 py-0 px-1">

                                                        <img class="img-fluid pb-4" :src="selectedSerie === 'eco' ? asset('img/luminaire-selection-tool/Einspeisungen_Ausschnitt-mitte_v2.png') : asset('img/luminaire-selection-tool/max-v2-einspeisung-mitte.png')">
                                                        <div class="form-group m-0 p-0">
                                                            <input v-model.number="luminaireLineFormFields.number_of_electrical_feeds_middle" type="number" class="form-control w-50 mx-auto" :placeholder="$t('Center')" @input="autoPopulateElectricalFeeds">
                                                            <div class="alert alert-danger text-center" v-if="luminaireLineFormErrors && luminaireLineFormErrors.number_of_electrical_feeds_middle">
                                                                {{ luminaireLineFormErrors.number_of_electrical_feeds_middle[0] }}
                                                            </div>
                                                            <div class="text-danger text-center" v-if="errors && errors[0]">{{ $t(errors[0]) }}: {{ luminaireLineFormFields.number_of_electrical_feeds_per_line}}</div>
                                                            <p class="small text-light m-1 text-center" v-if="$can('view_prices') && luminaireLineProducts.electrical_feeds && luminaireLineProducts.electrical_feeds.find(electricalFeed => electricalFeed.product_subtype.includes('electrical_feed_middle'))">€ {{ luminaireLineProducts.electrical_feeds.find(electricalFeed => electricalFeed.title.includes('center')).price }}/ {{ $t('Pcs.') }}</p>
                                                            <div class="text-center"><i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t('Not through-connected and two feeds possible in both directions')"></i></div>
                                                        </div>
                                                    </ValidationProvider>
                                                    <!--  ENDE -->
                                                    <ValidationProvider vid="number_of_electrical_feeds_end"
                                                                        :name="$t('Number of electrical end feeds')"
                                                                        :rules="`required|numeric|number_of_electrical_feeds:@number_of_electrical_feeds_start,@number_of_electrical_feeds_middle,@number_of_electrical_feeds_end,${luminaireLineFormFields.number_of_electrical_feeds_per_line}`"
                                                                        v-slot="{ errors }"
                                                                        tag="div"
                                                                        class="col-4 m-0 py-0 px-1">
                                                        <img class="img-fluid pb-4" :src="selectedSerie === 'eco' ? asset('img/luminaire-selection-tool/Einspeisungen_Ausschnitt-ende_v2.png') : asset('img/luminaire-selection-tool/max-v2-einspeisung-ende.png')">
                                                        <div class="form-group m-0 p-0">
                                                            <input v-model.number="number_of_electrical_feeds_end_total" name="number_of_electrical_feeds_end" type="number" class="form-control w-50 ml-auto" :placeholder="$t('End')" @input="autoPopulateElectricalFeeds">
                                                            <div class="alert alert-danger text-right" v-if="luminaireLineFormErrors && luminaireLineFormErrors.number_of_electrical_feeds_end">
                                                                {{ luminaireLineFormErrors.number_of_electrical_feeds_end[0] }}
                                                            </div>
                                                            <div class="text-danger text-right" v-if="errors && errors[0]">{{ $t(errors[0]) }}: {{ luminaireLineFormFields.number_of_electrical_feeds_per_line}}</div>
                                                            <p class="small text-light m-1" v-if="$can('view_prices') && luminaireLineProducts.electrical_feeds && luminaireLineProducts.electrical_feeds.find(electricalFeed => electricalFeed.product_subtype.includes('electrical_feed_end'))">€ {{ luminaireLineProducts.electrical_feeds.find(electricalFeed => electricalFeed.title.includes('end')).price }}/ {{ $t('Pcs.') }}</p>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                            </div>
                                            <p class="text-light" v-if="luminaireLineFormFields.lumination_length < luminaireLineFormFields.total_lumination_line_length">{{ $t('The total length of the lighting line was increased') }}: {{ luminaireLineFormFields.total_lumination_line_length / 100 }} m</p>
                                        </div>
                                        <!-- ANSCHLUSSKABEL -->
                                        <div class="container-fluid px-0 text-white" v-if="electricalFeedsValid">
                                            <div class="row">
                                                <div class="col">
                                                    <h4 class="text-white pt-3">{{ $t('Connection cable') }}</h4>
                                                </div>
                                            </div>
                                            <ValidationProvider :name="$t('Connection cable')"
                                                                rules="numeric"
                                                                tag="div"
                                                                class="row"
                                                                v-slot="{ errors }">
                                                <div class="llt-electrical-addons col-6 col-md-4 form-group" v-for="connecting_cable in luminaireLineProducts.connecting_cable">
                                                    <div class="custom-control custom-radio image-checkbox text-left">
                                                        <input type="radio" class="custom-control-input"
                                                               :name="'module-name-' + connecting_cable.id"
                                                               :id="'module-name-' + connecting_cable.id"
                                                               v-model.number="luminaireLineFormFields.type_of_connecting_cable"
                                                               :value="connecting_cable.id"
                                                               @click="connectingCableDeselectIfSelected(connecting_cable.id)">
                                                        <label class="custom-control-label btn btn-dark" :for="'module-name-' + connecting_cable.id" :class="{ 'active': luminaireLineFormFields.type_of_connecting_cable === connecting_cable.id}">
                                                            <img :src="asset('productimages/' + connecting_cable.picture_file_name)" :alt="connecting_cable.title" class="img-fluid" v-if="connecting_cable.picture_file_name">
                                                            <p class="text-white pt-3">{{ $t(connecting_cable.title) }} <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t(connecting_cable.tooltip)" v-if="connecting_cable.tooltip"></i><br>
                                                                <span class="small" v-if="$can('view_prices') && connecting_cable.price">€ {{ ((connecting_cable.price * luminaireLineFormFields.number_of_electrical_feeds_start) + (connecting_cable.price * luminaireLineFormFields.number_of_electrical_feeds_end) + (connecting_cable.price * luminaireLineFormFields.number_of_electrical_feeds_middle * (selectedSerie.includes('eco') ? 2 : 4))).toFixed(2) }}</span>
                                                            </p>
                                                        </label>
                                                    </div>
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Accordion card -->

                            <!-- SUSPENSIONS -->
                            <!-- Accordion cards for Selection Steps -->
                            <div class="card ltt-steps">
                                <!-- Card header -->
                                <card-header href="ltt-step-suspensions" id="heading-suspensions">
                                    <span>{{ $t('Suspension') }} <i class="fas fa-check-circle text-primary" v-if="mountingValid"></i></span>
                                </card-header>
                                <!-- Card body -->
                                <div id="ltt-step-suspensions" class="collapse" role="tabpanel" aria-labelledby="heading-ltt-step-suspensions" data-parent="#ltt-accordion">
                                    <div class="card-body px-0 py-3">
                                        <!-- SELECT MOUNTING TYPE -->
                                        <div class="container-fluid px-0 mx-0 mb-5">
                                            <div class="row">
                                                <div class="col-6 col-md-4 form-group">
                                                    <div class="custom-control custom-radio image-checkbox text-left">
                                                        <input type="radio" class="custom-control-input"
                                                               name="mounting_adapter_yes"
                                                               id="mounting_adapter_yes"
                                                               v-model.number="mountingAdapterYesOrNo"
                                                               value="mounting_adapter_yes">
                                                        <label class="custom-control-label btn btn-dark" :class="{ 'active': mountingAdapterYesOrNo === 'mounting_adapter_yes'}" for="mounting_adapter_yes">
                                                            <img :src="asset('img/luminaire-selection-tool/montageadapter-ja.png')" :alt="$t('Mounting adapter')" class="img-fluid pb-3">
                                                            <p class="text-white">
                                                                {{ $t('Installation with') }} {{ luminaireLineFormFields.number_of_mounting_rails_total + 1 + luminaireLineFormFields.number_of_mounting_rail_504 }} {{ $t('mounting adapters') }} <span class="small">({{ $t('Default') }})</span> <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t('for deviating mounting points, e.g. for retrofitting')"></i>
                                                                <br><span class="small" v-if="$can('view_prices')">€ {{ luminaireLineProducts.mounting_adapters && luminaireLineProducts.mounting_adapters[0] ? luminaireLineProducts.mounting_adapters[0].price : '' }} / {{ $t('pcs.') }}</span>
                                                            </p>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="col-6 col-md-4 form-group">
                                                    <div class="custom-control custom-radio image-checkbox text-left">
                                                        <input type="radio" class="custom-control-input"
                                                               name="mounting_adapter_no"
                                                               id="mounting_adapter_no"
                                                               v-model.number="mountingAdapterYesOrNo"
                                                               value="mounting_adapter_no">
                                                        <label class="custom-control-label btn btn-dark" :class="{ 'active': mountingAdapterYesOrNo === 'mounting_adapter_no'}" for="mounting_adapter_no">
                                                            <img :src="asset('img/luminaire-selection-tool/montageadapter-nein.png')" :alt="$t('No mounting adapter')" class="img-fluid pb-3">
                                                            <p class="text-white">{{ $t('Installation with included mounting rail connector') }} <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t('The rope suspensions are attached to the connecting piece between the mounting rails')"></i></p>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="col-6 col-md-4 form-group" v-if="luminaireLineProducts.ceiling_mounts && luminaireLineProducts.ceiling_mounts[0]">
                                                    <div class="custom-control custom-radio image-checkbox text-left">
                                                        <input type="radio" class="custom-control-input"
                                                               name="mounting_adapter_ceiling"
                                                               id="mounting_adapter_ceiling"
                                                               v-model.number="mountingAdapterYesOrNo"
                                                               value="mounting_adapter_ceiling">
                                                        <label class="custom-control-label btn btn-dark" :class="{ 'active': mountingAdapterYesOrNo === 'mounting_adapter_ceiling'}" for="mounting_adapter_ceiling">
                                                            <img :src="asset('productimages/' + ( $i18n.locale === 'en' && luminaireLineProducts.ceiling_mounts[0].picture_file_name_en ? luminaireLineProducts.ceiling_mounts[0].picture_file_name_en : luminaireLineProducts.ceiling_mounts[0].picture_file_name))" :alt="$t('Ceiling mount')" class="img-fluid pb-3">
                                                            <p class="text-white">
                                                                {{ $t('Installation with') }} {{ luminaireLineFormFields.number_of_mounting_rails_total + 1 }} {{ $t('ceiling mounts') }}
                                                                <br><span class="small" v-if="$can('view_prices')">€ {{ luminaireLineProducts.ceiling_mounts && luminaireLineProducts.ceiling_mounts[0] ? luminaireLineProducts.ceiling_mounts[0].price : '' }} / {{ $t('pcs.') }}</span>
                                                            </p>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- SELECT SUSPENSION -->
                                        <div class="container-fluid px-0 text-white" v-if="mountingAdapterYesOrNo !== 'mounting_adapter_ceiling'">
                                            <h4 class="text-white">{{ $t('Choose suspension') }}</h4>
                                            <p class="text-light">{{ $t('The rope suspensions are attached to the connecting piece between the mounting rails') }}: {{ luminaireLineFormFields.number_of_suspensions  }}</p>
                                            <ValidationProvider :name="$t('Type of rope suspension')"
                                                                rules="numeric"
                                                                tag="div"
                                                                class="row"
                                                                v-slot="{ errors }">
                                                <div class="col-6 col-md-4 form-group" v-for="suspension in luminaireLineProducts.suspensions">
                                                    <div class="custom-control custom-radio image-checkbox text-left">
                                                        <input type="radio" class="custom-control-input"
                                                               :name="'module-name-' + suspension.id"
                                                               :id="'module-name-' + suspension.id"
                                                               v-model.number="luminaireLineFormFields.type_of_suspensions"
                                                               :value="suspension.id">
                                                        <label class="custom-control-label btn btn-dark" :for="'module-name-' + suspension.id" :class="{ 'active': luminaireLineFormFields.type_of_suspensions === suspension.id}">
                                                            <img :src="asset('productimages/' + ($i18n.locale === 'en' && suspension.picture_file_name_en ? suspension.picture_file_name_en : suspension.picture_file_name))" :alt="suspension.title" class="img-fluid pb-3" v-if="suspension.picture_file_name">
                                                            <p class="text-white">{{ $t(suspension.title) }}<br><span class="small" v-if="$can('view_prices')">€ {{ suspension.price }} / {{ $t('pcs.') }}</span></p>
                                                        </label>
                                                    </div>
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>

                                            <ValidationProvider :name="$t('Additional suspensions')"
                                                                rules="numeric|min_value:0"
                                                                tag="div"
                                                                class="row"
                                                                v-slot="{ errors }">
                                                <div class="form-group col-sm-12 mb-3">
                                                    <h5 class="text-white">{{ $t('Add additional suspensions') }}</h5>
                                                    <input v-model.number="luminaireLineFormFields.number_of_additional_suspensions" name="number_of_additional_suspensions" type="number" class="form-control w-50" :placeholder="$t('Number of additional suspensions incl. mounting adapters')">
                                                    <div class="alert alert-danger text-right" v-if="luminaireLineFormErrors && luminaireLineFormErrors.number_of_additional_suspensions">
                                                        {{ luminaireLineFormErrors.number_of_additional_suspensions[0] }}
                                                    </div>
                                                    <div class="text-danger text-right">{{ errors[0] }}</div>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Accordion card -->

                            <!-- ZUBEHOER -->
                            <div class="card ltt-steps">
                                <!-- Card header -->
                                <card-header href="ltt-step-product-addons" id="heading-luminaire-line-product-addons">
                                    <span>{{ $t('Optional accessories') }} <i class="fas fa-times-circle text-danger" v-if="!productAddonsValid"></i><i class="fas fa-check-circle text-primary" v-else-if="(productAddonsValid && anyProductAddonSelected) || !anyProductAddonSelected"></i></span>
                                </card-header>
                                <!-- Card body -->
                                <div id="ltt-step-product-addons" class="collapse" role="tabpanel" aria-labelledby="heading-ltt-step-product-addons" data-parent="#ltt-accordion">
                                    <div class="card-body px-0 py-3">

                                        <!-- STEUERUNG LITE (only with DALI & CLO) -->
                                        <div class="container-fluid px-0 text-white"
                                             v-if="(lstForm.led_module_control_id && lstForm.led_module_control_id !== 27)
                                                || (!lstForm.led_module_control_id && planningFormFields.led_module_control_id && planningFormFields.led_module_control_id !== 27)
                                                || product_configurator_id === 3">
                                            <div class="row">
                                                <div class="col">
                                                    <h4 class="text-white pt-3">{{ $t('Control lite') }} <i class="fas fa-check-circle text-primary small" v-if="luminaireControlLiteValid"></i><i class="fas fa-times-circle text-danger small" v-else></i></h4>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-3 col-md-4">
                                                    <!-- STANDALONE TYPE OF SENSOR SYSTEM -->
                                                    <div v-if="luminaireLineProducts.luminaire_controls && (luminaireLineProducts.luminaire_controls.filter(el => el.product_subtype !== 'presence_detector_slave') || luminaireLineProducts.luminaire_controls.filter(el => el.product_subtype !== 'presence_detector'))">
                                                        <div class="llt-luminaire-control form-group">
                                                            <div class="custom-control custom-radio image-checkbox text-left">
                                                                <input type="radio" class="custom-control-input"
                                                                       name="standalone_sensor_yes"
                                                                       id="standalone_sensor_yes"
                                                                       v-model.number="standAloneSensorYesOrNo"
                                                                       value="true"
                                                                       @click="standAloneSensorDeselectIfSelected(standAloneSensorYesOrNo)" >
                                                                <label class="custom-control-label btn btn-dark" :class="{ 'active': standAloneSensorYesOrNo}" for="standalone_sensor_yes">
                                                                    <img :src="asset('img/luminaire-selection-tool/standalone-sensorsystem.png')" :alt="$t('Standalone SensorSystem')" class="img-fluid">
                                                                    <span class="text-white pt-3">{{ $t('SensorSystem') }} <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t('Sensors installed in separate 14cm mounting rail. The sensor system can be combined with the Integrated System')"/><br>
                                                                    <span class="small" v-if="$can('view_prices') && luminaireLineProducts.luminaire_controls && luminaireLineProducts.luminaire_controls.find(el => el.product_type === 'luminaire_control' && el.product_subtype === 'presence_detector')">{{ $t('from') }} € {{ luminaireLineProducts.luminaire_controls.find(el => el.product_type === 'luminaire_control' && el.product_subtype === 'presence_detector_slave').price.toFixed(2) }}</span></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- STANDALONE NUMBER OF MASTERS -->
                                                    <div v-if="standAloneSensorYesOrNo">
                                                        <ValidationProvider :name="$t('Quantity of standalone SensorSystem')"
                                                                            :rules="`numeric|min_value:0${luminaireLineFormFields.number_of_luminaire_control_submodules < 1 ? '|max_value:1' : '|max_value:0'}`"
                                                                            tag="div"
                                                                            class="form-group form-group"
                                                                            v-slot="{ errors }"
                                                        >
                                                            <div class="custom-control custom-radio image-checkbox text-left">
                                                                <h5 class="text-white">{{ $t('Quantity (MASTER)') }} <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t('Master only works without external lighting control (standalone control)')"/></h5>
                                                                <input v-model.number="luminaireLineFormFields.number_of_luminaire_controls"
                                                                       :name="'number_of_luminaire_controls_standalone_sensorsystem' + luminaireLineFormFields.type_of_luminaire_control"
                                                                       type="number"
                                                                       class="form-control"
                                                                       :placeholder="$t('Number')"
                                                                       min="0"
                                                                       @input="checkAndAutoCorrectLuminaireControlNumbers('number_of_luminaire_controls')"
                                                                       :max="sensorSystemMasterCount < 1 ? 1 : 0" >
                                                                <div class="alert alert-danger" v-if="luminaireLineFormErrors && luminaireLineFormErrors.number_of_luminaire_controls">
                                                                    {{ luminaireLineFormErrors.number_of_luminaire_controls[0] }}
                                                                </div>
                                                                <div class="text-danger">{{ errors[0] }}</div>
                                                            </div>
                                                        </ValidationProvider>

                                                        <!-- STANDALONE SENSOR SYSTEM SLAVES -->
                                                        <ValidationProvider :name="$t('Quantity of motion detector SLAVES')"
                                                                            :rules="`numeric|min_value:0|max_value:${availableSlavesCount + luminaireLineFormFields.number_of_luminaire_control_slaves}`"
                                                                            tag="div"
                                                                            class="form-group form-group"
                                                                            v-slot="{ errors }">
                                                            <div class="custom-control custom-radio image-checkbox text-left">
                                                                <h5 class="text-white">{{ $t('Quantity (SLAVES)') }} <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t('Can be realised with slaves (even without a master). Prerequisite for operation is an external lighting control system')"/></h5>
                                                                <input v-model.number="luminaireLineFormFields.number_of_luminaire_control_slaves"
                                                                       :name="'number_of_luminaire_control_slaves_' + luminaireLineFormFields.type_of_luminaire_control_slave"
                                                                       type="number"
                                                                       class="form-control"
                                                                       :placeholder="$t('Number')"
                                                                       min="0"
                                                                       @input="checkAndAutoCorrectLuminaireControlNumbers('number_of_luminaire_control_slaves')"
                                                                       :max="availableSlavesCount + luminaireLineFormFields.number_of_luminaire_control_slaves" >
                                                                <div class="alert alert-danger" v-if="luminaireLineFormErrors && luminaireLineFormErrors.number_of_luminaire_control_slaves">
                                                                    {{ luminaireLineFormErrors.number_of_luminaire_control_slaves[0] }}
                                                                </div>
                                                                <div class="text-danger">{{ errors[0] }}</div>
                                                                <div class="text-white" v-if="availableSlavesCount < 100">{{ $t('Available modules') }}: {{ availableSlavesCount }}</div>
                                                            </div>
                                                        </ValidationProvider>
                                                    </div>
                                                </div>
                                                <!-- TYPE OF INTEGRATED SENSORSYSTEM -->
                                                <div class="col-3 col-md-4" v-if="luminaireLineFormFields.number_of_blind_modules > 0">
                                                    <div v-if="luminaireLineProducts.luminaire_control_submodules && luminaireLineProducts.luminaire_control_submodules.length > 0">
                                                        <div class="llt-luminaire-control form-group">
                                                            <div class="custom-control custom-radio image-checkbox text-left">
                                                                <input type="radio" class="custom-control-input"
                                                                       name="integrated_sensor_yes"
                                                                       id="integrated_sensor_yes"
                                                                       v-model.number="integratedSensorYesOrNo"
                                                                       value="true"
                                                                       @click="integratedSensorDeselectIfSelected(integratedSensorYesOrNo)" >
                                                                <label class="custom-control-label btn btn-dark" :class="{ 'active': integratedSensorYesOrNo}" for="integrated_sensor_yes">
                                                                    <img :src="asset('img/luminaire-selection-tool/sensorsystem.png')" :alt="$t('Integrated SensorSystem')" class="img-fluid">
                                                                    <span class="text-white pt-3">{{ $t('Integrated SensorSystem') }} <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t('Sensors installed in mounting rail (blinde module). Integrated system can be combined with the sensor system')"/></span>
                                                                    <span class="small" v-if="$can('view_prices') && luminaireLineProducts.luminaire_controls && luminaireLineProducts.luminaire_controls.find(el => el.product_type === 'luminaire_control' && el.product_subtype === 'presence_detector')">{{ $t('from') }} € {{ luminaireLineProducts.luminaire_controls.find(el => el.product_type === 'luminaire_control' && el.product_subtype === 'presence_detector_slave').price.toFixed(2) }}</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="integratedSensorYesOrNo">
                                                        <ValidationProvider :name="$t('Quantity of integrated motion detector MASTERS')"
                                                                            :rules="`numeric|min_value:0|max_value:${luminaireLineFormFields.number_of_luminaire_control_submodules > 0 && luminaireLineFormFields.number_of_luminaire_controls === 0 ? 1 : 0}`"
                                                                            tag="div"
                                                                            class="form-group form-group"
                                                                            v-slot="{ errors }">
                                                            <div class="custom-control custom-radio image-checkbox text-left">
                                                                <h5 class="text-white">{{ $t('Quantity (MASTER)') }} <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t('Master only works without external lighting control (standalone control)')"/></h5>
                                                                <input v-model.number="luminaireLineFormFields.number_of_luminaire_control_submodules"
                                                                       :name="'number_of_luminaire_control_submodule_' + luminaireLineFormFields.type_of_luminaire_control_submodule"
                                                                       type="number"
                                                                       class="form-control"
                                                                       :placeholder="$t('Number')"
                                                                       min="0"
                                                                       @input="checkAndAutoCorrectLuminaireControlNumbers('number_of_luminaire_control_submodules')"
                                                                       max="1" >
                                                                <div class="alert alert-danger" v-if="luminaireLineFormErrors && luminaireLineFormErrors.number_of_luminaire_control_submodules">
                                                                    {{ luminaireLineFormErrors.number_of_luminaire_control_submodules[0] }}
                                                                </div>
                                                                <div class="text-danger">{{ errors[0] }}</div>
                                                            </div>
                                                        </ValidationProvider>

                                                        <ValidationProvider :name="$t('Quantity of integrated motion detector SLAVES')"
                                                                            :rules="`numeric|min_value:${sensorSystemMasterCount > 0 ? 0 : 1}|max_value:${availableIntegratedSlavesCount + luminaireLineFormFields.number_of_luminaire_control_submodule_slaves}`"
                                                                            tag="div"
                                                                            class="form-group form-group"
                                                                            v-slot="{ errors }">
                                                            <div class="custom-control custom-radio image-checkbox text-left">
                                                                <h5 class="text-white">{{ $t('Quantity (SLAVES)') }} <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t('Can be realised with slaves (even without a master). Prerequisite for operation is an external lighting control system')"/></h5>
                                                                <input v-model.number="luminaireLineFormFields.number_of_luminaire_control_submodule_slaves"
                                                                       :name="'number_of_luminaire_control_submodule_slave_' + luminaireLineFormFields.type_of_luminaire_control_submodule_slave"
                                                                       type="number"
                                                                       class="form-control"
                                                                       :placeholder="$t('Number')"
                                                                       :min="sensorSystemMasterCount > 0 ? 0 : 1"
                                                                       @input="checkAndAutoCorrectLuminaireControlNumbers('number_of_luminaire_control_submodule_slaves')"
                                                                       :max="availableIntegratedSlavesCount + luminaireLineFormFields.number_of_luminaire_control_submodule_slaves" >
                                                                <div class="alert alert-danger" v-if="luminaireLineFormErrors && luminaireLineFormErrors.number_of_luminaire_control_submodule_slaves">
                                                                    {{ luminaireLineFormErrors.number_of_luminaire_control_submodule_slaves[0] }}
                                                                </div>
                                                                <div class="text-danger">{{ errors[0] }}</div>
                                                            </div>
                                                        </ValidationProvider>
                                                        <span>{{ $t('Available modules') }}: {{ availableIntegratedSlavesCount }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- STEUERUNG: NEDAP / CASAMBI / ENLIGHTED (only with DALI & CLO) -->
                                        <div class="container-fluid px-0 text-white"
                                             v-if="(lstForm.led_module_control_id && lstForm.led_module_control_id !== 27)
                                            || (!lstForm.led_module_control_id && planningFormFields.led_module_control_id && planningFormFields.led_module_control_id !== 27)
                                            || product_configurator_id === 3">
                                            <div class="row">
                                                <div class="col">
                                                    <h4 class="text-white pt-3">{{ $t('Control pro') }} <i class="fas fa-check-circle text-primary small" v-if="luminaireControlProValid"></i><i class="fas fa-times-circle text-danger small" v-else></i></h4>
                                                </div>
                                            </div>
                                            <ValidationProvider :name="$t('Control pro')" v-if="luminaireLineProducts.luminaire_controls && luminaireLineProducts.luminaire_controls.filter(el => el.product_subtype !== 'presence_detector_slave' && el.product_subtype !== 'presence_detector').length > 0"
                                                                    rules="numeric"
                                                                    tag="div"
                                                                    class="row"
                                                                    v-slot="{ errors }">
                                                    <div class="llt-luminaire-control col-6 col-md-4 form-group" v-for="luminaire_control in luminaireLineProducts.luminaire_controls.filter(el => el.product_subtype !== 'presence_detector_slave' && el.product_subtype !== 'presence_detector')">

                                                        <div class="custom-control custom-radio image-checkbox text-left">
                                                            <input type="radio" class="custom-control-input"
                                                                   :name="'module-name-' + luminaire_control.id"
                                                                   :id="'module-name-' + luminaire_control.id"
                                                                   v-model.number="luminaireLineFormFields.type_of_luminaire_control"
                                                                   :value="luminaire_control.id"
                                                                   @click="luminaireControlDeselectIfSelected(luminaire_control.id)">
                                                            <label class="custom-control-label btn btn-dark text-break" :for="'module-name-' + luminaire_control.id" :class="{ 'active': luminaireLineFormFields.type_of_luminaire_control === luminaire_control.id}">
                                                                <img :src="asset('productimages/' + ($i18n.locale === 'en' && luminaire_control.picture_file_name_en ? luminaire_control.picture_file_name_en : luminaire_control.picture_file_name))" :alt="$t(luminaire_control.title)" class="img-fluid" v-if="luminaire_control.picture_file_name">
                                                                <span class="text-white pt-3">{{ !luminaire_control.title.includes('Motion detector system MASTER') ? $t(luminaire_control.title) : $t('Motion detector system') }} <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t(luminaire_control.tooltip)" v-if="luminaire_control.tooltip"></i><br>
                                                                    <span class="small" v-if="$can('view_prices') && luminaire_control.price && luminaire_control.product_subtype === 'casambi_10'">€ {{ product_configurator_id === 1 ? ((Math.ceil((luminaireLineFormFields.number_of_led_modules / 10))) * luminaire_control.price).toFixed(2) : luminaire_control.price.toFixed(2) + $t(' / pcs.') }}</span>
                                                                    <span class="small" v-if="$can('view_prices') && luminaire_control.price && luminaire_control.product_subtype === 'casambi_60'">€ {{ product_configurator_id === 1 ? ((Math.ceil((luminaireLineFormFields.number_of_led_modules / 60))) * luminaire_control.price).toFixed(2) : luminaire_control.price.toFixed(2) + $t(' / pcs.') }}</span>
                                                                    <span class="small" v-if="$can('view_prices') && luminaire_control.price && luminaire_control.product_subtype === 'nedap'">€ {{ (getTotalQuantityOfMountingRails() * luminaire_control.price).toFixed(2) + $t(' / pcs.') }}</span>
                                                                    <span class="small" v-if="$can('view_prices') && luminaire_control.price && luminaire_control.product_subtype === 'enlighted'">€ {{ (getTotalQuantityOfMountingRails() * luminaire_control.price).toFixed(2) }}</span>
                                                                </span>
                                                            </label>
                                                        </div>
                                                        <span class="text-danger">{{ errors[0] }}</span>
                                                </div>

                                            </ValidationProvider>
                                        </div>

                                        <!-- Elektrisches Zubehör -->
                                        <div class="container-fluid px-0 text-white">
                                            <div class="row">
                                                <div class="col">
                                                    <h4 class="text-white pt-3">{{ $t('Electrical accessories') }} <i class="fas fa-check-circle text-primary small" v-if="connectingCableMiddleValid"></i><i class="fas fa-times-circle text-danger small" v-else></i></h4>
                                                </div>
                                            </div>
                                            <ValidationProvider :name="$t('Connecting cable')"
                                                                rules="numeric"
                                                                tag="div"
                                                                class="row"
                                                                v-slot="{ errors }">
                                                <div class="llt-electrical-addons col-6 col-md-4 form-group" v-for="connecting_cable_middle in luminaireLineProducts.connecting_cable_middle">
                                                    <div class="custom-control custom-radio image-checkbox text-left">
                                                        <input type="radio" class="custom-control-input"
                                                               :name="'connecting-cable-' + connecting_cable_middle.id"
                                                               :id="'connecting-cable-' + connecting_cable_middle.id"
                                                               v-model.number="luminaireLineFormFields.type_of_connecting_cable_middle"
                                                               :value="connecting_cable_middle.id"
                                                               @click="connectingCableMiddleDeselectIfSelected(connecting_cable_middle.id)">
                                                        <label class="custom-control-label btn btn-dark" :for="'connecting-cable-' + connecting_cable_middle.id" :class="{ 'active': luminaireLineFormFields.type_of_connecting_cable_middle === connecting_cable_middle.id}">
                                                            <img :src="asset('productimages/' + ($i18n.locale === 'en' && connecting_cable_middle.picture_file_name_en ? connecting_cable_middle.picture_file_name_en : connecting_cable_middle.picture_file_name))" :alt="$t(connecting_cable_middle.title)" class="img-fluid" v-if="connecting_cable_middle.picture_file_name">
                                                            <p class="text-white pt-3">{{ $t(connecting_cable_middle.title) }} <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t(connecting_cable_middle.tooltip)" v-if="connecting_cable_middle.tooltip"></i><br>
                                                                <span class="small" v-if="$can('view_prices') && connecting_cable_middle.price">€ {{ connecting_cable_middle.price }} / {{ $t('pcs.')}}</span>
                                                            </p>
                                                        </label>
                                                    </div>
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                            <div class="row" v-show="luminaireLineFormFields.type_of_connecting_cable_middle">
                                                <div class="col-6 col-md-4 form-group form-group">
                                                    <div class="custom-control custom-radio image-checkbox text-left">
                                                        <h5 class="text-white">{{ $t('Quantity connecting cables') }} <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t('The RayLine Max needs 2 connecting cables for each connecting point.')" v-show="selectedSerie.includes('max')"></i></h5>
                                                        <ValidationProvider :name="$t('Quantity connecting cables')"
                                                                            :rules="`numeric|min_value:${selectedSerie.includes('max') ? 2 : 1}`"
                                                                            tag="div"
                                                                            v-slot="{ errors }" v-if="luminaireLineFormFields.type_of_connecting_cable_middle">
                                                            <input v-model.number="luminaireLineFormFields.number_of_connecting_cable_middle"
                                                                   :name="'number_of_connecting_cable_middle_' + luminaireLineFormFields.type_of_connecting_cable_middle"
                                                                   type="number"
                                                                   class="form-control"
                                                                   :placeholder="$t('Number')"
                                                                   min="0"
                                                                   @blur="fixNumberConnectingCableMiddle" >
                                                            <div class="alert alert-danger" v-if="luminaireLineFormErrors && luminaireLineFormErrors.number_of_connecting_cable_middle">
                                                                {{ luminaireLineFormErrors.number_of_connecting_cable_middle[0] }}
                                                            </div>
                                                            <div class="text-danger">{{ errors[0] }}</div>


                                                        </ValidationProvider>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- KABELTRASSE -->
                                        <div class="container-fluid px-0 mx-0 mb-5" v-if="false">
                                            <h4 class="text-white pt-3">{{ $t('Cable route') }} <i class="fas fa-check-circle text-primary small" v-if="cableRoutesValid"></i></h4>
                                            <div class="row">
                                                <div class="col-6 col-md-4 form-group llt-cable-routes">
                                                    <div class="custom-control custom-radio image-checkbox text-left">
                                                        <input type="radio" class="custom-control-input"
                                                                name="cable_route_yes"
                                                                id="cable_route_yes"
                                                                v-model.number="cableRouteYesOrNo"
                                                                value="true"
                                                                @click="cableRouteDeselectIfSelected(cableRouteYesOrNo)" >
                                                        <label class="custom-control-label btn btn-dark" :class="{ 'active': cableRouteYesOrNo}" for="cable_route_yes">
                                                            <img :src="asset('img/luminaire-selection-tool/rayline-v2-kabeltrasse.png')" :alt="$t('Cable route')" class="img-fluid pb-3">
                                                            <p class="text-white">{{ $t('Cable route for entire lighting line') }}</p>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="col-sm-8 form-group" v-if="luminaireLineFormFields.number_of_cable_routes_504 + luminaireLineFormFields.number_of_cable_routes_336 + luminaireLineFormFields.number_of_cable_routes_68 > 0">
                                                    <h5 class="text-white">{{ $t('Details') }}:</h5>
                                                    <p>
                                                        <strong>{{ $t('Cable route 5.04 m') }}:</strong> {{ luminaireLineFormFields.number_of_cable_routes_504 }}<br>
                                                        <strong>{{ $t('Cable route 3.36 m') }}Kabeltrasse 3,36 m:</strong> {{ luminaireLineFormFields.number_of_cable_routes_336 }}<br>
                                                        <strong>{{ $t('Cable route 1.68 m') }}Kabeltrasse 1,68 m:</strong> {{ luminaireLineFormFields.number_of_cable_routes_168 }}
                                                    </p>
                                                    <p v-if="$can('view_prices')">{{ $t('Price') }}: </p>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- UNIVERSALADAPTER -->
                                        <div class="container-fluid px-0 text-white" v-if="luminaireLineProducts.universal_adapters && luminaireLineProducts.universal_adapters.length > 0">
                                            <div class="row">
                                                <div class="col">
                                                    <h4 class="text-white">{{ $t('Universal adapter') }} <i class="fas fa-check-circle text-primary small" v-if="universalAdapterValid"></i><i class="fas fa-times-circle text-danger small" v-else></i></h4>
                                                </div>
                                            </div>
                                            <div class="row" v-if="luminaireLineProducts.universal_adapters && luminaireLineProducts.universal_adapters.length > 0">
                                                <!-- UNIVERSALADAPTER GROSS -->
                                                <div class="col-6 col-md-4 form-group">
                                                    <ValidationProvider :name="$t('Universal adapter large')"
                                                                        rules="numeric"
                                                                        tag="div"
                                                                        class="custom-control custom-radio image-checkbox text-left"
                                                                        v-slot="{ errors }">
                                                        <input type="radio" class="custom-control-input"
                                                               name="module-name-universal_adapters_lg"
                                                               :id="'module-name-' + luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_lg').id"
                                                               v-model.number="luminaireLineFormFields.type_of_universal_adapters_lg"
                                                               :value="luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_lg').id"
                                                               @click="universalAdapterDeselectIfSelected(luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_lg').id)">
                                                        <label class="custom-control-label btn btn-dark" :for="'module-name-' + luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_lg').id" :class="{ 'active': luminaireLineFormFields.type_of_universal_adapters_lg }">
                                                            <img :src="asset('productimages/' + ($i18n.locale === 'en' && luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_lg').picture_file_name_en ? luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_lg').picture_file_name_en : luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_lg').picture_file_name))" :alt="$t(luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_lg').title)" class="img-fluid" v-if="luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_lg').picture_file_name">
                                                            <p class="text-white pt-3">{{ $t(luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_lg').title) }} <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t(luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_lg').tooltip)" v-if="luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_lg').tooltip"></i><br><span class="small" v-if="$can('view_prices')">€ {{ luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_lg').price }} / {{ $t('pcs.') }}</span> <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t(luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_lg').tooltip)" v-if="luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_lg').tooltip"></i></p>
                                                        </label>
                                                        <span class="text-danger">{{ errors[0] }}</span>
                                                    </ValidationProvider>
                                                    <ValidationProvider :name="$t('Quantity') + ' ' + $t(luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_lg').title)"
                                                                        rules="numeric|min_value:1"
                                                                        tag="div"
                                                                        class="custom-control custom-radio image-checkbox text-left"
                                                                        v-slot="{ errors }"
                                                                        v-if="luminaireLineFormFields.type_of_universal_adapters_lg" >
                                                        <div class="form-group">
                                                            <h5 class="text-white">{{ $t('Quantity') }}</h5>
                                                            <input v-model.number="luminaireLineFormFields.number_of_universal_adapters_lg" :name="'numbers_of_universal_adapters_' + luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_lg').id" type="number" class="form-control" :placeholder="$t('Quantity')">
                                                            <div class="alert alert-danger" v-if="luminaireLineFormErrors && luminaireLineFormErrors.number_of_universal_adapters_lg">
                                                                {{ luminaireLineFormErrors.number_of_universal_adapters_lg[0] }}
                                                            </div>
                                                            <div class="text-danger">{{ errors[0] }}</div>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                                <!-- UNIVERSALADAPTER KLEIN -->
                                                <div class="col-6 col-md-4 form-group">
                                                    <ValidationProvider :name="$t('Universal adapter small')"
                                                                        rules="numeric"
                                                                        tag="div"
                                                                        class="custom-control custom-radio image-checkbox text-left"
                                                                        v-slot="{ errors }">
                                                        <input type="radio" class="custom-control-input"
                                                               name="module-name-universal_adapters_sm"
                                                               :id="'module-name-' + luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_sm').id"
                                                               v-model.number="luminaireLineFormFields.type_of_universal_adapters_sm"
                                                               :value="luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_sm').id"
                                                               @click="universalAdapterDeselectIfSelected(luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_sm').id)">
                                                        <label class="custom-control-label btn btn-dark" :for="'module-name-' + luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_sm').id" :class="{ 'active': luminaireLineFormFields.type_of_universal_adapters_sm }">
                                                            <img :src="asset('productimages/' + ( $i18n.locale === 'en' && luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_sm').picture_file_name_en ? luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_sm').picture_file_name_en : luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_sm').picture_file_name))" :alt="$t(luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_sm').title)" class="img-fluid" v-if="luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_sm').picture_file_name">
                                                            <p class="text-white pt-3">{{ $t(luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_sm').title) }} <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t(luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_sm').tooltip)" v-if="luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_sm').tooltip"></i><br><span class="small" v-if="$can('view_prices')">€ {{ luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_sm').price }} / {{ $t('pcs.') }}</span> <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t(luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_sm').tooltip)" v-if="luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_sm').tooltip"></i></p>
                                                        </label>
                                                        <span class="text-danger">{{ errors[0] }}</span>
                                                    </ValidationProvider>
                                                    <ValidationProvider :name="$t('Quantity') + ' ' + $t(luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_sm').title)"
                                                                        rules="numeric|min_value:1"
                                                                        tag="div"
                                                                        class="custom-control custom-radio image-checkbox text-left"
                                                                        v-slot="{ errors }"
                                                                        v-if="luminaireLineFormFields.type_of_universal_adapters_sm" >
                                                        <div class="form-group">
                                                            <h5 class="text-white">{{ $t('Quantity') }}</h5>
                                                            <input v-model.number="luminaireLineFormFields.number_of_universal_adapters_sm" :name="'numbers_of_universal_adapters_' + luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_sm').id" type="number" class="form-control" :placeholder="$t('Quantity')">
                                                            <div class="alert alert-danger" v-if="luminaireLineFormErrors && luminaireLineFormErrors.number_of_universal_adapters_sm">
                                                                {{ luminaireLineFormErrors.number_of_universal_adapters_sm[0] }}
                                                            </div>
                                                            <div class="text-danger">{{ errors[0] }}</div>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- UNIVERSALANSCHLUSS LITE -->
                                        <div class="container-fluid px-0 text-white" v-if="luminaireLineProducts.universal_connector_submodules && luminaireLineProducts.universal_connector_submodules.length > 0 && luminaireLineFormFields.number_of_blind_modules > 0">
                                            <div class="row">
                                                <div class="col">
                                                    <h4 class="text-white">{{ $t('Universal connector lite') }} <i class="fas fa-info-circle text-primary" style="font-size:0.8em" data-toggle="tooltip" :title="$t('Universal connector lite integrated in mounting rail (blind module)')"></i> <i class="fas fa-check-circle text-primary small" v-if="universalConnectorSubmoduleValid && universalConnectorSubmoduleValid_v2 && universalConnectorSubmoduleValid_v3"></i><i class="fas fa-times-circle text-danger small" v-else></i></h4>
                                                </div>
                                            </div>
                                            <div class="row" v-if="luminaireLineProducts.universal_connector_submodules && luminaireLineProducts.universal_connector_submodules.length > 0">
                                                <!-- UNIVERSALANSCHLUSS LITE V1 -->
                                                <div class="col-6 col-md-4 form-group" v-if="luminaireLineProducts.universal_connector_submodules && luminaireLineProducts.universal_connector_submodules.filter(product => product.product_subtype === 'universal_connector_5')">
                                                    <ValidationProvider :name="$t('Universal connector lite')"
                                                                        rules="numeric"
                                                                        tag="div"
                                                                        v-slot="{ errors }">
                                                        <div class="custom-control custom-radio image-checkbox text-left" v-for="universal_connector in luminaireLineProducts.universal_connector_submodules.filter(product => product.product_subtype === 'universal_connector_5')">
                                                            <input type="radio" class="custom-control-input"
                                                                   name="module-name-universal_connector_submodules"
                                                                   :id="'module-name-' + universal_connector.id"
                                                                   v-model.number="luminaireLineFormFields.type_of_universal_connector_submodules"
                                                                   :value="universal_connector.id"
                                                                   @click="universalConnectorSubmoduleDeselectIfSelected(universal_connector.id)" >
                                                            <label class="custom-control-label btn btn-dark" :for="'module-name-' + universal_connector.id" :class="{ 'active': luminaireLineFormFields.type_of_universal_connector_submodules }">
                                                                <img :src="asset('productimages/' + ( $i18n.locale === 'en' && universal_connector.picture_file_name_en ? universal_connector.picture_file_name_en : universal_connector.picture_file_name))" :alt="$t(universal_connector.title)" class="img-fluid" v-if="universal_connector.picture_file_name">
                                                                <p class="text-white pt-3">{{ $t(universal_connector.title) }} <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t(universal_connector.tooltip)" v-if="universal_connector.tooltip"></i><br><span class="small" v-if="$can('view_prices')">€ {{ universal_connector.price }} / {{ $t('pcs.') }}</span></p>
                                                            </label>
                                                        </div>
                                                        <span class="text-danger">{{ errors[0] }}</span>
                                                    </ValidationProvider>
                                                    <ValidationProvider :name="$t('Quantity') + ' ' + $t('universal connector lite')"
                                                                        :rules="`numeric|min_value:1|max_value:${availableBlindModulesCount + luminaireLineFormFields.number_of_universal_connector_submodules}`"
                                                                        tag="div"
                                                                        class="custom-control custom-radio image-checkbox text-left"
                                                                        v-slot="{ errors }"
                                                                        v-if="luminaireLineFormFields.type_of_universal_connector_submodules" >
                                                        <div class="form-group">
                                                            <h5 class="text-white">{{ $t('Quantity') }}</h5>
                                                            <input v-model.number="luminaireLineFormFields.number_of_universal_connector_submodules" name="number_of_universal_connector_submodules" type="number" class="form-control" :placeholder="$t('Quantity')">
                                                            <div class="alert alert-danger" v-if="luminaireLineFormErrors && luminaireLineFormErrors.number_of_universal_connector_submodules">
                                                                {{ luminaireLineFormErrors.number_of_universal_connector_submodules[0] }}
                                                            </div>
                                                            <div class="text-danger">{{ errors[0] }}</div>
                                                        </div>
                                                        <span>{{ $t('Max quantity') }}: {{ availableBlindModulesCount + luminaireLineFormFields.number_of_universal_connector_submodules }}</span>
                                                    </ValidationProvider>
                                                </div>
                                                <!-- UNIVERSALANSCHLUSS LITE V2 -->
                                                <div class="col-6 col-md-4 form-group" v-if="luminaireLineProducts.universal_connector_submodules && luminaireLineProducts.universal_connector_submodules.filter(product => product.product_subtype === 'universal_connector_5_v2')">
                                                    <ValidationProvider :name="$t('Universal connector V2 lite')"
                                                                        rules="numeric"
                                                                        tag="div"
                                                                        v-slot="{ errors }">
                                                        <div class="custom-control custom-radio image-checkbox text-left" v-for="universal_connector in luminaireLineProducts.universal_connector_submodules.filter(product => product.product_subtype === 'universal_connector_5_v2')">
                                                            <input type="radio" class="custom-control-input"
                                                                   name="module-name-universal_connector_submodules_v2"
                                                                   :id="'module-name-' + universal_connector.id"
                                                                   v-model.number="luminaireLineFormFields.type_of_universal_connector_submodules_v2"
                                                                   :value="universal_connector.id"
                                                                   @click="universalConnectorSubmoduleDeselectIfSelected(universal_connector.id)">
                                                            <label class="custom-control-label btn btn-dark" :for="'module-name-' + universal_connector.id" :class="{ 'active': luminaireLineFormFields.type_of_universal_connector_submodules_v2 }">
                                                                <img :src="asset('productimages/' + ( $i18n.locale === 'en' && universal_connector.picture_file_name_en ? universal_connector.picture_file_name_en : universal_connector.picture_file_name))" :alt="$t(universal_connector.title)" class="img-fluid" v-if="universal_connector.picture_file_name">
                                                                <p class="text-white pt-3">{{ $t(universal_connector.title) }} <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t(universal_connector.tooltip)" v-if="universal_connector.tooltip"></i><br><span class="small" v-if="$can('view_prices')">€ {{ universal_connector.price }} / {{ $t('pcs.') }}</span></p>
                                                            </label>
                                                        </div>
                                                        <span class="text-danger">{{ errors[0] }}</span>
                                                    </ValidationProvider>
                                                    <ValidationProvider :name="$t('Quantity') + ' ' + $t('universal connector V2 lite')"
                                                                        :rules="`numeric|min_value:1|max_value:${availableBlindModulesCount + luminaireLineFormFields.number_of_universal_connector_submodules_v2}`"
                                                                        tag="div"
                                                                        class="custom-control custom-radio image-checkbox text-left"
                                                                        v-slot="{ errors }"
                                                                        v-if="luminaireLineFormFields.type_of_universal_connector_submodules_v2" >
                                                        <div class="form-group">
                                                            <h5 class="text-white">{{ $t('Quantity') }}</h5>
                                                            <input v-model.number="luminaireLineFormFields.number_of_universal_connector_submodules_v2" name="number_of_universal_connector_submodules_v2" type="number" class="form-control" :placeholder="$t('Quantity')">
                                                            <div class="alert alert-danger" v-if="luminaireLineFormErrors && luminaireLineFormErrors.number_of_universal_connector_submodules_v2">
                                                                {{ luminaireLineFormErrors.number_of_universal_connector_submodules_v2[0] }}
                                                            </div>
                                                            <div class="text-danger">{{ errors[0] }}</div>
                                                        </div>
                                                        <span>{{ $t('Max quantity') }}: {{ availableBlindModulesCount + luminaireLineFormFields.number_of_universal_connector_submodules_v2 }}</span>
                                                    </ValidationProvider>
                                                </div>
                                                <!-- UNIVERSALANSCHLUSS LITE V3 -->
                                                <div class="col-6 col-md-4 form-group" v-if="luminaireLineProducts.universal_connector_submodules && luminaireLineProducts.universal_connector_submodules.filter(product => product.product_subtype === 'universal_connector_5_v3')">
                                                    <ValidationProvider :name="$t('Universal connector V3 lite')"
                                                                        rules="numeric"
                                                                        tag="div"
                                                                        v-slot="{ errors }">
                                                        <div class="custom-control custom-radio image-checkbox text-left" v-for="universal_connector in luminaireLineProducts.universal_connector_submodules.filter(product => product.product_subtype === 'universal_connector_5_v3')">
                                                            <input type="radio" class="custom-control-input"
                                                                   name="module-name-universal_connector_submodules_v3"
                                                                   :id="'module-name-' + universal_connector.id"
                                                                   v-model.number="luminaireLineFormFields.type_of_universal_connector_submodules_v3"
                                                                   :value="universal_connector.id"
                                                                   @click="universalConnectorSubmoduleDeselectIfSelected(universal_connector.id)" >
                                                            <label class="custom-control-label btn btn-dark" :for="'module-name-' + universal_connector.id" :class="{ 'active': luminaireLineFormFields.type_of_universal_connector_submodules_v3 }">
                                                                <img :src="asset('productimages/' + ( $i18n.locale === 'en' && universal_connector.picture_file_name_en ? universal_connector.picture_file_name_en : universal_connector.picture_file_name))" :alt="$t(universal_connector.title)" class="img-fluid" v-if="universal_connector.picture_file_name">
                                                                <p class="text-white pt-3">{{ $t(universal_connector.title) }} <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t(universal_connector.tooltip)" v-if="universal_connector.tooltip"></i><br><span class="small" v-if="$can('view_prices')">€ {{ universal_connector.price }} / {{ $t('pcs.') }}</span></p>
                                                            </label>
                                                        </div>
                                                        <span class="text-danger">{{ errors[0] }}</span>
                                                    </ValidationProvider>
                                                    <ValidationProvider :name="$t('Quantity') + ' ' + $t('universal connector V3 lite')"
                                                                        :rules="`numeric|min_value:1|max_value:${availableBlindModulesCount + luminaireLineFormFields.number_of_universal_connector_submodules_v3}`"
                                                                        tag="div"
                                                                        class="custom-control custom-radio image-checkbox text-left"
                                                                        v-slot="{ errors }"
                                                                        v-if="luminaireLineFormFields.type_of_universal_connector_submodules_v3" >
                                                        <div class="form-group">
                                                            <h5 class="text-white">{{ $t('Quantity') }}</h5>
                                                            <input v-model.number="luminaireLineFormFields.number_of_universal_connector_submodules_v3" name="number_of_universal_connector_submodules_v3" type="number" class="form-control" :placeholder="$t('Quantity')">
                                                            <div class="alert alert-danger" v-if="luminaireLineFormErrors && luminaireLineFormErrors.number_of_universal_connector_submodules_v3">
                                                                {{ luminaireLineFormErrors.number_of_universal_connector_submodules_v3[0] }}
                                                            </div>
                                                            <div class="text-danger">{{ errors[0] }}</div>
                                                        </div>
                                                        <span>{{ $t('Max quantity') }}: {{ availableBlindModulesCount + luminaireLineFormFields.number_of_universal_connector_submodules_v3 }}</span>
                                                    </ValidationProvider>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- SONDERPRODUKT -->
                                        <div class="container-fluid px-0 mt-3 text-white" v-if="luminaireLineFormFields.number_of_blind_modules > 0">
                                            <div class="row">
                                                <div class="col">
                                                    <h4 class="text-white">{{ $t('Integrated special products') }} <i class="fas fa-check-circle text-primary small" v-if="specialProductsValid"></i><i class="fas fa-times-circle text-danger small" v-else></i></h4>
                                                    <p class="text-light" v-if="luminaireLineFormFields.number_of_blind_modules > 0">
                                                        {{ $t('Special products must be requested with tempLED beforehand.') }}
                                                    </p>
                                                    <p class="text-light" v-if="luminaireLineFormFields.number_of_blind_modules > 0">
                                                        {{ $t('Available modules') }}: {{ availableBlindModulesCount }}
                                                    </p>
                                                </div>
                                            </div>

                                            <div class="container-fluid w-100 mb-3">
                                                <!-- loop through all special products with v-for -->
                                                <div v-for="(specialProduct, index) in luminaireLineFormFields.special_products" :key="index">
                                                            <div class="row electrical-feeds-row mb-2">
                                                                <!--  Anzahl -->
                                                                <ValidationProvider vid="specialProduct.quantity"
                                                                                    :name="$t('Quantity of special product')"
                                                                                    :rules="`required|numeric|min_value:1|max_value:${specialProduct.quantity + availableBlindModulesCount}`"
                                                                                    v-slot="{ errors }"
                                                                                    tag="div"
                                                                                    class="col-2 m-0 py-0 px-1">
                                                                    <div class="form-group m-0 p-0">
                                                                        <input
                                                                            v-model.number="specialProduct.quantity"
                                                                            name="specialProductQuantity"
                                                                            type="number"
                                                                            class="form-control w-100"
                                                                            :placeholder="$t('quantity')"
                                                                            :min="1"
                                                                            :max="specialProduct.quantity + availableBlindModulesCount">
                                                                        <p class="small text-light m-1">{{ $t('Quantity') }}</p>
                                                                        <div class="text-danger">{{ errors[0] }}</div>

                                                                    </div>
                                                                </ValidationProvider>
                                                                <!--  Artikelnummer -->
                                                                <ValidationProvider vid="specialProduct.sku"
                                                                                    :name="$t('SKU of Special Product')"
                                                                                    :rules="`required`"
                                                                                    v-slot="{ errors }"
                                                                                    tag="div"
                                                                                    class="col-4 m-0 py-0 px-1">
                                                                    <div class="form-group m-0 p-0">
                                                                        <input v-model="specialProduct.sku"
                                                                               type="text"
                                                                               name="specialProductSku"
                                                                               class="form-control w-100"
                                                                               :placeholder="$t('Sku')">
                                                                        <p class="small text-light m-1">{{ $t('Sku.') }}</p>
                                                                        <div class="text-danger">{{ errors[0] }}</div>

                                                                    </div>
                                                                </ValidationProvider>
                                                                <!--  Preis / Stk. -->
                                                                <ValidationProvider vid="specialProduct.price"
                                                                                    :name="$t('Price of Sepcial Product')"
                                                                                    :rules="`required|germanFloat|min_value:0`"
                                                                                    v-slot="{ errors }"
                                                                                    tag="div"
                                                                                    class="col-2 m-0 py-0 px-1">
                                                                    <div class="form-group m-0 p-0">
                                                                        <input v-model.number="specialProduct.price"
                                                                               name="specialProductPrice"
                                                                               type="number"
                                                                               class="form-control w-100"
                                                                               :placeholder="$t('price')">

                                                                        <p class="small text-light m-1">{{ $t('Price / pcs.') }}</p>
                                                                        <div class="text-danger">{{ errors[0] }}</div>

                                                                    </div>
                                                                </ValidationProvider>

                                                                <!-- Add button to remove this special product -->
                                                                <div class="col-2 m-0 py-0">
                                                                    <button type="button" class="btn btn-danger" @click="removeSpecialProduct(index)">{{ $t('Remove') }}</button>
                                                                </div>

                                                            </div>
                                                        </div>

                                                <div class="row" v-if="availableBlindModulesCount > 0">
                                                    <div class="col m-0 p-0">
                                                        <button type="button" class="btn btn-primary" @click="addSpecialProduct()">+ {{ $t('Add special product') }}</button>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <!-- WARRANTY -->
                                        <div class="container-fluid px-0 text-white" v-if="luminaireLineProducts.warranties">
                                            <h4 class="text-white">{{ $t('Warranty extension') }} <i class="fas fa-check-circle text-primary small"></i></h4>
                                            <ValidationProvider :name="$t('Warranty extension')"
                                                                rules="numeric"
                                                                tag="div"
                                                                class="row"
                                                                v-slot="{ errors }">
                                                <div class="col-6 col-md-4 form-group llt-emergency-light" v-for="warranty in luminaireLineProducts.warranties">
                                                    <div class="custom-control custom-radio image-checkbox text-left">
                                                        <input type="radio" class="custom-control-input"
                                                               :name="'module-name-' + warranty.id"
                                                               :id="'module-name-' + warranty.id"
                                                               v-model.number="luminaireLineFormFields.type_of_warranties"
                                                               :value="warranty.id"
                                                               @click="warrantyDeselectIfSelected(warranty.id)">
                                                        <label class="custom-control-label btn btn-dark" :for="'module-name-' + warranty.id" :class="{ 'active': luminaireLineFormFields.type_of_warranties === warranty.id}">
                                                            <img :src="asset('productimages/' + ( $i18n.locale === 'en' && warranty.picture_file_name_en ? warranty.picture_file_name_en : warranty.picture_file_name))" :alt="$t(warranty.title)" class="img-fluid" v-if="warranty.picture_file_name">
                                                            <p class="text-white pt-3">{{ $t(warranty.title) }} <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t(warranty.tooltip)" v-if="warranty.tooltip"></i><br><span class="small" v-if="$can('view_prices')">€ {{ getWarrantyPrice(calculatedPlanningPrice, warranty.price).toFixed(2) }}</span></p>
                                                        </label>
                                                    </div>
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Accordion card -->

                            <!-- ANMERKUNGEN & ZUSAMMENFASSUNG -->
                            <div class="card ltt-steps">
                                <!-- Card header -->
                                <card-header href="ltt-step-planning-comment" id="heading-luminaire-line-planning-comment">
                                    <span>{{ $t('Notes and summary') }}</span>
                                </card-header>
                                <!-- Card body -->
                                <div id="ltt-step-planning-comment" class="collapse" role="tabpanel" aria-labelledby="heading-ltt-step-planning-comment" data-parent="#ltt-accordion">
                                    <div class="card-body px-0 py-3">
                                        <div class="container-fluid px-0 text-white">
                                            <ValidationProvider
                                                :name="$t('Notes')"
                                                rules="max:1000"
                                                tag="div"
                                                class="row"
                                                v-slot="{ errors }">
                                                <div class="form-group col-12">
                                                    <p class="text-light">{{ $t('Use this field for notes or special requests for your lighting line') }}.</p>
                                                    <textarea v-model="luminaireLineFormFields.description" name="description" class="form-control" rows="3"></textarea>
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                    <div class="alert alert-danger" v-if="(luminaireLineFormErrors && luminaireLineFormErrors.description)">
                                                        {{ luminaireLineFormErrors.description[0] }}
                                                    </div>
                                                </div>
                                            </ValidationProvider>
                                            <div class="row">
                                                <div class="col-12">
                                                    <!-- PROJECT OVERVIEW -->
                                                    <luminaire-line-project-overview
                                                        :finalPlanningPrice="finalPlanningPrice"
                                                        :luminaireLinePrices="luminaireLinePrices"
                                                        :specialProducts="luminaireLineFormFields.special_products"
                                                        :displayLedModule="false"
                                                        v-if="finalPlanningPrice > 0"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Accordion card -->
                        </div>
                    </div>
                </form>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>

import {mapGetters} from 'vuex';
import CardHeader from "./FormComponents/CardHeader.vue";

export default {
    components: {CardHeader},
        props: [
            'product_configurator_id',
            'current_step',
            'luminaireLineProducts',
            'planningFormFields',
            'planning_id',
            'lstForm',
            'generatedSku',
            'generatedProductName',
            'calculatedProductPrice',
            'editPlanning',
            'lltDataLoaded',
            'selectedSerie',
            'selectedControl',
            'selectedHousingColor',
            'selectedOptions',
            'selectedOptics',
            'selectedProtectionClass',
            'unfilteredProducts'
        ],

        data() {
            return {
                helpers: {
                    moduleLength: 168,
                    mountingRail504Length: 504,
                    mountingRail336Length: 336,
                    mountingRail168Length: 168,
                    electricalFeedMiddleLength: 28,
                    universalConnectorLength: 28,
                    mountingrail_db_titles: [
                        'mounting_rail_504', 'mounting_rail_336', 'mounting_rail_168'
                    ],
                    number_of_submodules_db_titles: [
                        'number_of_luminaire_control_submodules',
                        'number_of_luminaire_control_submodule_slaves',
                        'number_of_universal_connector_submodules',
                        'number_of_universal_connector_submodules_v2',
                        'number_of_universal_connector_submodules_v3',
                    ],
                },

                mountingRailTypeSuggestions: {},
                selectedMountingRailTypeSuggestion: '',

                calculatedExactLength: 0,

                number_of_electrical_feeds_start_total: '',
                number_of_electrical_feeds_end_total: '',

                luminaireLineFormFields: {
                    number_of_poles: '',
                    lumination_length_suggestion: '',                     // entered
                    lumination_length: '',                                // calculated
                    total_lumination_line_length: 0,                      // calculated
                    number_of_mounting_rail_504: 0,                       // calculated
                    number_of_mounting_rail_336: 0,                       // calculated
                    number_of_mounting_rail_168: 0,                       // calculated
                    number_of_mounting_rail_504_0: '',                    // calculated
                    number_of_mounting_rail_504_1: '',                    // calculated
                    number_of_mounting_rail_504_2: '',                    // calculated
                    number_of_mounting_rail_504_3: '',                    // calculated
                    number_of_mounting_rail_336_0: '',                    // calculated
                    number_of_mounting_rail_336_1: '',                    // calculated
                    number_of_mounting_rail_336_2: '',                    // calculated
                    number_of_mounting_rail_168_0: '',                    // calculated
                    number_of_mounting_rail_168_1: '',                    // calculated
                    number_of_mounting_rails_total: 0,                    // calculated
                    type_of_mounting_rail_504: '',                        // calculated
                    type_of_mounting_rail_336: '',                        // calculated
                    type_of_mounting_rail_168: '',                        // calculated
                    type_of_mounting_rail_504_0: '',                      // calculated
                    type_of_mounting_rail_504_1: '',                      // calculated
                    type_of_mounting_rail_504_2: '',                      // calculated
                    type_of_mounting_rail_504_3: '',                      // calculated
                    type_of_mounting_rail_336_0: '',                      // calculated
                    type_of_mounting_rail_336_1: '',                      // calculated
                    type_of_mounting_rail_336_2: '',                      // calculated
                    type_of_mounting_rail_168_0: '',                      // calculated
                    type_of_mounting_rail_168_1: '',                      // calculated
                    number_of_optics_504: 0,                              // calculated
                    number_of_optics_336: 0,                              // calculated
                    number_of_optics_168: 0,                              // calculated
                    type_of_optics_504: '',                               // calculated
                    type_of_optics_336: '',                               // calculated
                    type_of_optics_168: '',                               // calculated
                    number_of_modules_total: '',                          // calculated
                    number_of_led_modules: 0,                             // entered
                    number_of_blind_modules: 0,                           // calculated
                    type_of_blind_modules: '',                            // calculated
                    number_of_electrical_feeds_per_line: '',              // calculated
                    number_of_electrical_feeds_start: '',                 // entered
                    number_of_electrical_feeds_middle: '',                // entered
                    number_of_electrical_feeds_end: '',                   // entered
                    type_of_electrical_feeds_start: '',                   // calculated
                    type_of_electrical_feeds_middle: '',                  // calculated
                    type_of_electrical_feeds_end: '',                     // calculated
                    number_of_suspensions: '',                            // calculated
                    number_of_additional_suspensions: 0,                  // entered
                    type_of_suspensions: '',                              // calculated
                    number_of_mount_connectors: '',                       // calculated
                    type_of_mount_connectors: '',                         // calculated
                    number_of_mounting_adapters: 0,                       // calculated
                    type_of_mounting_adapters: '',                        // calculated
                    number_of_ceiling_mounts: 0,                          // calculated
                    type_of_ceiling_mounts: '',                           // calculated
                    description: '',
                    planning_id: '',
                    type_of_emergency_light: '',                          // entered
                    number_of_emergency_lights: 0,                        // entered
                    type_of_luminaire_control: '',                        // entered
                    number_of_luminaire_controls: 0,                      // calculated
                    type_of_luminaire_control_slave: '',                  // entered
                    number_of_luminaire_control_slaves: 0,                // calculated
                    type_of_luminaire_control_submodule: '',              // entered
                    number_of_luminaire_control_submodules: 0,            // entered
                    type_of_luminaire_control_submodule_slave: '',              // entered
                    number_of_luminaire_control_submodule_slaves: 0,            // entered
                    type_of_cable_route_504: '',                          // calculated
                    type_of_cable_route_336: '',                          // calculated
                    type_of_cable_route_168: '',                          // calculated
                    number_of_cable_routes_504: 0,                        // calculated
                    number_of_cable_routes_336: 0,                        // calculated
                    number_of_cable_routes_168: 0,                        // calculated
                    type_of_universal_adapters_sm: '',                    // entered
                    number_of_universal_adapters_sm: 0,                   // entered
                    type_of_universal_adapters_lg: '',                    // entered
                    number_of_universal_adapters_lg: 0,                   // entered
                    type_of_universal_connectors: '',                     // entered
                    number_of_universal_connectors: 0,                    // entered
                    type_of_universal_connectors_v2: '',                  // entered
                    number_of_universal_connectors_v2: 0,                 // entered
                    type_of_universal_connectors_v3: '',                  // entered
                    number_of_universal_connectors_v3: 0,                 // entered
                    type_of_mounting_adapter_tool: '',                    // entered
                    number_of_mounting_adapter_tools: 0,                  // entered
                    type_of_warranties: '',                               // entered
                    number_of_warranties: 0,                              // entered
                    type_of_remote_controls: '',                          // entered
                    number_of_remote_controls: 0,                         // entered
                    type_of_connecting_cable: '',                         // entered
                    number_of_connecting_cable: 0,                        // calculated
                    type_of_connecting_cable_middle: '',                  // entered
                    number_of_connecting_cable_middle: 0,                 // calculated
                    number_of_protection_class_504: 0,                    // calculated
                    number_of_protection_class_336: 0,                    // calculated
                    number_of_protection_class_168: 0,                    // calculated
                    type_of_protection_class_168: '',                     // calculated
                    type_of_protection_class_336: '',                     // calculated
                    type_of_protection_class_504: '',                     // calculated
                    type_of_universal_connector_submodules: '',           // entered
                    number_of_universal_connector_submodules: 0,          // entered
                    type_of_universal_connector_submodules_v2: '',        // entered
                    number_of_universal_connector_submodules_v2: 0,       // entered
                    type_of_universal_connector_submodules_v3: '',        // entered
                    number_of_universal_connector_submodules_v3: 0,       // entered
                    number_of_special_products: 0, // entered
                    special_products: [],
                    sku_of_led_module: '',                      // calculated
                    emergency_light_standalone: false,
                },
                luminaireLineFormErrors: {},

                mountingAdapterYesOrNo: '',
                cableRouteYesOrNo: false,

                standAloneSensorYesOrNo: false,
                integratedSensorYesOrNo: false,

                connectingCableYesOrNo: false,
                connectingCableMiddleYesOrNo: false,

                electricalFeedMiddleAlertCounter: 0,
                universalConnectorAlertCounter: 0,
                fixConnectingCableMiddleAlertCounter: 0,

                luminaireLinePrices: {
                    price_of_led_modules: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_mounting_rail_504: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_mounting_rail_336: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_mounting_rail_168: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_mounting_rail_504_0: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_mounting_rail_504_1: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_mounting_rail_504_2: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_mounting_rail_504_3: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_mounting_rail_336_0: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_mounting_rail_336_1: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_mounting_rail_336_2: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_mounting_rail_168_0: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_mounting_rail_168_1: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_optics_504: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_optics_336: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_optics_168: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_protection_class_504: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_protection_class_336: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_protection_class_168: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_electrical_feeds: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_blind_modules: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_mount_connectors: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_suspensions: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_mounting_adapters: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_ceiling_mounts: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_emergency_lights: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_luminaire_controls: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_luminaire_control_slaves: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_luminaire_control_submodules: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_luminaire_control_submodule_slaves: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_cable_routes_168: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_cable_routes_336: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_cable_routes_504: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_universal_adapters_sm: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_universal_adapters_lg: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_universal_connectors: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_universal_connectors_v2: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_universal_connectors_v3: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_universal_connector_submodules: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_universal_connector_submodules_v2: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_universal_connector_submodules_v3: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    /*price_of_mounting_adapter_tools: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },*/
                    price_of_remote_controls: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_connecting_cable: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_connecting_cable_middle: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                    price_of_warranties: {
                        title: '',
                        quantity: 0,
                        price: 0
                    },
                },

                stepThreeValidated: false,

                mountingRailStepIsValid: false,
                mountingRailWithConnectorsStepIsValid: false,
                blindModuleStepIsValid: false,
                ledAndBlindModuleValid: false,
                electricalFeedsValid: false,
                mountingValid: false,
                emergencyLightValid: false,
                luminaireControlValid: false,
                luminaireControlLiteValid: false,
                luminaireControlProValid: false,
                cableRoutesValid: false,
                universalAdapterValid: false,
                universalConnectorValid: false,
                universalConnectorValid_v2: false,
                universalConnectorValid_v3: false,
                universalConnectorSubmoduleValid: false,
                universalConnectorSubmoduleValid_v2: false,
                universalConnectorSubmoduleValid_v3: false,
                //mountingAdapterToolValid: false,
                connectingCableMiddleValid: false,
                anyProductAddonSelected: false,

                luminationLengthValid: false,
                productAddonsValid: false,
                specialProductsValid: false,

                calculatedPlanningPrice: 0,
                finalPlanningPrice: 0,
                calculatedLengthSuggestionPrices: {},

            }
        },

        mounted() {
            this.activateTooltips();
            this.validateStepThree();
            if (this.lltDataLoaded) {
                this.loadPlanningDataOnEdit();
            }
        },

        methods: {

            // prefill form if editing planning
            setLuminaireLineFormData() {

                this.luminaireLineFormFields = Object.assign(this.luminaireLineFormFields, this.planningFormFields);
                this.luminaireLineFormFields.lumination_length_suggestion = (this.planningFormFields.lumination_length / 100).toFixed(0);

                this.calculateExactLength();

                this.standAloneSensorYesOrNo = this.luminaireLineFormFields.number_of_luminaire_controls + this.luminaireLineFormFields.number_of_luminaire_control_slaves > 0;
                this.integratedSensorYesOrNo = this.luminaireLineFormFields.number_of_luminaire_control_submodules + this.luminaireLineFormFields.number_of_luminaire_control_submodule_slaves > 0;

                this.cableRouteYesOrNo = this.luminaireLineFormFields.number_of_cable_routes_504 + this.luminaireLineFormFields.number_of_cable_routes_336 + this.luminaireLineFormFields.number_of_cable_routes_168 > 0;

                // if more suspensions than needed, set number_of_additional_suspensions and number_of_suspensions
                if (this.luminaireLineFormFields.number_of_suspensions > this.luminaireLineFormFields.number_of_mounting_rails_total + this.getTotalQuantityOfMountingRails(504) + 1) {
                    this.luminaireLineFormFields.number_of_additional_suspensions = this.luminaireLineFormFields.number_of_suspensions - (this.luminaireLineFormFields.number_of_mounting_rails_total + this.getTotalQuantityOfMountingRails(504) + 1);
                    this.luminaireLineFormFields.number_of_suspensions = this.luminaireLineFormFields.number_of_mounting_rails_total + this.getTotalQuantityOfMountingRails(504) + 1;
                }

                // Set mounting adapter or not + ceiling mount
                if (this.luminaireLineFormFields.number_of_ceiling_mounts > 0) {
                    this.mountingAdapterYesOrNo = 'mounting_adapter_ceiling';
                } else if (this.luminaireLineFormFields.number_of_mounting_adapters === this.luminaireLineFormFields.number_of_mounting_rails_total + 1 + this.getTotalQuantityOfMountingRails(504) + this.luminaireLineFormFields.number_of_additional_suspensions) {
                    this.mountingAdapterYesOrNo = 'mounting_adapter_yes';
                } else if (this.luminaireLineFormFields.number_of_mounting_adapters === 2 + this.getTotalQuantityOfMountingRails(504) + this.luminaireLineFormFields.number_of_additional_suspensions) {
                    this.mountingAdapterYesOrNo = 'mounting_adapter_no';
                }

                // Set electical feeds Start / End
                if (this.luminaireLineFormFields.number_of_electrical_feeds_start > 0) {
                    this.number_of_electrical_feeds_start_total = this.luminaireLineFormFields.number_of_electrical_feeds_start;
                } else {
                    this.number_of_electrical_feeds_start_total = 0;
                }

                if (this.luminaireLineFormFields.number_of_electrical_feeds_end > 0) {
                    this.number_of_electrical_feeds_end_total = this.luminaireLineFormFields.number_of_electrical_feeds_end;
                } else {
                    this.number_of_electrical_feeds_end_total = 0;
                }

                for (const [key, value] of Object.entries(this.luminaireLineFormFields)) {
                    if (key.includes('number_of_') && value === null) {
                        this.luminaireLineFormFields[key] = 0;
                    }
                }

                //convert planningFormFields.special_products from json to array
                if (this.planningFormFields.special_products) {
                    this.luminaireLineFormFields.special_products = JSON.parse(this.planningFormFields.special_products);
                }

            },

            /**************************************************************************
             * GENERAL METHODS & HELPERS
             **************************************************************************/

            activateTooltips () {
                $( document ).ready(function() {
                    setTimeout(function() {
                        $('[data-toggle="tooltip"]').tooltip({
                            trigger: 'hover',
                            animated: 'fade',
                            placement: 'bottom',
                            html: true
                        });
                    }, 800);
                });
            },

            // display next Accordion Section, when option is selected
            lltGoToNextSection: function (event, nextStepId, errors, stepIsNotValid ) {

                if (errors[0] !== undefined) {
                    return;
                }

                if (stepIsNotValid) {
                    return;
                }

                // disable for led and blind module step
                if ( nextStepId === 'ltt-step-luminaire-electrical-feeds' && !stepIsNotValid && this.product_configurator_id === 1 ) {
                    return;
                }

                $('#' + nextStepId + '.collapse').collapse('show');

            },

            sum(prev, next){
                return prev + next;
            },

            objectsEqual(o1, o2) {
                return typeof o1 === 'object' && Object.keys(o1).length > 0
                        ? Object.keys(o1).length === Object.keys(o2).length
                        && Object.keys(o1).every(p => this.objectsEqual(o1[p], o2[p]))
                        : o1 === o2;
            },

            arraysEqual(a1, a2) {
                return a1.length === a2.length && a1.every((o, idx) => this.objectsEqual(o, a2[idx]));
            },

            getDynamicModel(prefix, db_title) {
                return this.luminaireLineFormFields[prefix + db_title];
            },

            getDynamicError(prefix, db_title) {
                return this.luminaireLineFormErrors[prefix + db_title];
            },

            setDynamicModel(prefix, db_title, value) {
                this.luminaireLineFormFields[prefix + db_title] = prefix === 'number_of_' ? Number(value) : value;
            },

            getMountingRailConfigurationByTitle(title) {
                const regex = /(Mounting rail (Eco|Max) \d+\.\d+ m) \((\d+ electrical connector[s]?)\)/;
                let match = title.match(regex);

                if (match) {
                    return {
                        title: match[1],
                        serie: match[2],
                        connectors: match[3],
                    };
                } else {
                    return false;
                }
            },

            getTotalQuantityOfMountingRails(mounting_rail_type) {

                let number_of_mounting_rail_168 = Number(this.luminaireLineFormFields.number_of_mounting_rail_168) + Number(this.luminaireLineFormFields.number_of_mounting_rail_168_0) + Number(this.luminaireLineFormFields.number_of_mounting_rail_168_1);
                let number_of_mounting_rail_336 = Number(this.luminaireLineFormFields.number_of_mounting_rail_336) + Number(this.luminaireLineFormFields.number_of_mounting_rail_336_0) + Number(this.luminaireLineFormFields.number_of_mounting_rail_336_1) + Number(this.luminaireLineFormFields.number_of_mounting_rail_336_2);
                let number_of_mounting_rail_504 = Number(this.luminaireLineFormFields.number_of_mounting_rail_504) + Number(this.luminaireLineFormFields.number_of_mounting_rail_504_0) + Number(this.luminaireLineFormFields.number_of_mounting_rail_504_1) + Number(this.luminaireLineFormFields.number_of_mounting_rail_504_2) + Number(this.luminaireLineFormFields.number_of_mounting_rail_504_3);

                if (mounting_rail_type === 168) {
                    return Number(number_of_mounting_rail_168);
                } else if (mounting_rail_type === 336) {
                    return Number(number_of_mounting_rail_336);
                } else if (mounting_rail_type === 504) {
                    return Number(number_of_mounting_rail_504);
                } else {
                    return Number(number_of_mounting_rail_168) + Number(number_of_mounting_rail_336) + Number(number_of_mounting_rail_504);
                }
            },

            findProductAlternative(product_id) {

                if (!product_id || !this.luminaireLineProducts || !this.unfilteredProducts ) return;

                let activeProductsFlat = Object.values(this.luminaireLineProducts).flat().filter(el => el !== null);
                let allProductsFlat = Object.values(this.unfilteredProducts).flat().filter(el => el !== null);

                let oldProduct = allProductsFlat.find(product => product.id === product_id);

                return activeProductsFlat.find(product => product.product_subtype
                    && product.product_subtype.includes(oldProduct.product_subtype)
                    && product.id !== oldProduct.id
                    && (!product.serie || this.selectedSerie.includes(product.serie)))
                        ? activeProductsFlat.find(product => product.product_subtype
                            && product.product_subtype === oldProduct.product_subtype
                            && product.id !== oldProduct.id
                            && (!product.serie || this.selectedSerie.includes(product.serie)))
                        : allProductsFlat.find(product => product.product_subtype
                            && product.product_subtype === oldProduct.product_subtype
                            && product.id !== oldProduct.id);
            },

            luminaireControlIsPresenceDetector(product_id) {

                if (this.luminaireLineProducts.luminaire_controls === undefined) return;

                return this.luminaireLineProducts.luminaire_controls.find(el => el.id === product_id)
                    ? this.luminaireLineProducts.luminaire_controls.find(el => el.id === product_id).product_subtype.includes('presence_detector')
                    : false;
            },

            productIsSubtype(product_id, subtype) {

                if (!this.luminaireLineProducts || Object.keys(this.luminaireLineProducts).length === 0) {
                    return false;
                }

                for (let key in this.luminaireLineProducts) {
                    const product_cat = this.luminaireLineProducts[key];

                    if (product_cat && Array.isArray(product_cat) && product_cat.length > 0) {
                        if (product_cat.find(el => el.id === product_id && el.product_subtype.includes(subtype))) {
                            return true;
                        }
                    }
                }


                return false;
            },

            addSpecialProduct() {
                this.luminaireLineFormFields.special_products.push({
                    quantity: 1,
                    sku: '',
                    price: 0
                });
                this.calculateLuminationLineForm();
            },

            removeSpecialProduct(index) {
                this.luminaireLineFormFields.special_products.splice(index, 1);
                this.calculateLuminationLineForm();
            },

            /**************************************************************************
             * CALCULATE LUMINATION LINE
             **************************************************************************/

            // add luminaireLine Prices + without warranty
            calculatePlanningPrice() {

                let total = 0;

                for (let object in this.luminaireLinePrices) {
                    if (object !== 'price_of_warranties') {
                        total += this.luminaireLinePrices[object].price;
                    }
                }

                this.calculatedPlanningPrice = total;
            },

            calculateFinalPlanningPrice() {

                if (!this.calculatedPlanningPrice || this.calculatedPlanningPrice < 0) {
                    this.finalPlanningPrice = 0;
                    return;
                }

                let total = 0;

                for (let object in this.luminaireLinePrices) {
                    total += this.luminaireLinePrices[object].price ? parseFloat(this.luminaireLinePrices[object].price) : 0;
                }

                this.finalPlanningPrice = total;

            },

            calculateLengthSuggestionPrices() {

                if (this.luminaireLineFormFields.lumination_length_suggestion < 2 ) {
                    return;
                }

                let mountingRailLengthTypes = [
                    this.helpers.mountingRail504Length,
                    this.helpers.mountingRail336Length,
                    this.helpers.mountingRail168Length
                ];

                let calculatedLengthSuggestions = [
                    this.calculatedExactLength,
                    this.calculatedExactLength + 168,
                    this.calculatedExactLength - 168,
                ];

                let calculatedLengthSuggestionsPrices = {};

                calculatedLengthSuggestions.forEach(function(luminationLength) {
                    if (luminationLength > 0) {
                        calculatedLengthSuggestionsPrices[luminationLength] = {
                            luminationLength: luminationLength,
                            price: this.getMountingRailPrice(this.getOptimalMountingRails(luminationLength, mountingRailLengthTypes))
                        };
                    }
                }, this);

                this.calculatedLengthSuggestionPrices = calculatedLengthSuggestionsPrices;
            },

            // Main funciton that triggers all calculations (triggered when change in form)
            calculateLuminationLineForm () {

                if (this.editPlanning && this.product_configurator_id === 1 && this.luminaireLineFormFields.sku_of_led_module !== this.generatedSku) {
                    this.luminaireLineFormFields.sku_of_led_module = this.generatedSku;
                }
                this.calculateExactLength();

                // Get Mounting Rail Suggestions
                this.getMountingRailTypeSuggestions();

                // Get Prices for length suggestions
                this.calculateLengthSuggestionPrices();

                // Set Number of mounting rails by selected option & update number of modules
                this.setNumberOfMountingRails();
                this.setTypeOfMountingRails();

                if (this.product_configurator_id === 1) {
                    // Optics
                    this.setNumberOfOptics();
                    this.setTypeOfOptics();

                    // Set Protection Class
                    this.setNumberOfProtectionClass();
                    this.setTypeOfProtectionClass();

                    // Blind Modules
                    this.setTypeOfBlindModules();
                    this.setNumberOfBlindModules();
                }

                // Calculate & Set number of needed electrical feeds
                this.setNumberOfElectricalFeedsPerLine();
                this.setNumberOfElectricalFeedsStartEnd();
                //this.electricalFeedMiddleAlert();

                // Set Type of Electrical Feeds
                this.setTypeOfElectricalFeeds();

                // Set mount connectors
                this.setNumberOfMountConnectors();
                this.setTypeOfConnectors();

                // Set Mounting Adapters & Ceiling Mounts
                this.setNumberOfMountingAdapters();
                this.setTypeOfMountingAdapters();

                // Set number of suspensions
                this.setNumberOfSuspensions();

                // Set Cable Routes
                this.setCableRoutes();

                // Set Number of Luminaire Controls
                this.setNumberOfLuminaireControls();
                this.setTypeOfLuminaireControls();

                this.checkLuminaireControls();


                // Set number of remote controls
                this.setNumberOfRemoteControls();

                // set number and type of connecting cables
                this.setNumberConnectingCable();

                // set number and type of connecting cables
                this.setNumberConnectingCableMiddle();

                // Reset submodules if no blindmodules
                this.resetSubmodules();

                // Set emergency light standalone to false if number of emergency lights is less than 1

                if (this.luminaireLineFormFields.number_of_emergency_lights < 1) {
                    this.luminaireLineFormFields.emergency_light_standalone = false;
                }

                // Set number of Warranties
                this.setNumberOfWarranties();

                // Calculate Price
                this.setPlanningPriceObject();
                this.calculateFinalPlanningPrice();

                // Set total length of lumination line incl. electrical feeds middle
                this.setTotalLuminationLineLength();

                // if no blind modules remove blindmoduletype selection
                if (this.luminaireLineFormFields.number_of_blind_modules === 0 && this.luminaireLineFormFields.type_of_blind_modules) {
                    this.luminaireLineFormFields.type_of_blind_modules = '';
                }

                this.validateStepThree();

            },

            resetSubmodules() {
                if (this.luminaireLineFormFields.number_of_blind_modules < 1) {
                    this.luminaireLineFormFields.type_of_luminaire_control_submodule = '';
                    this.luminaireLineFormFields.number_of_luminaire_control_submodules = 0;
                    this.luminaireLineFormFields.type_of_luminaire_control_submodule_slave = '';
                    this.luminaireLineFormFields.number_of_luminaire_control_submodule_slaves = 0;
                    this.luminaireLineFormFields.type_of_universal_connector_submodules = '';
                    this.luminaireLineFormFields.number_of_universal_connector_submodules = 0;
                    this.luminaireLineFormFields.type_of_universal_connector_submodules_v2 = '';
                    this.luminaireLineFormFields.number_of_universal_connector_submodules_v2 = 0;
                    this.luminaireLineFormFields.type_of_universal_connector_submodules_v3 = '';
                    this.luminaireLineFormFields.number_of_universal_connector_submodules_v3 = 0;
                    this.luminaireLineFormFields.special_products = [];

                }
            },

            setPlanningPriceObject() {

                if ( this.getTotalQuantityOfMountingRails() > 0 ) {

                    // Mounting Rails
                    if (this.luminaireLineFormFields.number_of_mounting_rail_168 > 0) {
                        let selectedMountingRail168 = this.luminaireLineProducts.mountingrails.find(mountingRail => mountingRail.size_x === 168);
                        this.luminaireLinePrices.price_of_mounting_rail_168['price'] = this.luminaireLineFormFields.number_of_mounting_rail_168 * selectedMountingRail168.price;
                        this.luminaireLinePrices.price_of_mounting_rail_168['quantity'] = this.luminaireLineFormFields.number_of_mounting_rail_168;
                        this.luminaireLinePrices.price_of_mounting_rail_168['title'] = selectedMountingRail168.title;
                    } else {
                        this.luminaireLinePrices.price_of_mounting_rail_168['price'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_168['quantity'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_168['title'] = '';
                    }
                    if (this.luminaireLineFormFields.number_of_mounting_rail_336 > 0) {
                        let selectedMountingRail336 = this.luminaireLineProducts.mountingrails.find(mountingRail => mountingRail.size_x === 336);

                        this.luminaireLinePrices.price_of_mounting_rail_336['price'] = this.luminaireLineFormFields.number_of_mounting_rail_336 * selectedMountingRail336.price;
                        this.luminaireLinePrices.price_of_mounting_rail_336['quantity'] = this.luminaireLineFormFields.number_of_mounting_rail_336;
                        this.luminaireLinePrices.price_of_mounting_rail_336['title'] = selectedMountingRail336.title;
                    } else {
                        this.luminaireLinePrices.price_of_mounting_rail_336['price'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_336['quantity'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_336['title'] = '';
                    }
                    if (this.luminaireLineFormFields.number_of_mounting_rail_504 > 0) {
                        let selectedMountingRail504 = this.luminaireLineProducts.mountingrails.find(mountingRail => mountingRail.size_x === 504);

                        this.luminaireLinePrices.price_of_mounting_rail_504['price'] = this.luminaireLineFormFields.number_of_mounting_rail_504 * selectedMountingRail504.price;
                        this.luminaireLinePrices.price_of_mounting_rail_504['quantity'] = this.luminaireLineFormFields.number_of_mounting_rail_504;
                        this.luminaireLinePrices.price_of_mounting_rail_504['title'] = selectedMountingRail504.title;
                    } else {
                        this.luminaireLinePrices.price_of_mounting_rail_504['price'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_504['quantity'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_504['title'] = '';
                    }

                    // Mounting Rails 504 with connectors
                    if (this.luminaireLineFormFields.number_of_mounting_rail_504_0 > 0) {
                        let selectedMountingRail504_0 = this.luminaireLineProducts.mountingrails_with_connectors.find(mountingRail => mountingRail.size_x === 504 && mountingRail.product_subtype === 'mounting_rail_0_connectors');

                        this.luminaireLinePrices.price_of_mounting_rail_504_0['price'] = this.luminaireLineFormFields.number_of_mounting_rail_504_0 * selectedMountingRail504_0.price;
                        this.luminaireLinePrices.price_of_mounting_rail_504_0['quantity'] = this.luminaireLineFormFields.number_of_mounting_rail_504_0;
                        this.luminaireLinePrices.price_of_mounting_rail_504_0['title'] = selectedMountingRail504_0.title;
                    } else {
                        this.luminaireLinePrices.price_of_mounting_rail_504_0['price'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_504_0['quantity'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_504_0['title'] = '';
                    }

                    if (this.luminaireLineFormFields.number_of_mounting_rail_504_1 > 0) {
                        let selectedMountingRail504_1 = this.luminaireLineProducts.mountingrails_with_connectors.find(mountingRail => mountingRail.size_x === 504 && mountingRail.product_subtype === 'mounting_rail_1_connectors');

                        this.luminaireLinePrices.price_of_mounting_rail_504_1['price'] = this.luminaireLineFormFields.number_of_mounting_rail_504_1 * selectedMountingRail504_1.price;
                        this.luminaireLinePrices.price_of_mounting_rail_504_1['quantity'] = this.luminaireLineFormFields.number_of_mounting_rail_504_1;
                        this.luminaireLinePrices.price_of_mounting_rail_504_1['title'] = selectedMountingRail504_1.title;
                    } else {
                        this.luminaireLinePrices.price_of_mounting_rail_504_1['price'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_504_1['quantity'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_504_1['title'] = '';
                    }

                    if (this.luminaireLineFormFields.number_of_mounting_rail_504_2 > 0) {
                        let selectedMountingRail504_2 = this.luminaireLineProducts.mountingrails_with_connectors.find(mountingRail => mountingRail.size_x === 504 && mountingRail.product_subtype === 'mounting_rail_2_connectors');

                        this.luminaireLinePrices.price_of_mounting_rail_504_2['price'] = this.luminaireLineFormFields.number_of_mounting_rail_504_2 * selectedMountingRail504_2.price;
                        this.luminaireLinePrices.price_of_mounting_rail_504_2['quantity'] = this.luminaireLineFormFields.number_of_mounting_rail_504_2;
                        this.luminaireLinePrices.price_of_mounting_rail_504_2['title'] = selectedMountingRail504_2.title;
                    } else {
                        this.luminaireLinePrices.price_of_mounting_rail_504_2['price'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_504_2['quantity'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_504_2['title'] = '';
                    }

                    if (this.luminaireLineFormFields.number_of_mounting_rail_504_3 > 0) {
                        let selectedMountingRail504_3 = this.luminaireLineProducts.mountingrails_with_connectors.find(mountingRail => mountingRail.size_x === 504 && mountingRail.product_subtype === 'mounting_rail_3_connectors');

                        this.luminaireLinePrices.price_of_mounting_rail_504_3['price'] = this.luminaireLineFormFields.number_of_mounting_rail_504_3 * selectedMountingRail504_3.price;
                        this.luminaireLinePrices.price_of_mounting_rail_504_3['quantity'] = this.luminaireLineFormFields.number_of_mounting_rail_504_3;
                        this.luminaireLinePrices.price_of_mounting_rail_504_3['title'] = selectedMountingRail504_3.title;
                    } else {
                        this.luminaireLinePrices.price_of_mounting_rail_504_3['price'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_504_3['quantity'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_504_3['title'] = '';
                    }

                    // Mounting Rails 336 with connectors
                    if (this.luminaireLineFormFields.number_of_mounting_rail_336_0 > 0) {
                        let selectedMountingRail336_0 = this.luminaireLineProducts.mountingrails_with_connectors.find(mountingRail => mountingRail.size_x === 336 && mountingRail.product_subtype === 'mounting_rail_0_connectors');

                        this.luminaireLinePrices.price_of_mounting_rail_336_0['price'] = this.luminaireLineFormFields.number_of_mounting_rail_336_0 * selectedMountingRail336_0.price;
                        this.luminaireLinePrices.price_of_mounting_rail_336_0['quantity'] = this.luminaireLineFormFields.number_of_mounting_rail_336_0;
                        this.luminaireLinePrices.price_of_mounting_rail_336_0['title'] = selectedMountingRail336_0.title;
                    } else {
                        this.luminaireLinePrices.price_of_mounting_rail_336_0['price'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_336_0['quantity'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_336_0['title'] = '';
                    }

                    if (this.luminaireLineFormFields.number_of_mounting_rail_336_1 > 0) {
                        let selectedMountingRail336_1 = this.luminaireLineProducts.mountingrails_with_connectors.find(mountingRail => mountingRail.size_x === 336 && mountingRail.product_subtype === 'mounting_rail_1_connectors');

                        this.luminaireLinePrices.price_of_mounting_rail_336_1['price'] = this.luminaireLineFormFields.number_of_mounting_rail_336_1 * selectedMountingRail336_1.price;
                        this.luminaireLinePrices.price_of_mounting_rail_336_1['quantity'] = this.luminaireLineFormFields.number_of_mounting_rail_336_1;
                        this.luminaireLinePrices.price_of_mounting_rail_336_1['title'] = selectedMountingRail336_1.title;
                    } else {
                        this.luminaireLinePrices.price_of_mounting_rail_336_1['price'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_336_1['quantity'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_336_1['title'] = '';
                    }

                    if (this.luminaireLineFormFields.number_of_mounting_rail_336_2 > 0) {
                        let selectedMountingRail336_2 = this.luminaireLineProducts.mountingrails_with_connectors.find(mountingRail => mountingRail.size_x === 336 && mountingRail.product_subtype === 'mounting_rail_2_connectors');

                        this.luminaireLinePrices.price_of_mounting_rail_336_2['price'] = this.luminaireLineFormFields.number_of_mounting_rail_336_2 * selectedMountingRail336_2.price;
                        this.luminaireLinePrices.price_of_mounting_rail_336_2['quantity'] = this.luminaireLineFormFields.number_of_mounting_rail_336_2;
                        this.luminaireLinePrices.price_of_mounting_rail_336_2['title'] = selectedMountingRail336_2.title;
                    } else {
                        this.luminaireLinePrices.price_of_mounting_rail_336_2['price'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_336_2['quantity'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_336_2['title'] = '';
                    }

                    // Mounting Rails 168 with connectors

                    if (this.luminaireLineFormFields.number_of_mounting_rail_168_0 > 0) {
                        let selectedMountingRail168_0 = this.luminaireLineProducts.mountingrails_with_connectors.find(mountingRail => mountingRail.size_x === 168 && mountingRail.product_subtype === 'mounting_rail_0_connectors');

                        this.luminaireLinePrices.price_of_mounting_rail_168_0['price'] = this.luminaireLineFormFields.number_of_mounting_rail_168_0 * selectedMountingRail168_0.price;
                        this.luminaireLinePrices.price_of_mounting_rail_168_0['quantity'] = this.luminaireLineFormFields.number_of_mounting_rail_168_0;
                        this.luminaireLinePrices.price_of_mounting_rail_168_0['title'] = selectedMountingRail168_0.title;
                    } else {
                        this.luminaireLinePrices.price_of_mounting_rail_168_0['price'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_168_0['quantity'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_168_0['title'] = '';
                    }

                    if (this.luminaireLineFormFields.number_of_mounting_rail_168_1 > 0) {
                        let selectedMountingRail168_1 = this.luminaireLineProducts.mountingrails_with_connectors.find(mountingRail => mountingRail.size_x === 168 && mountingRail.product_subtype === 'mounting_rail_1_connectors');

                        this.luminaireLinePrices.price_of_mounting_rail_168_1['price'] = this.luminaireLineFormFields.number_of_mounting_rail_168_1 * selectedMountingRail168_1.price;
                        this.luminaireLinePrices.price_of_mounting_rail_168_1['quantity'] = this.luminaireLineFormFields.number_of_mounting_rail_168_1;
                        this.luminaireLinePrices.price_of_mounting_rail_168_1['title'] = selectedMountingRail168_1.title;
                    } else {
                        this.luminaireLinePrices.price_of_mounting_rail_168_1['price'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_168_1['quantity'] = 0;
                        this.luminaireLinePrices.price_of_mounting_rail_168_1['title'] = '';
                    }

                    // Optics
                    if (this.luminaireLineFormFields.number_of_optics_168 > 0) {
                        let selectedOptics168 = this.luminaireLineProducts.optics.find(optics => optics.size_x === 167);
                        this.luminaireLinePrices.price_of_optics_168['price'] = this.luminaireLineFormFields.number_of_optics_168 * selectedOptics168.price;
                        this.luminaireLinePrices.price_of_optics_168['quantity'] = this.luminaireLineFormFields.number_of_optics_168;
                        this.luminaireLinePrices.price_of_optics_168['title'] = selectedOptics168.title;
                    } else {
                        this.luminaireLinePrices.price_of_optics_168['price'] = 0;
                        this.luminaireLinePrices.price_of_optics_168['quantity'] = 0;
                        this.luminaireLinePrices.price_of_optics_168['title'] = '';
                    }
                    if (this.luminaireLineFormFields.number_of_optics_336 > 0) {
                        let selectedOptics336 = this.luminaireLineProducts.optics.find(optics => optics.size_x === 334);
                        this.luminaireLinePrices.price_of_optics_336['price'] = this.luminaireLineFormFields.number_of_optics_336 * selectedOptics336.price;
                        this.luminaireLinePrices.price_of_optics_336['quantity'] = this.luminaireLineFormFields.number_of_optics_336;
                        this.luminaireLinePrices.price_of_optics_336['title'] = selectedOptics336.title;
                    } else {
                        this.luminaireLinePrices.price_of_optics_336['price'] = 0;
                        this.luminaireLinePrices.price_of_optics_336['quantity'] = 0;
                        this.luminaireLinePrices.price_of_optics_336['title'] = '';
                    }
                    if (this.luminaireLineFormFields.number_of_optics_504 > 0) {
                        let selectedOptics504 = this.luminaireLineProducts.optics.find(optics => optics.size_x === 502);
                        this.luminaireLinePrices.price_of_optics_504['price'] = this.luminaireLineFormFields.number_of_optics_504 * selectedOptics504.price;
                        this.luminaireLinePrices.price_of_optics_504['quantity'] = this.luminaireLineFormFields.number_of_optics_504;
                        this.luminaireLinePrices.price_of_optics_504['title'] = selectedOptics504.title;
                    } else {
                        this.luminaireLinePrices.price_of_optics_504['price'] = 0;
                        this.luminaireLinePrices.price_of_optics_504['quantity'] = 0;
                        this.luminaireLinePrices.price_of_optics_504['title'] = '';
                    }

                    // Protection Class
                    if (this.luminaireLineFormFields.number_of_protection_class_168 > 0) {
                        let selectedProtectionClass168 = this.luminaireLineProducts.protection_class.find(protection_class => protection_class.size_x === 168);

                        this.luminaireLinePrices.price_of_protection_class_168['price'] = this.luminaireLineFormFields.number_of_protection_class_168 * selectedProtectionClass168.price;
                        this.luminaireLinePrices.price_of_protection_class_168['quantity'] = this.luminaireLineFormFields.number_of_protection_class_168;
                        this.luminaireLinePrices.price_of_protection_class_168['title'] = selectedProtectionClass168.title;
                    } else {
                        this.luminaireLinePrices.price_of_protection_class_168['price'] = 0;
                        this.luminaireLinePrices.price_of_protection_class_168['quantity'] = 0;
                        this.luminaireLinePrices.price_of_protection_class_168['title'] = '';
                    }
                    if (this.luminaireLineFormFields.number_of_protection_class_336 > 0) {
                        let selectedProtectionClass336 = this.luminaireLineProducts.protection_class.find(protection_class => protection_class.size_x === 336);

                        this.luminaireLinePrices.price_of_protection_class_336['price'] = this.luminaireLineFormFields.number_of_protection_class_336 * selectedProtectionClass336.price;
                        this.luminaireLinePrices.price_of_protection_class_336['quantity'] = this.luminaireLineFormFields.number_of_protection_class_336;
                        this.luminaireLinePrices.price_of_protection_class_336['title'] = selectedProtectionClass336.title;
                    } else {
                        this.luminaireLinePrices.price_of_protection_class_336['price'] = 0;
                        this.luminaireLinePrices.price_of_protection_class_336['quantity'] = 0;
                        this.luminaireLinePrices.price_of_protection_class_336['title'] = '';
                    }
                    if (this.luminaireLineFormFields.number_of_protection_class_504 > 0) {
                        let selectedProtectionClass504 = this.luminaireLineProducts.protection_class.find(protection_class => protection_class.size_x === 504);

                        this.luminaireLinePrices.price_of_protection_class_504['price'] = this.luminaireLineFormFields.number_of_protection_class_504 * selectedProtectionClass504.price;
                        this.luminaireLinePrices.price_of_protection_class_504['quantity'] = this.luminaireLineFormFields.number_of_protection_class_504;
                        this.luminaireLinePrices.price_of_protection_class_504['title'] = selectedProtectionClass504.title;
                    } else {
                        this.luminaireLinePrices.price_of_protection_class_504['price'] = 0;
                        this.luminaireLinePrices.price_of_protection_class_504['quantity'] = 0;
                        this.luminaireLinePrices.price_of_protection_class_504['title'] = '';
                    }

                    // LED Modules
                    if (this.luminaireLineFormFields.number_of_led_modules > 0 ) {
                        this.luminaireLinePrices.price_of_led_modules['title'] = this.generatedProductName;
                        this.luminaireLinePrices.price_of_led_modules['quantity'] = this.luminaireLineFormFields.number_of_led_modules;
                        this.luminaireLinePrices.price_of_led_modules['price'] = this.luminaireLineFormFields.number_of_led_modules * this.calculatedProductPrice;
                    }

                    // Blind Modules
                    if (this.luminaireLineFormFields.type_of_blind_modules && this.luminaireLineFormFields.number_of_blind_modules > 0 && this.luminaireLineFormFields.number_of_led_modules > 0 && this.luminaireLineProducts.blind_modules.find(blindModule => blindModule.id === this.luminaireLineFormFields.type_of_blind_modules)) {
                        let selectedBlindModule = this.luminaireLineProducts.blind_modules.find(blindModule => blindModule.id === this.luminaireLineFormFields.type_of_blind_modules);

                        this.luminaireLinePrices.price_of_blind_modules['title'] = selectedBlindModule.title;
                        this.luminaireLinePrices.price_of_blind_modules['quantity'] = this.luminaireLineFormFields.number_of_blind_modules;
                        this.luminaireLinePrices.price_of_blind_modules['price'] = this.luminaireLineFormFields.number_of_blind_modules * selectedBlindModule.price;
                    } else {
                        this.luminaireLinePrices.price_of_blind_modules['title'] = '';
                        this.luminaireLinePrices.price_of_blind_modules['quantity'] = 0;
                        this.luminaireLinePrices.price_of_blind_modules['price'] = 0;
                    }

                    // Electrical Feeds
                    if ((this.number_of_electrical_feeds_start_total + this.luminaireLineFormFields.number_of_electrical_feeds_middle + this.number_of_electrical_feeds_end_total) >= this.luminaireLineFormFields.number_of_electrical_feeds_per_line) {
                        this.luminaireLinePrices.price_of_electrical_feeds['title'] = this.selectedSerie.includes('eco') ? this.$t('Electrical feed Eco') : this.$t('Electrical feed Max');
                        this.luminaireLinePrices.price_of_electrical_feeds['quantity'] = 0;
                        this.luminaireLinePrices.price_of_electrical_feeds['price'] = 0;

                        if (this.luminaireLineFormFields.number_of_electrical_feeds_start > 0) {
                            let selectedElectricalFeedsStart = this.luminaireLineProducts.electrical_feeds.find(electricalFeed => electricalFeed.product_subtype.includes('electrical_feed_start'));

                            this.luminaireLinePrices.price_of_electrical_feeds['price'] += this.luminaireLineFormFields.number_of_electrical_feeds_start * selectedElectricalFeedsStart.price;
                        }
                        if (this.luminaireLineFormFields.number_of_electrical_feeds_middle > 0) {
                            let selectedElectricalFeedsMiddle = this.luminaireLineProducts.electrical_feeds.find(electricalFeed => electricalFeed.product_subtype.includes('electrical_feed_middle'));

                            this.luminaireLinePrices.price_of_electrical_feeds['price'] += this.luminaireLineFormFields.number_of_electrical_feeds_middle * selectedElectricalFeedsMiddle.price;
                        }
                        if (this.luminaireLineFormFields.number_of_electrical_feeds_end > 0) {
                            let selectedElectricalFeedsEnd = this.luminaireLineProducts.electrical_feeds.find(electricalFeed => electricalFeed.product_subtype.includes('electrical_feed_end'));

                            this.luminaireLinePrices.price_of_electrical_feeds['price'] += this.luminaireLineFormFields.number_of_electrical_feeds_end * selectedElectricalFeedsEnd.price;
                        }

                        if ( (this.luminaireLineFormFields.number_of_electrical_feeds_start + this.luminaireLineFormFields.number_of_electrical_feeds_middle + this.luminaireLineFormFields.number_of_electrical_feeds_end) > 0 ) {
                            this.luminaireLinePrices.price_of_electrical_feeds['quantity'] = this.luminaireLineFormFields.number_of_electrical_feeds_start + this.luminaireLineFormFields.number_of_electrical_feeds_middle + this.luminaireLineFormFields.number_of_electrical_feeds_end;
                        }

                    } else {

                        this.luminaireLinePrices.price_of_electrical_feeds['title'] = '';
                        this.luminaireLinePrices.price_of_electrical_feeds['quantity'] = 0;
                        this.luminaireLinePrices.price_of_electrical_feeds['price'] = 0;
                    }

                    // Connectors
                    if (this.luminaireLineFormFields.number_of_mount_connectors > 0 ) {
                        this.luminaireLinePrices.price_of_mount_connectors['title'] = this.luminaireLineProducts.mount_connectors[0].title;
                        this.luminaireLinePrices.price_of_mount_connectors['quantity'] = this.luminaireLineFormFields.number_of_mount_connectors;
                        this.luminaireLinePrices.price_of_mount_connectors['price'] = this.luminaireLineFormFields.number_of_mount_connectors * this.luminaireLineProducts.mount_connectors[0].price;
                    } else {
                        this.luminaireLinePrices.price_of_mount_connectors['title'] = '';
                        this.luminaireLinePrices.price_of_mount_connectors['quantity'] = 0;
                        this.luminaireLinePrices.price_of_mount_connectors['price'] = 0;
                    }

                    // Mounting Adapters
                    if (this.luminaireLineFormFields.number_of_mounting_adapters > 0 ) {
                        this.luminaireLinePrices.price_of_mounting_adapters['title'] = this.luminaireLineProducts.mounting_adapters[0].title;
                        this.luminaireLinePrices.price_of_mounting_adapters['quantity'] = this.luminaireLineFormFields.number_of_mounting_adapters;
                        this.luminaireLinePrices.price_of_mounting_adapters['price'] = this.luminaireLineFormFields.number_of_mounting_adapters * this.luminaireLineProducts.mounting_adapters[0].price;
                    } else {
                        this.luminaireLinePrices.price_of_mounting_adapters['title'] = '';
                        this.luminaireLinePrices.price_of_mounting_adapters['quantity'] = 0;
                        this.luminaireLinePrices.price_of_mounting_adapters['price'] = 0;
                    }

                    // Ceiling Mount
                    if (this.luminaireLineFormFields.number_of_ceiling_mounts > 0 ) {
                        this.luminaireLinePrices.price_of_ceiling_mounts['title'] = this.luminaireLineProducts.ceiling_mounts[0].title;
                        this.luminaireLinePrices.price_of_ceiling_mounts['quantity'] = this.luminaireLineFormFields.number_of_ceiling_mounts;
                        this.luminaireLinePrices.price_of_ceiling_mounts['price'] = this.luminaireLineFormFields.number_of_ceiling_mounts * this.luminaireLineProducts.ceiling_mounts[0].price;
                    } else {
                        this.luminaireLinePrices.price_of_ceiling_mounts['title'] = '';
                        this.luminaireLinePrices.price_of_ceiling_mounts['quantity'] = 0;
                        this.luminaireLinePrices.price_of_ceiling_mounts['price'] = 0;
                    }

                    // Suspensions
                    if (this.luminaireLineFormFields.type_of_suspensions && this.luminaireLineFormFields.number_of_suspensions > 0 && this.luminaireLineProducts.suspensions.find(suspension => suspension.id === this.luminaireLineFormFields.type_of_suspensions)) {
                        let selectedSuspension = this.luminaireLineProducts.suspensions.find(suspension => suspension.id === this.luminaireLineFormFields.type_of_suspensions);

                        this.luminaireLinePrices.price_of_suspensions['title'] = selectedSuspension.title;
                        this.luminaireLinePrices.price_of_suspensions['quantity'] = this.luminaireLineFormFields.number_of_suspensions;
                        this.luminaireLinePrices.price_of_suspensions['price'] = this.luminaireLineFormFields.number_of_suspensions * selectedSuspension.price;
                    } else {
                        this.luminaireLinePrices.price_of_suspensions['title'] = '';
                        this.luminaireLinePrices.price_of_suspensions['quantity'] = '';
                        this.luminaireLinePrices.price_of_suspensions['price'] = '';
                    }

                    // Emergency Lights
                    if (this.luminaireLineFormFields.number_of_emergency_lights > 0  && this.luminaireLineProducts.emergency_lights.find(emergency_light => emergency_light.id === this.luminaireLineFormFields.type_of_emergency_light)) {
                        let selectedEmergencyLight = this.luminaireLineProducts.emergency_lights.find(emergency_light => emergency_light.id === this.luminaireLineFormFields.type_of_emergency_light);

                        this.luminaireLinePrices.price_of_emergency_lights['title'] = selectedEmergencyLight.title;
                        this.luminaireLinePrices.price_of_emergency_lights['quantity'] = this.luminaireLineFormFields.number_of_emergency_lights;
                        this.luminaireLinePrices.price_of_emergency_lights['price'] = this.luminaireLineFormFields.number_of_emergency_lights * selectedEmergencyLight.price;
                    } else {
                        this.luminaireLinePrices.price_of_emergency_lights['title'] = '';
                        this.luminaireLinePrices.price_of_emergency_lights['quantity'] = 0;
                        this.luminaireLinePrices.price_of_emergency_lights['price'] = 0;
                    }

                    // luminaire_control
                    if (this.luminaireLineFormFields.type_of_luminaire_control
                        && this.luminaireLineFormFields.number_of_luminaire_controls > 0
                        && ( this.luminaireLineProducts.luminaire_controls.find(luminaire_control => luminaire_control.id === this.luminaireLineFormFields.type_of_luminaire_control)
                            || this.findProductAlternative(this.luminaireLineFormFields.type_of_luminaire_control) )
                    ) {

                        let selectedLuminaireControl = this.luminaireLineProducts.luminaire_controls.find(luminaire_control => luminaire_control.id === this.luminaireLineFormFields.type_of_luminaire_control)
                            ? this.luminaireLineProducts.luminaire_controls.find(luminaire_control => luminaire_control.id === this.luminaireLineFormFields.type_of_luminaire_control)
                            : this.findProductAlternative(this.luminaireLineFormFields.type_of_luminaire_control);

                        // Update type in case of alternative product
                        this.luminaireLineFormFields.type_of_luminaire_control = selectedLuminaireControl.id;

                        this.luminaireLinePrices.price_of_luminaire_controls['title'] = selectedLuminaireControl.title;
                        this.luminaireLinePrices.price_of_luminaire_controls['quantity'] = this.luminaireLineFormFields.number_of_luminaire_controls;
                        this.luminaireLinePrices.price_of_luminaire_controls['price'] = this.luminaireLineFormFields.number_of_luminaire_controls * selectedLuminaireControl.price;

                    } else {
                        this.luminaireLinePrices.price_of_luminaire_controls['title'] = '';
                        this.luminaireLinePrices.price_of_luminaire_controls['quantity'] = 0;
                        this.luminaireLinePrices.price_of_luminaire_controls['price'] = 0;
                    }

                    // luminaire_control slave
                    if (this.luminaireLineFormFields.type_of_luminaire_control_slave
                        && this.luminaireLineFormFields.number_of_luminaire_control_slaves > 0
                        && ( this.luminaireLineProducts.luminaire_controls.find(luminaire_control_slave => luminaire_control_slave.id === this.luminaireLineFormFields.type_of_luminaire_control_slave)
                            || this.findProductAlternative(this.luminaireLineFormFields.type_of_luminaire_control_slave) )
                    ) {

                        let selectedLuminaireControl = this.luminaireLineProducts.luminaire_controls.find(luminaire_control_slave => luminaire_control_slave.id === this.luminaireLineFormFields.type_of_luminaire_control_slave)
                            ? this.luminaireLineProducts.luminaire_controls.find(luminaire_control_slave => luminaire_control_slave.id === this.luminaireLineFormFields.type_of_luminaire_control_slave)
                            : this.findProductAlternative(this.luminaireLineFormFields.type_of_luminaire_control_slave);

                        // Update type in case of alternative product
                        this.luminaireLineFormFields.type_of_luminaire_control_slave = selectedLuminaireControl.id;

                        this.luminaireLinePrices.price_of_luminaire_control_slaves['title'] = selectedLuminaireControl.title;
                        this.luminaireLinePrices.price_of_luminaire_control_slaves['quantity'] = this.luminaireLineFormFields.number_of_luminaire_control_slaves;
                        this.luminaireLinePrices.price_of_luminaire_control_slaves['price'] = this.luminaireLineFormFields.number_of_luminaire_control_slaves * selectedLuminaireControl.price;

                    } else {
                        this.luminaireLineFormFields.type_of_luminaire_control_slave = null;
                        this.luminaireLinePrices.price_of_luminaire_control_slaves['title'] = '';
                        this.luminaireLinePrices.price_of_luminaire_control_slaves['quantity'] = 0;
                        this.luminaireLinePrices.price_of_luminaire_control_slaves['price'] = 0;
                    }

                    // Luminaire Control Submodule
                    if(this.luminaireLineFormFields.type_of_luminaire_control_submodule &&
                        this.luminaireLineFormFields.number_of_luminaire_control_submodules > 0) {
                        let selectedLuminarecontrolSubmodule = this.luminaireLineProducts.luminaire_control_submodules.find(luminaire_control_submodule => luminaire_control_submodule.id === this.luminaireLineFormFields.type_of_luminaire_control_submodule);

                        this.luminaireLineFormFields.type_of_luminaire_control_submodule = selectedLuminarecontrolSubmodule.id;

                        this.luminaireLinePrices.price_of_luminaire_control_submodules['title'] = selectedLuminarecontrolSubmodule.title;
                        this.luminaireLinePrices.price_of_luminaire_control_submodules['quantity'] = this.luminaireLineFormFields.number_of_luminaire_control_submodules;
                        this.luminaireLinePrices.price_of_luminaire_control_submodules['price'] = this.luminaireLineFormFields.number_of_luminaire_control_submodules * selectedLuminarecontrolSubmodule.price;
                    } else {
                        this.luminaireLinePrices.price_of_luminaire_control_submodules['title'] = '';
                        this.luminaireLinePrices.price_of_luminaire_control_submodules['quantity'] = 0;
                        this.luminaireLinePrices.price_of_luminaire_control_submodules['price'] = 0;
                    }

                    // luminaire_control submodule slave
                    if (this.luminaireLineFormFields.type_of_luminaire_control_submodule_slave
                        && this.luminaireLineFormFields.number_of_luminaire_control_submodule_slaves > 0
                        && ( this.luminaireLineProducts.luminaire_control_submodules.find(luminaire_control_submodule_slave => luminaire_control_submodule_slave.id === this.luminaireLineFormFields.type_of_luminaire_control_submodule_slave)
                            || this.findProductAlternative(this.luminaireLineFormFields.type_of_luminaire_control_submodule_slave) )
                    ) {

                        let selectedLuminaireControlSubmoduleSlave = this.luminaireLineProducts.luminaire_control_submodules.find(luminaire_control_submodule_slave => luminaire_control_submodule_slave.id === this.luminaireLineFormFields.type_of_luminaire_control_submodule_slave)
                            ? this.luminaireLineProducts.luminaire_control_submodules.find(luminaire_control_submodule_slave => luminaire_control_submodule_slave.id === this.luminaireLineFormFields.type_of_luminaire_control_submodule_slave)
                            : this.findProductAlternative(this.luminaireLineFormFields.type_of_luminaire_control_submodule_slave);

                        // Update type in case of alternative product
                        this.luminaireLineFormFields.type_of_luminaire_control_submodule_slave = selectedLuminaireControlSubmoduleSlave.id;

                        this.luminaireLinePrices.price_of_luminaire_control_submodule_slaves['title'] = selectedLuminaireControlSubmoduleSlave.title;
                        this.luminaireLinePrices.price_of_luminaire_control_submodule_slaves['quantity'] = this.luminaireLineFormFields.number_of_luminaire_control_submodule_slaves;
                        this.luminaireLinePrices.price_of_luminaire_control_submodule_slaves['price'] = this.luminaireLineFormFields.number_of_luminaire_control_submodule_slaves * selectedLuminaireControlSubmoduleSlave.price;


                    } else {
                        this.luminaireLineFormFields.type_of_luminaire_control_submodule_slave = null;
                        this.luminaireLinePrices.price_of_luminaire_control_submodule_slaves['title'] = '';
                        this.luminaireLinePrices.price_of_luminaire_control_submodule_slaves['quantity'] = 0;
                        this.luminaireLinePrices.price_of_luminaire_control_submodule_slaves['price'] = 0;
                    }

                    // remote_control
                    if (this.luminaireLineFormFields.type_of_remote_controls
                        && this.luminaireLineFormFields.number_of_remote_controls > 0
                        && (this.luminaireLineProducts.remote_controls.find(luminaire_control => luminaire_control.id === this.luminaireLineFormFields.type_of_remote_controls)
                            || this.findProductAlternative(this.luminaireLineFormFields.type_of_remote_controls) )
                    ) {

                        let selectedRemoteControl = this.luminaireLineProducts.remote_controls.find(luminaire_control => luminaire_control.id === this.luminaireLineFormFields.type_of_remote_controls)
                            ? this.luminaireLineProducts.remote_controls.find(luminaire_control => luminaire_control.id === this.luminaireLineFormFields.type_of_remote_controls)
                            : this.findProductAlternative(this.luminaireLineFormFields.type_of_remote_controls);

                        this.luminaireLinePrices.price_of_remote_controls['title'] = selectedRemoteControl.title;
                        this.luminaireLinePrices.price_of_remote_controls['quantity'] = this.luminaireLineFormFields.number_of_remote_controls;
                        this.luminaireLinePrices.price_of_remote_controls['price'] = this.luminaireLineFormFields.number_of_remote_controls * selectedRemoteControl.price;

                    } else {
                        this.luminaireLinePrices.price_of_remote_controls['title'] = '';
                        this.luminaireLinePrices.price_of_remote_controls['quantity'] = 0;
                        this.luminaireLinePrices.price_of_remote_controls['price'] = 0;
                    }

                    // universal_adapter_lg
                    if (this.luminaireLineFormFields.type_of_universal_adapters_lg && this.luminaireLineFormFields.number_of_universal_adapters_lg > 0 && this.luminaireLineProducts.universal_adapters.find(universal_adapter => universal_adapter.id === this.luminaireLineFormFields.type_of_universal_adapters_lg)) {
                        let selectedUniversalAdapter = this.luminaireLineProducts.universal_adapters.find(universal_adapter => universal_adapter.id === this.luminaireLineFormFields.type_of_universal_adapters_lg);

                        this.luminaireLinePrices.price_of_universal_adapters_lg['title'] = selectedUniversalAdapter.title;
                        this.luminaireLinePrices.price_of_universal_adapters_lg['quantity'] = this.luminaireLineFormFields.number_of_universal_adapters_lg;
                        this.luminaireLinePrices.price_of_universal_adapters_lg['price'] = this.luminaireLineFormFields.number_of_universal_adapters_lg * selectedUniversalAdapter.price;
                    } else {
                        this.luminaireLinePrices.price_of_universal_adapters_lg['title'] = '';
                        this.luminaireLinePrices.price_of_universal_adapters_lg['quantity'] = 0;
                        this.luminaireLinePrices.price_of_universal_adapters_lg['price'] = 0;
                    }

                    // universal_adapter_sm
                    if (this.luminaireLineFormFields.type_of_universal_adapters_sm && this.luminaireLineFormFields.number_of_universal_adapters_sm > 0 && this.luminaireLineProducts.universal_adapters.find(universal_adapter => universal_adapter.id === this.luminaireLineFormFields.type_of_universal_adapters_sm)) {

                        let selectedUniversalAdapter = this.luminaireLineProducts.universal_adapters.find(universal_adapter => universal_adapter.id === this.luminaireLineFormFields.type_of_universal_adapters_sm);

                        this.luminaireLinePrices.price_of_universal_adapters_sm['title'] = selectedUniversalAdapter.title;
                        this.luminaireLinePrices.price_of_universal_adapters_sm['quantity'] = this.luminaireLineFormFields.number_of_universal_adapters_sm;
                        this.luminaireLinePrices.price_of_universal_adapters_sm['price'] = this.luminaireLineFormFields.number_of_universal_adapters_sm * selectedUniversalAdapter.price;
                    } else {
                        this.luminaireLinePrices.price_of_universal_adapters_sm['title'] = '';
                        this.luminaireLinePrices.price_of_universal_adapters_sm['quantity'] = 0;
                        this.luminaireLinePrices.price_of_universal_adapters_sm['price'] = 0;
                    }

                    // universal_connector
                    if (this.luminaireLineFormFields.type_of_universal_connectors
                        && this.luminaireLineFormFields.number_of_universal_connectors > 0
                        && ( this.luminaireLineProducts.universal_connectors.find(universal_connector => universal_connector.id === this.luminaireLineFormFields.type_of_universal_connectors)
                            || this.findProductAlternative(this.luminaireLineFormFields.type_of_universal_connectors) )
                    ) {

                        let selectedUniversalConnector = this.luminaireLineProducts.universal_connectors.find(universal_connector => universal_connector.id === this.luminaireLineFormFields.type_of_universal_connectors)
                            ? this.luminaireLineProducts.universal_connectors.find(universal_connector => universal_connector.id === this.luminaireLineFormFields.type_of_universal_connectors)
                            : this.findProductAlternative(this.luminaireLineFormFields.type_of_universal_connectors);

                        this.luminaireLineFormFields.type_of_universal_connectors = selectedUniversalConnector.id;

                        this.luminaireLinePrices.price_of_universal_connectors['title'] = selectedUniversalConnector.title;
                        this.luminaireLinePrices.price_of_universal_connectors['quantity'] = this.luminaireLineFormFields.number_of_universal_connectors;
                        this.luminaireLinePrices.price_of_universal_connectors['price'] = this.luminaireLineFormFields.number_of_universal_connectors * selectedUniversalConnector.price;

                    } else {
                        this.luminaireLinePrices.price_of_universal_connectors['title'] = '';
                        this.luminaireLinePrices.price_of_universal_connectors['quantity'] = 0;
                        this.luminaireLinePrices.price_of_universal_connectors['price'] = 0;
                    }

                    // universal_connector_v2
                    if (this.luminaireLineFormFields.type_of_universal_connectors_v2
                        && this.luminaireLineFormFields.number_of_universal_connectors_v2 > 0
                        && ( this.luminaireLineProducts.universal_connectors.find(universal_connector => universal_connector.id === this.luminaireLineFormFields.type_of_universal_connectors_v2)
                            || this.findProductAlternative(this.luminaireLineFormFields.type_of_universal_connectors_v2) )
                    ) {
                        let selectedUniversalConnector = this.luminaireLineProducts.universal_connectors.find(universal_connector => universal_connector.id === this.luminaireLineFormFields.type_of_universal_connectors_v2)
                            ? this.luminaireLineProducts.universal_connectors.find(universal_connector => universal_connector.id === this.luminaireLineFormFields.type_of_universal_connectors_v2)
                            : this.findProductAlternative(this.luminaireLineFormFields.type_of_universal_connectors_v2);

                        this.luminaireLineFormFields.type_of_universal_connectors_v2 = selectedUniversalConnector.id;

                        this.luminaireLinePrices.price_of_universal_connectors_v2['title'] = selectedUniversalConnector.title;
                        this.luminaireLinePrices.price_of_universal_connectors_v2['quantity'] = this.luminaireLineFormFields.number_of_universal_connectors_v2;
                        this.luminaireLinePrices.price_of_universal_connectors_v2['price'] = this.luminaireLineFormFields.number_of_universal_connectors_v2 * selectedUniversalConnector.price;

                    } else {
                        this.luminaireLinePrices.price_of_universal_connectors_v2['title'] = '';
                        this.luminaireLinePrices.price_of_universal_connectors_v2['quantity'] = 0;
                        this.luminaireLinePrices.price_of_universal_connectors_v2['price'] = 0;
                    }

                    // universal_connector_v3
                    if (this.luminaireLineFormFields.type_of_universal_connectors_v3
                        && this.luminaireLineFormFields.number_of_universal_connectors_v3 > 0
                        && ( this.luminaireLineProducts.universal_connectors.find(universal_connector => universal_connector.id === this.luminaireLineFormFields.type_of_universal_connectors_v3)
                            || this.findProductAlternative(this.luminaireLineFormFields.type_of_universal_connectors_v3) )
                    ) {

                        let selectedUniversalConnector = this.luminaireLineProducts.universal_connectors.find(universal_connector => universal_connector.id === this.luminaireLineFormFields.type_of_universal_connectors_v3)
                            ? this.luminaireLineProducts.universal_connectors.find(universal_connector => universal_connector.id === this.luminaireLineFormFields.type_of_universal_connectors_v3)
                            : this.findProductAlternative(this.luminaireLineFormFields.type_of_universal_connectors_v3);

                        this.luminaireLineFormFields.type_of_universal_connectors_v3 = selectedUniversalConnector.id;

                        this.luminaireLinePrices.price_of_universal_connectors_v3['title'] = selectedUniversalConnector.title;
                        this.luminaireLinePrices.price_of_universal_connectors_v3['quantity'] = this.luminaireLineFormFields.number_of_universal_connectors_v3;
                        this.luminaireLinePrices.price_of_universal_connectors_v3['price'] = this.luminaireLineFormFields.number_of_universal_connectors_v3 * selectedUniversalConnector.price;

                    } else {
                        this.luminaireLinePrices.price_of_universal_connectors_v3['title'] = '';
                        this.luminaireLinePrices.price_of_universal_connectors_v3['quantity'] = 0;
                        this.luminaireLinePrices.price_of_universal_connectors_v3['price'] = 0;
                    }

                    // universal_connector_submodule
                    if (this.luminaireLineFormFields.type_of_universal_connector_submodules
                        && this.luminaireLineFormFields.number_of_universal_connector_submodules > 0
                        && ( this.luminaireLineProducts.universal_connector_submodules.find(universal_connector => universal_connector.id === this.luminaireLineFormFields.type_of_universal_connector_submodules)
                            || this.findProductAlternative(this.luminaireLineFormFields.type_of_universal_connector_submodules) )
                    ) {

                        let selectedUniversalConnectorSubmodule = this.luminaireLineProducts.universal_connector_submodules.find(universal_connector => universal_connector.id === this.luminaireLineFormFields.type_of_universal_connector_submodules)
                            ? this.luminaireLineProducts.universal_connector_submodules.find(universal_connector => universal_connector.id === this.luminaireLineFormFields.type_of_universal_connector_submodules)
                            : this.findProductAlternative(this.luminaireLineFormFields.type_of_universal_connector_submodules);

                        this.luminaireLineFormFields.type_of_universal_connector_submodules = selectedUniversalConnectorSubmodule.id;

                        this.luminaireLinePrices.price_of_universal_connector_submodules['title'] = selectedUniversalConnectorSubmodule.title;
                        this.luminaireLinePrices.price_of_universal_connector_submodules['quantity'] = this.luminaireLineFormFields.number_of_universal_connector_submodules;
                        this.luminaireLinePrices.price_of_universal_connector_submodules['price'] = this.luminaireLineFormFields.number_of_universal_connector_submodules * selectedUniversalConnectorSubmodule.price;

                    } else {
                        this.luminaireLinePrices.price_of_universal_connector_submodules['title'] = '';
                        this.luminaireLinePrices.price_of_universal_connector_submodules['quantity'] = 0;
                        this.luminaireLinePrices.price_of_universal_connector_submodules['price'] = 0;
                    }

                    // universal_connector_submodule_v2
                    if (this.luminaireLineFormFields.type_of_universal_connector_submodules_v2
                        && this.luminaireLineFormFields.number_of_universal_connector_submodules_v2 > 0
                        && ( this.luminaireLineProducts.universal_connector_submodules.find(universal_connector => universal_connector.id === this.luminaireLineFormFields.type_of_universal_connector_submodules_v2)
                            || this.findProductAlternative(this.luminaireLineFormFields.type_of_universal_connector_submodules_v2) )
                    ) {
                        let selectedUniversalConnectorSubmoduleV2 = this.luminaireLineProducts.universal_connector_submodules.find(universal_connector => universal_connector.id === this.luminaireLineFormFields.type_of_universal_connector_submodules_v2)
                            ? this.luminaireLineProducts.universal_connector_submodules.find(universal_connector => universal_connector.id === this.luminaireLineFormFields.type_of_universal_connector_submodules_v2)
                            : this.findProductAlternative(this.luminaireLineFormFields.type_of_universal_connector_submodules_v2);

                        this.luminaireLineFormFields.type_of_universal_connector_submodules_v2 = selectedUniversalConnectorSubmoduleV2.id;

                        this.luminaireLinePrices.price_of_universal_connector_submodules_v2['title'] = selectedUniversalConnectorSubmoduleV2.title;
                        this.luminaireLinePrices.price_of_universal_connector_submodules_v2['quantity'] = this.luminaireLineFormFields.number_of_universal_connector_submodules_v2;
                        this.luminaireLinePrices.price_of_universal_connector_submodules_v2['price'] = this.luminaireLineFormFields.number_of_universal_connector_submodules_v2 * selectedUniversalConnectorSubmoduleV2.price;

                    } else {
                        this.luminaireLinePrices.price_of_universal_connector_submodules_v2['title'] = '';
                        this.luminaireLinePrices.price_of_universal_connector_submodules_v2['quantity'] = 0;
                        this.luminaireLinePrices.price_of_universal_connector_submodules_v2['price'] = 0;
                    }

                    // universal_connector_submodule_v3
                    if (this.luminaireLineFormFields.type_of_universal_connector_submodules_v3
                        && this.luminaireLineFormFields.number_of_universal_connector_submodules_v3 > 0
                        && ( this.luminaireLineProducts.universal_connector_submodules.find(universal_connector => universal_connector.id === this.luminaireLineFormFields.type_of_universal_connector_submodules_v3)
                            || this.findProductAlternative(this.luminaireLineFormFields.type_of_universal_connector_submodules_v3) )
                    ) {

                        let selectedUniversalConnectorSubmoduleV3 = this.luminaireLineProducts.universal_connector_submodules.find(universal_connector => universal_connector.id === this.luminaireLineFormFields.type_of_universal_connector_submodules_v3)
                            ? this.luminaireLineProducts.universal_connector_submodules.find(universal_connector => universal_connector.id === this.luminaireLineFormFields.type_of_universal_connector_submodules_v3)
                            : this.findProductAlternative(this.luminaireLineFormFields.type_of_universal_connector_submodules_v3);

                        this.luminaireLineFormFields.type_of_universal_connector_submodules_v3 = selectedUniversalConnectorSubmoduleV3.id;

                        this.luminaireLinePrices.price_of_universal_connector_submodules_v3['title'] = selectedUniversalConnectorSubmoduleV3.title;
                        this.luminaireLinePrices.price_of_universal_connector_submodules_v3['quantity'] = this.luminaireLineFormFields.number_of_universal_connector_submodules_v3;
                        this.luminaireLinePrices.price_of_universal_connector_submodules_v3['price'] = this.luminaireLineFormFields.number_of_universal_connector_submodules_v3 * selectedUniversalConnectorSubmoduleV3.price;

                    } else {
                        this.luminaireLinePrices.price_of_universal_connector_submodules_v3['title'] = '';
                        this.luminaireLinePrices.price_of_universal_connector_submodules_v3['quantity'] = 0;
                        this.luminaireLinePrices.price_of_universal_connector_submodules_v3['price'] = 0;
                    }

                    // connecting_cable
                    if (this.luminaireLineFormFields.type_of_connecting_cable
                        && this.luminaireLineFormFields.number_of_connecting_cable > 0
                        && ( this.luminaireLineProducts.connecting_cable.find(connecting_cable => connecting_cable.id === this.luminaireLineFormFields.type_of_connecting_cable)
                            || this.findProductAlternative(this.luminaireLineFormFields.type_of_connecting_cable) )
                    ) {

                        let selectedConnectingCable = this.luminaireLineProducts.connecting_cable.find(connecting_cable => connecting_cable.id === this.luminaireLineFormFields.type_of_connecting_cable)
                            ? this.luminaireLineProducts.connecting_cable.find(connecting_cable => connecting_cable.id === this.luminaireLineFormFields.type_of_connecting_cable)
                            : this.findProductAlternative(this.luminaireLineFormFields.type_of_connecting_cable);

                        this.luminaireLineFormFields.type_of_connecting_cable = selectedConnectingCable.id;

                        this.luminaireLinePrices.price_of_connecting_cable['title'] = selectedConnectingCable.title;
                        this.luminaireLinePrices.price_of_connecting_cable['quantity'] = this.luminaireLineFormFields.number_of_connecting_cable;
                        this.luminaireLinePrices.price_of_connecting_cable['price'] = this.luminaireLineFormFields.number_of_connecting_cable * selectedConnectingCable.price;

                    } else {
                        this.luminaireLinePrices.price_of_connecting_cable['title'] = '';
                        this.luminaireLinePrices.price_of_connecting_cable['quantity'] = 0;
                        this.luminaireLinePrices.price_of_connecting_cable['price'] = 0;
                    }

                    // connecting_cable_middle
                    if (this.luminaireLineFormFields.type_of_connecting_cable_middle
                        && this.luminaireLineFormFields.number_of_connecting_cable_middle > 0
                        && ( this.luminaireLineProducts.connecting_cable_middle.find(connecting_cable_middle => connecting_cable_middle.id === this.luminaireLineFormFields.type_of_connecting_cable_middle)
                            || this.findProductAlternative(this.luminaireLineFormFields.type_of_connecting_cable_middle) )
                    ) {
                        let selectedConnectingCableMiddle = this.luminaireLineProducts.connecting_cable_middle.find(connecting_cable_middle => connecting_cable_middle.id === this.luminaireLineFormFields.type_of_connecting_cable_middle)
                            ? this.luminaireLineProducts.connecting_cable_middle.find(connecting_cable_middle => connecting_cable_middle.id === this.luminaireLineFormFields.type_of_connecting_cable_middle)
                            : this.findProductAlternative(this.luminaireLineFormFields.type_of_connecting_cable_middle);

                        this.luminaireLineFormFields.type_of_connecting_cable_middle = selectedConnectingCableMiddle.id;

                        this.luminaireLinePrices.price_of_connecting_cable_middle['title'] = selectedConnectingCableMiddle.title;
                        this.luminaireLinePrices.price_of_connecting_cable_middle['quantity'] = this.luminaireLineFormFields.number_of_connecting_cable_middle;
                        this.luminaireLinePrices.price_of_connecting_cable_middle['price'] = this.luminaireLineFormFields.number_of_connecting_cable_middle * selectedConnectingCableMiddle.price;

                    } else {
                        this.luminaireLinePrices.price_of_connecting_cable_middle['title'] = '';
                        this.luminaireLinePrices.price_of_connecting_cable_middle['quantity'] = 0;
                        this.luminaireLinePrices.price_of_connecting_cable_middle['price'] = 0;
                    }

                    // Cable Route
                    if (this.cableRouteYesOrNo) {
                        // Cable Routes 168cm
                        if ( this.luminaireLineFormFields.number_of_cable_routes_168 > 0 ) {
                            let selectedCableRoute = this.luminaireLineProducts.cable_routes.find(element => element.id === this.luminaireLineFormFields.type_of_cable_route_168);

                            this.luminaireLinePrices.price_of_cable_routes_168['title'] = selectedCableRoute.title;
                            this.luminaireLinePrices.price_of_cable_routes_168['quantity'] = this.luminaireLineFormFields.number_of_cable_routes_168;
                            this.luminaireLinePrices.price_of_cable_routes_168['price'] = this.luminaireLineFormFields.number_of_cable_routes_168 * selectedCableRoute.price;
                        }

                        // Cable Routes 336cm
                        if ( this.luminaireLineFormFields.number_of_cable_routes_336 > 0 ) {
                            let selectedCableRoute = this.luminaireLineProducts.cable_routes.find(element => element.id === this.luminaireLineFormFields.type_of_cable_route_336);

                            this.luminaireLinePrices.price_of_cable_routes_336['title'] = selectedCableRoute.title;
                            this.luminaireLinePrices.price_of_cable_routes_336['quantity'] = this.luminaireLineFormFields.number_of_cable_routes_336;
                            this.luminaireLinePrices.price_of_cable_routes_336['price'] = this.luminaireLineFormFields.number_of_cable_routes_336 * selectedCableRoute.price;
                        }

                        // Cable Routes 504cm
                        if ( this.luminaireLineFormFields.number_of_cable_routes_504 > 0 ) {
                            let selectedCableRoute = this.luminaireLineProducts.cable_routes.find(element => element.id === this.luminaireLineFormFields.type_of_cable_route_504);
                            this.luminaireLinePrices.price_of_cable_routes_504['title'] = selectedCableRoute.title;
                            this.luminaireLinePrices.price_of_cable_routes_504['quantity'] = this.luminaireLineFormFields.number_of_cable_routes_504;
                            this.luminaireLinePrices.price_of_cable_routes_504['price'] = this.luminaireLineFormFields.number_of_cable_routes_504 * selectedCableRoute.price;
                        }
                    } else {
                        this.luminaireLinePrices.price_of_cable_routes_168['title'] = '';
                        this.luminaireLinePrices.price_of_cable_routes_168['quantity'] = 0;
                        this.luminaireLinePrices.price_of_cable_routes_168['price'] = 0;

                        this.luminaireLinePrices.price_of_cable_routes_336['title'] = '';
                        this.luminaireLinePrices.price_of_cable_routes_336['quantity'] = 0;
                        this.luminaireLinePrices.price_of_cable_routes_336['price'] = 0;

                        this.luminaireLinePrices.price_of_cable_routes_504['title'] = '';
                        this.luminaireLinePrices.price_of_cable_routes_504['quantity'] = 0;
                        this.luminaireLinePrices.price_of_cable_routes_504['price'] = 0;

                    }

                    // Special Products

                    // remove all objects from this.luiminaireLinePrices starting with price_of_special_products
                    Object.keys(this.luminaireLinePrices).forEach(key => {
                        if (key.includes('price_of_special_products')) {
                            delete this.luminaireLinePrices[key];
                        }
                    });

                    if (this.luminaireLineFormFields.special_products && this.luminaireLineFormFields.special_products.length > 0) {

                        this.luminaireLineFormFields.special_products.forEach((specialProduct, index) => {
                            if (specialProduct && specialProduct.quantity > 0) {
                                this.luminaireLinePrices[`price_of_special_products_${index + 1}`] = {
                                    'title': 'Special Product:' + specialProduct.sku,
                                    'quantity': specialProduct.quantity,
                                    'price': specialProduct.price
                                };
                            } else {
                                this.luminaireLinePrices[`price_of_special_products_${index + 1}`] = {
                                    'title': '',
                                    'quantity': 0,
                                    'price': 0
                                };
                            }
                        });
                    }

                    this.calculatePlanningPrice();

                    // warranties – MUST BE AT END
                    if (this.luminaireLineFormFields.type_of_warranties && this.luminaireLineFormFields.number_of_warranties > 0 ) {
                        let selectedWarranty = this.luminaireLineProducts.warranties.find(warranty => warranty.id === this.luminaireLineFormFields.type_of_warranties);

                        this.luminaireLinePrices.price_of_warranties['title'] = selectedWarranty.title;
                        this.luminaireLinePrices.price_of_warranties['quantity'] = this.luminaireLineFormFields.number_of_warranties;
                        this.luminaireLinePrices.price_of_warranties['price'] = this.getWarrantyPrice(this.calculatedPlanningPrice, selectedWarranty.price);
                    } else {
                        this.luminaireLinePrices.price_of_warranties['title'] = '';
                        this.luminaireLinePrices.price_of_warranties['quantity'] = 0;
                        this.luminaireLinePrices.price_of_warranties['price'] = 0;
                    }

                }

            },

            calculateExactLength() {
                let length_suggestion_in_cm = this.luminaireLineFormFields.lumination_length_suggestion * 100;

                if ( length_suggestion_in_cm <= 168 ) {
                    this.calculatedExactLength = 168;
                } else {
                    this.calculatedExactLength = Math.floor(length_suggestion_in_cm / 168 ) * 168;
                }
            },

            getMountingRailTypeSuggestions() {

                this.mountingRailTypeSuggestions = {
                    optimal: this.getOptimalMountingRails(this.luminaireLineFormFields.lumination_length, [this.helpers.mountingRail504Length, this.helpers.mountingRail336Length, this.helpers.mountingRail168Length]),
                    second: this.arraysEqual(this.getOptimalMountingRails(this.luminaireLineFormFields.lumination_length, [this.helpers.mountingRail336Length, this.helpers.mountingRail168Length]), this.getOptimalMountingRails(this.luminaireLineFormFields.lumination_length, [this.helpers.mountingRail504Length, this.helpers.mountingRail336Length, this.helpers.mountingRail168Length]))
                        ? null
                        : this.getOptimalMountingRails(this.luminaireLineFormFields.lumination_length, [this.helpers.mountingRail336Length, this.helpers.mountingRail168Length]),
                    third:  this.arraysEqual(this.getOptimalMountingRails(this.luminaireLineFormFields.lumination_length, [this.helpers.mountingRail168Length]), this.getOptimalMountingRails(this.luminaireLineFormFields.lumination_length, [this.helpers.mountingRail336Length, this.helpers.mountingRail168Length]))
                    || this.arraysEqual(this.getOptimalMountingRails(this.luminaireLineFormFields.lumination_length, [this.helpers.mountingRail168Length]), this.getOptimalMountingRails(this.luminaireLineFormFields.lumination_length, [this.helpers.mountingRail504Length, this.helpers.mountingRail336Length, this.helpers.mountingRail168Length]))
                        ? null
                        : this.getOptimalMountingRails(this.luminaireLineFormFields.lumination_length, [this.helpers.mountingRail168Length]),
                };

                if (!this.selectedMountingRailTypeSuggestion && !this.editPlanning) {
                    this.selectedMountingRailTypeSuggestion = 'optimal';
                }
            },

            getMountingRailPrice(neededMountingRails) {

                if (!neededMountingRails || neededMountingRails.length === 0
                    || (this.product_configurator_id === 1 && !this.luminaireLineProducts.mountingrails)
                    || (this.product_configurator_id === 1 && this.luminaireLineProducts.mountingrails.length === 0)
                    || (this.product_configurator_id === 3 && !this.luminaireLineProducts.mountingrails_with_connectors)
                    || (this.product_configurator_id === 3 && this.luminaireLineProducts.mountingrails_with_connectors.length === 0)
                ) {
                    return null;
                }

                return neededMountingRails.map(({ luminationType, counter }) => {


                    if (this.product_configurator_id === 1) {
                        return this.luminaireLineProducts.mountingrails
                            .find(mountingRail => mountingRail.size_x === luminationType).price * counter;
                    }

                    // cheapest possible price
                    if (this.product_configurator_id === 3) {
                        return this.luminaireLineProducts.mountingrails_with_connectors
                            .filter(el => el.product_subtype === 'mounting_rail_0_connectors')
                            .find(mountingRail => mountingRail.size_x === luminationType).price * counter;
                    }

                    }).reduce(this.sum).toFixed(2);
            },

            checkIfFirstMountingRailOfThisLength(length) {
                if (!this.luminaireLineProducts.mountingrails_with_connectors) {
                    return false;
                }

                // get the index of the first mounting rail of this length
                return this.luminaireLineProducts.mountingrails_with_connectors
                    .findIndex(el => el.size_x === length);

            },

            setNumberOfMountingRails() {

                // Set option if mounting rails already set (e.g. edit planning)
                if (!this.selectedMountingRailTypeSuggestion && (this.getTotalQuantityOfMountingRails() > 0)) {
                    let mountingRailConfiguration = [];

                    if (this.getTotalQuantityOfMountingRails(504) > 0) {
                        mountingRailConfiguration.push({
                            counter: this.getTotalQuantityOfMountingRails(504) ? this.getTotalQuantityOfMountingRails(504) : 0,
                            luminationType: 504
                        });
                    }

                    if (this.getTotalQuantityOfMountingRails(336) > 0) {
                        mountingRailConfiguration.push({
                            counter: this.getTotalQuantityOfMountingRails(336) ? this.getTotalQuantityOfMountingRails(336) : 0,
                            luminationType: 336
                        });
                    }

                    if (this.getTotalQuantityOfMountingRails(168) > 0 ) {
                        mountingRailConfiguration.push({
                            counter: this.getTotalQuantityOfMountingRails(168) ? this.getTotalQuantityOfMountingRails(168) : 0,
                            luminationType: 168
                        });
                    }

                    for (const [key, value] of Object.entries(this.mountingRailTypeSuggestions)) {

                        if (!key || !value) {
                            continue;
                        }

                        if (this.arraysEqual(mountingRailConfiguration, value)) {
                            this.selectedMountingRailTypeSuggestion = key;
                        }
                    }

                }

                let mountingRails = this.mountingRailTypeSuggestions[this.selectedMountingRailTypeSuggestion];

                if (!mountingRails) return;

                if (this.product_configurator_id === 1) {
                    let number_of_mounting_rail_504 = mountingRails.find( element => element.luminationType === this.helpers.mountingRail504Length) ? mountingRails.find( element => element.luminationType === this.helpers.mountingRail504Length) : 0;
                    let number_of_mounting_rail_336 = mountingRails.find( element => element.luminationType === this.helpers.mountingRail336Length) ? mountingRails.find( element => element.luminationType === this.helpers.mountingRail336Length) : 0;
                    let number_of_mounting_rail_168 = mountingRails.find( element => element.luminationType === this.helpers.mountingRail168Length) ? mountingRails.find( element => element.luminationType === this.helpers.mountingRail168Length) : 0;

                    // Set needed Modules
                    this.luminaireLineFormFields.number_of_mounting_rail_504 = number_of_mounting_rail_504.counter ? number_of_mounting_rail_504.counter : 0;
                    this.luminaireLineFormFields.number_of_mounting_rail_336 = number_of_mounting_rail_336.counter ? number_of_mounting_rail_336.counter : 0;
                    this.luminaireLineFormFields.number_of_mounting_rail_168 = number_of_mounting_rail_168.counter ? number_of_mounting_rail_168.counter : 0;
                }

                // Set Number of mounting rails total
                this.setNumberOfMountingRailsTotal();

                // Number of Modules (LED & Blind)
                if (this.product_configurator_id === 1) {
                    this.setNumberOfModulesTotal((this.getTotalQuantityOfMountingRails(504) * 3) + (this.getTotalQuantityOfMountingRails(336) * 2) + this.getTotalQuantityOfMountingRails(168));
                }
            },

            setNumberOfMountingRailsTotal() {
                this.luminaireLineFormFields.number_of_mounting_rails_total = this.getTotalQuantityOfMountingRails();
            },

            getMissingMountingRailsByType(mounting_rail_type) {

                if (!this.selectedMountingRailTypeSuggestion || !this.mountingRailTypeSuggestions[this.selectedMountingRailTypeSuggestion] || !mounting_rail_type) {
                    return 0;
                }

                let neededMountingRails = this.mountingRailTypeSuggestions[this.selectedMountingRailTypeSuggestion].find( element => element.luminationType === mounting_rail_type);

                return {
                    needed: neededMountingRails ? Number(neededMountingRails.counter) : 0,
                    missing: neededMountingRails ? Number(neededMountingRails.counter) - this.getTotalQuantityOfMountingRails(mounting_rail_type) : 0
                };

            },

            getOptimalMountingRails (luminairLineLength, railLength) {

                if (this.product_configurator_id === 1) {
                    this.setNumberOfModulesTotal(this.luminaireLineFormFields.lumination_length / 168);
                    if (this.luminaireLineFormFields.number_of_led_modules > this.luminaireLineFormFields.number_of_modules_total) {
                        this.luminaireLineFormFields.number_of_led_modules = this.luminaireLineFormFields.number_of_modules_total;
                    }
                }

                let result = [];

                if (this.luminaireLineFormFields.number_of_emergency_lights > 0) {
                    if (this.luminaireLineFormFields.number_of_emergency_lights > this.luminaireLineFormFields.number_of_led_modules) {
                        this.luminaireLineFormFields.number_of_emergency_lights = this.luminaireLineFormFields.number_of_led_modules;
                    }

                    // todo patrick: abfragen ob eigenes mounting rail, ansonsten ignorieren

                    if (this.luminaireLineFormFields.emergency_light_standalone) {

                        result.push({
                            'luminationType': 168,
                            'counter': this.luminaireLineFormFields.number_of_emergency_lights
                        });

                        luminairLineLength -= 168 * Number(this.luminaireLineFormFields.number_of_emergency_lights);
                    }

                }

                for (let i = 0; i < railLength.length; i++) {
                    let counter = 0;
                    while (luminairLineLength >= railLength[i]) {
                        counter++;
                        luminairLineLength -= railLength[i];
                    }
                    if (counter > 0) {

                        if (result.find(el => el.luminationType === railLength[i]) ) {
                            result.find(el => el.luminationType === railLength[i]).counter += counter;
                        } else {
                            result.push({
                                'luminationType': railLength[i],
                                'counter': counter
                            });
                        }

                    }

                }

                return result.sort((a, b) => b.luminationType - a.luminationType);
            },

            setTotalLuminationLineLength() {
                let startingTotalLength = this.luminaireLineFormFields.total_lumination_line_length;
                this.luminaireLineFormFields.total_lumination_line_length = this.luminaireLineFormFields.lumination_length;

                const calculateLength = (numberField, typeField, productField) => {
                    if (this.luminaireLineFormFields[numberField] > 0 && this.luminaireLineFormFields[typeField]) {
                        const product = this.luminaireLineProducts[productField].find(element => element.id === this.luminaireLineFormFields[typeField]);
                        this.luminaireLineFormFields.total_lumination_line_length += this.luminaireLineFormFields[numberField] * product.size_x;
                    }
                };


                calculateLength('number_of_electrical_feeds_middle', 'type_of_electrical_feeds_middle',  'electrical_feeds');
                calculateLength('number_of_universal_connectors', 'type_of_universal_connectors',  'universal_connectors');
                calculateLength('number_of_universal_connectors_v2', 'type_of_universal_connectors_v2',  'universal_connectors');
                calculateLength('number_of_universal_connectors_v3', 'type_of_universal_connectors_v3',  'universal_connectors');
                calculateLength('number_of_luminaire_controls', 'type_of_luminaire_control',  'luminaire_controls');
                calculateLength('number_of_luminaire_control_slaves', 'type_of_luminaire_control_slave',  'luminaire_controls');

                if (startingTotalLength > 0 && this.luminaireLineFormFields.total_lumination_line_length > 0 && startingTotalLength !== this.luminaireLineFormFields.total_lumination_line_length && this.luminaireLineFormFields.total_lumination_line_length !== this.luminaireLineFormFields.lumination_length) {

                    let diff = this.luminaireLineFormFields.total_lumination_line_length - startingTotalLength;

                    this.$swal.fire({
                        icon: 'info',
                        title: this.$t('Change of total length'),
                        text: diff > 0 ? this.$t('The total length has increased by ') + (diff  / 100) + 'm' : this.$t('The total length has decreased by ') + (diff * -1  / 100) + 'm',
                        confirmButtonColor: '#3085d6',
                    });

                }

            },

            setNumberOfModulesTotal(numberOfModules) {
                this.luminaireLineFormFields.number_of_modules_total = numberOfModules;
            },

            setNumberOfLuminaireControls() {

                // CASAMBI Typ 10: ID 25, 44, 89, 90
                if (this.luminaireLineFormFields.type_of_luminaire_control
                    && this.luminaireLineFormFields.number_of_led_modules > 0
                    && this.productIsSubtype(this.luminaireLineFormFields.type_of_luminaire_control, 'casambi_10'))
                {
                    this.integratedSensorYesOrNo = false;
                    this.standAloneSensorYesOrNo = false;

                    this.luminaireLineFormFields.number_of_luminaire_controls = Math.ceil((this.luminaireLineFormFields.number_of_led_modules / 10));
                }

                // CASAMBI Typ 60: ID 45, 46, 91, 92
                if (this.luminaireLineFormFields.type_of_luminaire_control
                    && this.luminaireLineFormFields.number_of_led_modules > 0
                    && this.productIsSubtype(this.luminaireLineFormFields.type_of_luminaire_control, 'casambi_60') )
                {
                    this.integratedSensorYesOrNo = false;
                    this.standAloneSensorYesOrNo = false;

                    this.luminaireLineFormFields.number_of_luminaire_controls = Math.ceil((this.luminaireLineFormFields.number_of_led_modules / 60));
                }

                // Enlighted: ID 212, 213
                if (this.luminaireLineFormFields.type_of_luminaire_control
                    && this.luminaireLineFormFields.number_of_led_modules > 0
                    && this.productIsSubtype(this.luminaireLineFormFields.type_of_luminaire_control, 'enlighted'))
                {
                    this.integratedSensorYesOrNo = false;
                    this.standAloneSensorYesOrNo = false;

                    this.luminaireLineFormFields.number_of_luminaire_controls = this.luminaireLineFormFields.number_of_mounting_rails_total;
                }

                // NEDAP: ID 26, 64, 93, 94
                if (this.luminaireLineFormFields.type_of_luminaire_control
                    && this.luminaireLineFormFields.number_of_led_modules > 0
                    && this.productIsSubtype(this.luminaireLineFormFields.type_of_luminaire_control, 'nedap') )
                {
                    this.integratedSensorYesOrNo = false;
                    this.standAloneSensorYesOrNo = false;

                    this.luminaireLineFormFields.number_of_luminaire_controls = this.getTotalQuantityOfMountingRails();
                }


                // Presence detectors
                if (this.luminaireControlIsPresenceDetector(this.luminaireLineFormFields.type_of_luminaire_control) && this.luminaireLineFormFields.number_of_luminaire_controls > 1) {
                    // Check if is presence detector && if > 1 then add slaves
                    let diff = this.luminaireLineFormFields.number_of_luminaire_controls - 1;

                    this.luminaireLineFormFields.number_of_luminaire_controls = 1;
                    this.luminaireLineFormFields.number_of_luminaire_control_slaves = diff <= 3 ? diff : 3;
                }

                if (this.luminaireLineFormFields.type_of_luminaire_control && !this.luminaireControlIsPresenceDetector(this.luminaireLineFormFields.type_of_luminaire_control)) {
                    this.luminaireLineFormFields.number_of_luminaire_control_slaves = 0;
                }

            },

            setTypeOfLuminaireControls() {

                if (this.standAloneSensorYesOrNo
                    && (!this.luminaireLineFormFields.type_of_luminaire_control || this.getProductType(this.luminaireLineFormFields.type_of_luminaire_control, 'subtype') !== 'presence_detector')
                    && this.luminaireLineFormFields.number_of_luminaire_controls > 0)
                {
                    this.luminaireLineFormFields.type_of_luminaire_control = this.luminaireLineProducts.luminaire_controls.find(product => product.product_type === 'luminaire_control' && product.product_subtype === 'presence_detector')?.id;
                } else if (this.luminaireLineFormFields.number_of_luminaire_controls === 0) {
                    this.luminaireLineFormFields.type_of_luminaire_control = '';
                }

                if (this.standAloneSensorYesOrNo && this.luminaireLineFormFields.number_of_luminaire_control_slaves > 0) {
                    this.luminaireLineFormFields.type_of_luminaire_control_slave = this.luminaireLineProducts.luminaire_controls.find(product => product.product_type === 'luminaire_control' && product.product_subtype === 'presence_detector_slave')?.id;
                } else {
                    this.luminaireLineFormFields.type_of_luminaire_control_slave = '';
                }

                if (this.integratedSensorYesOrNo && this.luminaireLineFormFields.number_of_luminaire_control_submodules > 0) {
                    this.luminaireLineFormFields.type_of_luminaire_control_submodule = this.luminaireLineProducts.luminaire_control_submodules.find(product => product.product_type === 'luminaire_control_submodule' && product.product_subtype === 'presence_detector')?.id;
                } else {
                    this.luminaireLineFormFields.type_of_luminaire_control_submodule = '';
                }

                if (this.integratedSensorYesOrNo && this.luminaireLineFormFields.number_of_luminaire_control_submodule_slaves > 0) {
                    this.luminaireLineFormFields.type_of_luminaire_control_submodule_slave = this.luminaireLineProducts.luminaire_control_submodules.find(product => product.product_type === 'luminaire_control_submodule' && product.product_subtype === 'presence_detector_slave')?.id;
                } else {
                    this.luminaireLineFormFields.type_of_luminaire_control_submodule_slave = '';
                }
            },

            setTypeOfBlindModules() {
                this.luminaireLineFormFields.type_of_blind_modules = this.luminaireLineProducts.blind_modules[0].id;
            },

            setNumberOfBlindModules() {
                this.luminaireLineFormFields.number_of_blind_modules = this.luminaireLineFormFields.number_of_modules_total - this.luminaireLineFormFields.number_of_led_modules;
            },

            setTypeOfMountingRails() {

                // set type by number of input for rayrail

                if (this.product_configurator_id === 1) {
                    this.helpers.mountingrail_db_titles.forEach(el => {
                        if (this.getDynamicModel('number_of_', el) > 0) {
                            this.setDynamicModel('type_of_', el, this.luminaireLineProducts.mountingrails.find(mountingRail => mountingRail.size_x === Number(el.split('_').pop())).id);
                        } else {
                            this.setDynamicModel('type_of_', el, '');
                        }
                    });
                }

                if (this.product_configurator_id === 3) {
                    this.luminaireLineProducts.mountingrails_with_connectors
                        .forEach(el => {
                        if (this.getDynamicModel('number_of_', el.db_title) > 0) {
                            this.setDynamicModel('type_of_', el.db_title, el.id);
                        } else {
                            this.setDynamicModel('type_of_', el.db_title, '');
                        }
                    });
                }

            },

            setNumberOfOptics() {
                this.luminaireLineFormFields.number_of_optics_504 = this.luminaireLineFormFields.number_of_mounting_rail_504;
                this.luminaireLineFormFields.number_of_optics_336 = this.luminaireLineFormFields.number_of_mounting_rail_336;
                this.luminaireLineFormFields.number_of_optics_168 = this.luminaireLineFormFields.number_of_mounting_rail_168;
            },

            setTypeOfOptics() {
                // length of optics differ from mounting rail length
                if ( this.luminaireLineFormFields.number_of_optics_168 > 0 ) {
                    let selectedOptic168 = this.luminaireLineProducts.optics.find(optic => optic.size_x === 167);
                    this.luminaireLineFormFields.type_of_optics_168 = selectedOptic168.id;
                } else {
                    this.luminaireLineFormFields.type_of_optics_168 = '';
                }
                if ( this.luminaireLineFormFields.number_of_optics_336 > 0 ) {
                    let selectedOptic336 = this.luminaireLineProducts.optics.find(optic => optic.size_x === 334);
                    this.luminaireLineFormFields.type_of_optics_336 = selectedOptic336.id;
                } else {
                    this.luminaireLineFormFields.type_of_optics_336 = '';
                }
                if ( this.luminaireLineFormFields.number_of_optics_504 > 0 ) {
                    let selectedOptic504 = this.luminaireLineProducts.optics.find(optic => optic.size_x === 502);
                    this.luminaireLineFormFields.type_of_optics_504 = selectedOptic504.id;
                } else {
                    this.luminaireLineFormFields.type_of_optics_504 = '';
                }

            },

            setNumberOfProtectionClass() {
                if (this.selectedProtectionClass === 15 || this.selectedProtectionClass === 16) {
                    this.luminaireLineFormFields.number_of_protection_class_504 = this.luminaireLineFormFields.number_of_mounting_rail_504;
                    this.luminaireLineFormFields.number_of_protection_class_336 = this.luminaireLineFormFields.number_of_mounting_rail_336;
                    this.luminaireLineFormFields.number_of_protection_class_168 = this.luminaireLineFormFields.number_of_mounting_rail_168;
                } else {
                    this.luminaireLineFormFields.number_of_protection_class_504 = 0;
                    this.luminaireLineFormFields.number_of_protection_class_336 = 0;
                    this.luminaireLineFormFields.number_of_protection_class_168 = 0;
                }

            },

            setTypeOfProtectionClass() {
                // length of protection_class differ from mounting rail length
                if ( this.luminaireLineFormFields.number_of_protection_class_168 > 0 ) {
                    let selectedProtectionClass168 = this.luminaireLineProducts.protection_class.find(el => el.size_x === 168);
                    this.luminaireLineFormFields.type_of_protection_class_168 = selectedProtectionClass168.id;
                } else {
                    this.luminaireLineFormFields.type_of_protection_class_168 = '';
                }
                if ( this.luminaireLineFormFields.number_of_protection_class_336 > 0 ) {
                    let selectedProtectionClass336 = this.luminaireLineProducts.protection_class.find(el => el.size_x === 336);
                    this.luminaireLineFormFields.type_of_protection_class_336 = selectedProtectionClass336.id;
                } else {
                    this.luminaireLineFormFields.type_of_protection_class_336 = '';
                }
                if ( this.luminaireLineFormFields.number_of_protection_class_504 > 0 ) {
                    let selectedProtectionClass504 = this.luminaireLineProducts.protection_class.find(el => el.size_x === 504);
                    this.luminaireLineFormFields.type_of_protection_class_504 = selectedProtectionClass504.id;
                } else {
                    this.luminaireLineFormFields.type_of_protection_class_504 = '';
                }

            },

            setNumberOfElectricalFeedsPerLine() {
                this.luminaireLineFormFields.number_of_electrical_feeds_per_line = this.luminaireLineFormFields.lumination_length >= 6000 ? Math.ceil(this.luminaireLineFormFields.lumination_length / 6000) : 1;
            },

            setNumberOfElectricalFeedsStartEnd() {

                this.luminaireLineFormFields.number_of_electrical_feeds_start   = this.number_of_electrical_feeds_start_total ? this.number_of_electrical_feeds_start_total : 0;
                this.luminaireLineFormFields.number_of_electrical_feeds_end     = this.number_of_electrical_feeds_end_total ? this.number_of_electrical_feeds_end_total : 0;

            },

            setTypeOfElectricalFeeds() {

                // Set Electrical Feed Start
                if ( this.luminaireLineFormFields.number_of_electrical_feeds_start > 0 ) {
                    let selectedElectricalFeedsStart = this.luminaireLineProducts.electrical_feeds.find(electricalFeed => electricalFeed.product_subtype.includes('electrical_feed_start'));
                    this.luminaireLineFormFields.type_of_electrical_feeds_start = selectedElectricalFeedsStart.id;
                } else {
                    this.luminaireLineFormFields.type_of_electrical_feeds_start = '';
                }

                // Set Electrical Feed Middle
                if ( this.luminaireLineFormFields.number_of_electrical_feeds_middle > 0 ) {
                    let selectedElectricalFeedsMiddle = this.luminaireLineProducts.electrical_feeds.find(electricalFeed => electricalFeed.product_subtype.includes('electrical_feed_middle'));
                    this.luminaireLineFormFields.type_of_electrical_feeds_middle = selectedElectricalFeedsMiddle.id;
                } else {
                    this.luminaireLineFormFields.type_of_electrical_feeds_middle = '';
                }

                // Set Electrical Feed End
                if ( this.luminaireLineFormFields.number_of_electrical_feeds_end > 0 ) {
                    let selectedElectricalFeedsEnd = this.luminaireLineProducts.electrical_feeds.find(electricalFeed => electricalFeed.product_subtype.includes('electrical_feed_end'));
                    this.luminaireLineFormFields.type_of_electrical_feeds_end = selectedElectricalFeedsEnd.id;
                } else {
                    this.luminaireLineFormFields.type_of_electrical_feeds_end = '';
                }
            },

            setNumberOfSuspensions() {
                if (this.luminaireLineFormFields.number_of_ceiling_mounts > 0) {
                    this.luminaireLineFormFields.number_of_suspensions = 0;
                    this.luminaireLineFormFields.number_of_additional_suspensions = 0;
                } else {
                    this.luminaireLineFormFields.number_of_suspensions = this.luminaireLineFormFields.number_of_mounting_rails_total + 1 + this.luminaireLineFormFields.number_of_additional_suspensions + this.getTotalQuantityOfMountingRails(504);
                }

            },

            setNumberOfMountConnectors() {
                let number_of_mount_connectors = this.luminaireLineFormFields.number_of_mounting_rails_total - 1;
                this.luminaireLineFormFields.number_of_mount_connectors = number_of_mount_connectors > 0 ? number_of_mount_connectors : 0;
            },

            setTypeOfConnectors() {
                if (this.luminaireLineFormFields.number_of_mount_connectors && this.luminaireLineFormFields.number_of_mount_connectors > 0) {
                    this.luminaireLineFormFields.type_of_mount_connectors = this.luminaireLineProducts.mount_connectors[0].id;
                } else {
                    this.luminaireLineFormFields.type_of_mount_connectors = '';
                }
            },

            setNumberOfMountingAdapters() {

                if (!this.luminaireLineProducts.ceiling_mounts[0] && this.mountingAdapterYesOrNo === 'mounting_adapter_no') {
                    this.mountingAdapterYesOrNo = 'mounting_adapter_no';
                }

                if (this.mountingAdapterYesOrNo === 'mounting_adapter_yes') {
                    // mounting_adapter_yes: 1 for each mounting rail + 1 for end + 1 additional for each mounting rail 504
                    this.luminaireLineFormFields.number_of_mounting_adapters = this.luminaireLineFormFields.number_of_mounting_rails_total + 1 + this.getTotalQuantityOfMountingRails(504) + this.luminaireLineFormFields.number_of_additional_suspensions;
                    this.luminaireLineFormFields.number_of_ceiling_mounts = 0;

                } else if (this.mountingAdapterYesOrNo === 'mounting_adapter_no') {
                    // mounting_adapter_no: 1 for start and one for end + for every mounting rail 504
                    this.luminaireLineFormFields.number_of_mounting_adapters = 2 + this.getTotalQuantityOfMountingRails(504) + this.luminaireLineFormFields.number_of_additional_suspensions;
                    this.luminaireLineFormFields.number_of_ceiling_mounts = 0;

                } else if (this.mountingAdapterYesOrNo ===  'mounting_adapter_ceiling') {
                    // 1 for each mounting rail + 1 for end
                    this.luminaireLineFormFields.number_of_ceiling_mounts = this.luminaireLineFormFields.number_of_mounting_rails_total + 1 + this.luminaireLineFormFields.number_of_additional_suspensions;
                    this.luminaireLineFormFields.number_of_mounting_adapters = 0;

                }

            },

            setTypeOfMountingAdapters() {
                if (this.luminaireLineFormFields.number_of_mounting_adapters > 0 && (this.mountingAdapterYesOrNo === 'mounting_adapter_yes' || this.mountingAdapterYesOrNo === 'mounting_adapter_no' )) {
                    // With Mounting Adapters
                    this.luminaireLineFormFields.type_of_mounting_adapters = this.luminaireLineProducts.mounting_adapters[0].id;
                    this.luminaireLineFormFields.type_of_ceiling_mounts = '';
                } else if (this.luminaireLineFormFields.number_of_ceiling_mounts > 0 && this.mountingAdapterYesOrNo === 'mounting_adapter_ceiling') {
                    // With ceiling adapters
                    this.luminaireLineFormFields.type_of_ceiling_mounts = this.luminaireLineProducts.ceiling_mounts[0].id;
                    this.luminaireLineFormFields.type_of_mounting_adapters = '';
                    this.luminaireLineFormFields.type_of_suspensions = '';
                }
            },

            setNumberOfRemoteControls() {
                if (this.luminaireLineFormFields.type_of_remote_controls) {
                    this.luminaireLineFormFields.number_of_remote_controls = 1;
                } else {
                    this.luminaireLineFormFields.number_of_remote_controls = 0;
                }
            },

            setNumberConnectingCable() {
                if (this.luminaireLineFormFields.type_of_connecting_cable) {
                    this.luminaireLineFormFields.number_of_connecting_cable = this.luminaireLineFormFields.number_of_electrical_feeds_start + this.luminaireLineFormFields.number_of_electrical_feeds_end + (this.luminaireLineFormFields.number_of_electrical_feeds_middle * (this.selectedSerie.includes('eco') ? 2 : 4));
                } else {
                    this.luminaireLineFormFields.number_of_connecting_cable = 0;
                }
            },

            fixNumberConnectingCableMiddle() {

                if (!this.luminaireLineFormFields.type_of_connecting_cable_middle) {
                    this.luminaireLineFormFields.number_of_connecting_cable_middle = 0;
                    return;
                }

                if (!this.selectedSerie.includes('max') || this.luminaireLineFormFields.number_of_connecting_cable_middle < 1 || this.fixConnectingCableMiddleAlertCounter > 0) return;

                this.$swal.fire({
                    title: this.$t('Fix quantity of connecting cables?'),
                    text: this.$t('The RayLine Max needs 2 connecting cables per connecting point. Do you want to double the quantity?'),
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#3CA2A4',
                    cancelButtonColor: '#393e42',
                    confirmButtonText: this.$t('Fix'),
                    cancelButtonText: this.$t('Cancel'),
                }).then((result) => {
                    if (result.value) {
                        this.luminaireLineFormFields.number_of_connecting_cable_middle = this.luminaireLineFormFields.number_of_connecting_cable_middle * 2;
                        this.fixConnectingCableMiddleAlertCounter++;
                    }
                })
            },

            fixEmergencyLightSelection() {
                if (this.luminaireLineFormFields.number_of_emergency_lights > 0 && !this.luminaireLineProducts.emergency_lights?.find(el => el.id === this.luminaireLineFormFields.type_of_emergency_light)) {
                    this.luminaireLineFormFields.number_of_emergency_lights = 0;
                    this.luminaireLineFormFields.type_of_emergency_light = '';
                }
            },

            fixUniversalConnectorSubmodulesSelection() {

                // Check if the selected universal connector submodule, submodule v2, or submodule v3 exists in the product list.
                // If not, reset the number and type of the respective universal connector submodules to 0 and an empty string respectively.

                if (this.luminaireLineFormFields.number_of_universal_connector_submodules > 0 && !!!this.luminaireLineProducts.universal_connector_submodules?.filter(product => product.product_subtype === 'universal_connector_5')?.find(el => el.id === this.luminaireLineFormFields.type_of_universal_connector_submodules)) {
                    this.luminaireLineFormFields.number_of_universal_connector_submodules = 0;
                    this.luminaireLineFormFields.type_of_universal_connector_submodules = '';
                }

                if (this.luminaireLineFormFields.number_of_universal_connector_submodules_v2 > 0 && !!!this.luminaireLineProducts.universal_connector_submodules?.filter(product => product.product_subtype === 'universal_connector_5_v2')?.find(el => el.id === this.luminaireLineFormFields.type_of_universal_connector_submodules_v2)) {
                    this.luminaireLineFormFields.number_of_universal_connector_submodules_v2 = 0;
                    this.luminaireLineFormFields.type_of_universal_connector_submodules_v2 = '';
                }

                if (this.luminaireLineFormFields.number_of_universal_connector_submodules_v3 > 0 && !!!this.luminaireLineProducts.universal_connector_submodules?.filter(product => product.product_subtype === 'universal_connector_5_v3')?.find(el => el.id === this.luminaireLineFormFields.type_of_universal_connector_submodules_v3)) {
                    this.luminaireLineFormFields.number_of_universal_connector_submodules_v3 = 0;
                    this.luminaireLineFormFields.type_of_universal_connector_submodules_v3 = '';
                }

            },

            setNumberConnectingCableMiddle() {
                if (!this.luminaireLineFormFields.type_of_connecting_cable_middle) {
                    this.luminaireLineFormFields.number_of_connecting_cable_middle = 0;
                }
            },

            setCableRoutes() {

                if (this.cableRouteYesOrNo) {

                    this.luminaireLineFormFields.number_of_cable_routes_504 = this.getTotalQuantityOfMountingRails(504);
                    this.luminaireLineFormFields.number_of_cable_routes_336 = this.getTotalQuantityOfMountingRails(336);
                    this.luminaireLineFormFields.number_of_cable_routes_168 = this.getTotalQuantityOfMountingRails(168);

                    this.luminaireLineFormFields.type_of_cable_route_504 = this.luminaireLineFormFields.number_of_cable_routes_504 > 0
                                                                                ? this.luminaireLineProducts.cable_routes.find(element => element.size_x === 504).id
                                                                                : this.luminaireLineFormFields.type_of_cable_route_504 = '';

                    this.luminaireLineFormFields.type_of_cable_route_336 = this.luminaireLineFormFields.number_of_cable_routes_336 > 0
                                                                                ? this.luminaireLineProducts.cable_routes.find(element => element.size_x === 336).id
                                                                                : this.luminaireLineFormFields.type_of_cable_route_336 = '';

                    this.luminaireLineFormFields.type_of_cable_route_168 = this.luminaireLineFormFields.number_of_cable_routes_168 > 0
                                                                                ? this.luminaireLineProducts.cable_routes.find(element => element.size_x === 168).id
                                                                                : this.luminaireLineFormFields.type_of_cable_route_168 = '';

                } else {
                    this.luminaireLineFormFields.number_of_cable_routes_504 = 0;
                    this.luminaireLineFormFields.number_of_cable_routes_336 = 0;
                    this.luminaireLineFormFields.number_of_cable_routes_168 = 0;
                }

            },

            autoPopulateElectricalFeeds () {

                let number_of_electrical_feeds_per_line = Number(this.luminaireLineFormFields.number_of_electrical_feeds_per_line);
                let number_of_electrical_feeds_start = Number(this.number_of_electrical_feeds_start_total);
                let number_of_electrical_feeds_middle = Number(this.number_of_electrical_feeds_end_total);
                let number_of_electrical_feeds_end = Number(this.luminaireLineFormFields.number_of_electrical_feeds_middle);

                // If all needed electrical feeds are set, set 0
                if ( number_of_electrical_feeds_per_line === ( number_of_electrical_feeds_start + number_of_electrical_feeds_middle + number_of_electrical_feeds_end) ) {

                    if (!this.number_of_electrical_feeds_start_total) {
                        this.luminaireLineFormFields.number_of_electrical_feeds_start = 0;
                        this.number_of_electrical_feeds_start_total = 0;
                    }
                    if (!this.luminaireLineFormFields.number_of_electrical_feeds_middle) {
                        this.luminaireLineFormFields.number_of_electrical_feeds_middle = 0;
                    }
                    if (!this.number_of_electrical_feeds_end_total) {
                        this.luminaireLineFormFields.number_of_electrical_feeds_end = 0;
                        this.number_of_electrical_feeds_end_total = 0;
                    }

                }

            },

            checkAndAutoCorrectLuminaireControlNumbers(field) {

                // MASTERS
                if (field === 'number_of_luminaire_controls' && this.luminaireLineFormFields.number_of_luminaire_controls >= 1) {
                    this.luminaireLineFormFields.number_of_luminaire_controls = 1;
                    if (this.luminaireLineFormFields.number_of_luminaire_control_submodules > 0) {
                        this.luminaireLineFormFields.number_of_luminaire_control_submodules = 0;
                        this.luminaireLineFormFields.type_of_luminaire_control_submodule = '';
                    }
                }

                if (field === 'number_of_luminaire_control_submodules' && this.luminaireLineFormFields.number_of_luminaire_control_submodules >= 1) {
                    this.luminaireLineFormFields.number_of_luminaire_control_submodules = 1;
                    if (this.luminaireLineFormFields.number_of_luminaire_controls > 0) {
                        this.luminaireLineFormFields.number_of_luminaire_controls = 0;
                        this.luminaireLineFormFields.type_of_luminaire_control = '';
                    }
                }

                // set slaves to 0 if master is 1
                if (this.sensorSystemMasterCount > 0 && this.sensorSystemSlaveCount > 3 && (field === 'number_of_luminaire_controls' || field === 'number_of_luminaire_control_submodules') ) {
                    this.luminaireLineFormFields.number_of_luminaire_control_submodule_slaves = 0;
                    this.luminaireLineFormFields.type_of_luminaire_control_submodule_slave = '';
                    this.luminaireLineFormFields.number_of_luminaire_control_slaves = 0;
                    this.luminaireLineFormFields.type_of_luminaire_control_slave = '';
                }

                // SLAVES
                if (field === 'number_of_luminaire_control_slaves' && this.availableSlavesCount < 0) {
                    this.luminaireLineFormFields.number_of_luminaire_control_slaves = this.luminaireLineFormFields.number_of_luminaire_control_slaves + this.availableSlavesCount;

                    if (this.luminaireLineFormFields.number_of_luminaire_control_slaves === 0) {
                        this.luminaireLineFormFields.type_of_luminaire_control_slave = '';
                    }
                }

                if (field === 'number_of_luminaire_control_submodule_slaves' && this.availableIntegratedSlavesCount < 0) {
                    this.luminaireLineFormFields.number_of_luminaire_control_submodule_slaves = this.luminaireLineFormFields.number_of_luminaire_control_submodule_slaves + this.availableIntegratedSlavesCount;

                    if (this.luminaireLineFormFields.number_of_luminaire_control_submodule_slaves === 0) {
                        this.luminaireLineFormFields.type_of_luminaire_control_submodule_slave = '';
                    }
                }

                this.calculateLuminationLineForm();

            },

            autoPopulateMountingRails(input, max, prefix, db_title) {
                if (!this.luminaireLineProducts.mountingrails_with_connectors ) return;

                if (max < 0) {
                    this.setDynamicModel(prefix, db_title, input + max);
                }

                if (this.getMissingMountingRailsByType(504).missing === 0 || this.getMissingMountingRailsByType(336).missing === 0 || this.getMissingMountingRailsByType(168).missing === 0) {
                    this.luminaireLineProducts.mountingrails_with_connectors.forEach(el => {
                        if (el.size_x === 504 && this.getMissingMountingRailsByType(504).missing === 0 && !this.getDynamicModel('number_of_', el.db_title)) {
                            this.setDynamicModel('number_of_', el.db_title, 0);
                        }
                        if (el.size_x === 336 && this.getMissingMountingRailsByType(336).missing === 0 && !this.getDynamicModel('number_of_', el.db_title)) {
                            this.setDynamicModel('number_of_', el.db_title, 0);
                        }
                        if (el.size_x === 168 && this.getMissingMountingRailsByType(168).missing === 0 && !this.getDynamicModel('number_of_', el.db_title)) {
                            this.setDynamicModel('number_of_', el.db_title, 0);
                        }
                    })
                }
            },

            resetMountingRailConfiguration(mounting_rail) {

                let mountingrailsToReset = mounting_rail === 'all'
                    ? this.helpers.mountingrail_db_titles.concat(this.luminaireLineProducts.mountingrails_with_connectors.map(el => el.db_title))
                    : this.luminaireLineProducts.mountingrails_with_connectors.filter(el => el.size_x === mounting_rail.size_x).map(el => el.db_title);

                mountingrailsToReset.forEach(el => {
                        this.setDynamicModel('number_of_', el, 0);
                        this.setDynamicModel('type_of_', el, '');
                    });

                this.calculateLuminationLineForm();

            },

            getWarrantyPrice(planningPrice, percent) {
                return (planningPrice * percent / 100);
            },

            setNumberOfWarranties() {
                if (this.luminaireLineFormFields.type_of_warranties) {
                    this.luminaireLineFormFields.number_of_warranties = 1;
                } else {
                    this.luminaireLineFormFields.number_of_warranties = 0;
                }
            },

            getNumberOfAvailableSubmodulesExcludingSelf(typeToExclude) {
                let submodulesCount = 0;
                this.helpers.number_of_submodules_db_titles.forEach((title) => {
                    if (this.luminaireLineFormFields[title] && title !== typeToExclude) {
                        submodulesCount += this.luminaireLineFormFields[title];
                    }
                });

                return this.luminaireLineFormFields.number_of_blind_modules - submodulesCount;

            },

            /****************************************
             * RESET ON CHANGE
             ****************************************/

            emergencyLightDeselectIfSelected(value) {
                if (this.luminaireLineFormFields.type_of_emergency_light === value) {
                    this.luminaireLineFormFields.type_of_emergency_light = '';
                    this.luminaireLineFormFields.number_of_emergency_lights = 0;

                    this.calculateLuminationLineForm();
                }
            },

            luminaireControlDeselectIfSelected(newVal) {
                if (this.luminaireLineFormFields.type_of_luminaire_control === newVal)
                {
                    this.luminaireLineFormFields.type_of_luminaire_control = '';
                    this.luminaireLineFormFields.number_of_luminaire_controls = 0;
                    this.luminaireLineFormFields.type_of_remote_controls = '';
                    this.luminaireLineFormFields.number_of_remote_controls = 0;
                    this.luminaireLineFormFields.type_of_luminaire_control_slave = '';
                    this.luminaireLineFormFields.number_of_luminaire_control_slaves = 0;

                }

                // if type_of_luminaire_control_submodule is selected and type_of_luminaire_control is casambi then unset type_of_luminaire_control and number_of_luminaire_controls
                if ((!!this.luminaireLineFormFields.type_of_luminaire_control_submodule || !!this.luminaireLineFormFields.type_of_luminaire_control_submodule_slave) && (this.getProductType(newVal, 'subtype')?.includes('casambi') || this.getProductType(newVal, 'subtype')?.includes('enlighted')))
                {
                    this.luminaireLineFormFields.type_of_luminaire_control_submodule = '';
                    this.luminaireLineFormFields.number_of_luminaire_control_submodules = 0;
                    this.luminaireLineFormFields.type_of_luminaire_control_submodule_slave = '';
                    this.luminaireLineFormFields.number_of_luminaire_control_submodule_slaves = 0;
                }

                this.calculateLuminationLineForm();

            },

            checkLuminaireControls() {
                if (this.lstForm.led_module_control_id === 27) {
                    this.luminaireLineFormFields.type_of_luminaire_control = '';
                    this.luminaireLineFormFields.number_of_luminaire_controls = 0;
                    this.luminaireLineFormFields.type_of_remote_controls = '';
                    this.luminaireLineFormFields.number_of_remote_controls = 0;
                    this.luminaireLineFormFields.type_of_luminaire_control_slave = '';
                    this.luminaireLineFormFields.number_of_luminaire_control_slaves = 0;
                    this.luminaireLineFormFields.type_of_luminaire_control_submodule = '';
                    this.luminaireLineFormFields.number_of_luminaire_control_submodules = 0;
                    this.luminaireLineFormFields.type_of_luminaire_control_submodule_slave = '';
                    this.luminaireLineFormFields.number_of_luminaire_control_submodule_slaves = 0;
                }
            },

            universalAdapterDeselectIfSelected(value) {
                if (value === this.luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_lg').id) {
                    this.luminaireLineFormFields.type_of_universal_adapters_lg = '';
                    this.luminaireLineFormFields.number_of_universal_adapters_lg = 0;

                    this.calculateLuminationLineForm();
                }
                if (value === this.luminaireLineProducts.universal_adapters.find(el => el.product_type === 'universal_adapter' && el.product_subtype === 'universal_adapter_sm').id) {
                    this.luminaireLineFormFields.type_of_universal_adapters_sm = '';
                    this.luminaireLineFormFields.number_of_universal_adapters_sm = 0;

                    this.calculateLuminationLineForm();
                }
            },

            universalConnectorDeselectIfSelected(value) {

                if (this.luminaireLineFormFields.type_of_universal_connectors === value) {
                    this.luminaireLineFormFields.type_of_universal_connectors = '';
                    this.luminaireLineFormFields.number_of_universal_connectors = 0;
                } else if (this.luminaireLineFormFields.type_of_universal_connectors_v2 === value) {
                    this.luminaireLineFormFields.type_of_universal_connectors_v2 = '';
                    this.luminaireLineFormFields.number_of_universal_connectors_v2 = 0;
                } else if (this.luminaireLineFormFields.type_of_universal_connectors_v3 === value) {
                    this.luminaireLineFormFields.type_of_universal_connectors_v3 = '';
                    this.luminaireLineFormFields.number_of_universal_connectors_v3 = 0;
                }

                this.calculateLuminationLineForm();

            },

            universalConnectorSubmoduleDeselectIfSelected(value) {

                if (this.luminaireLineFormFields.type_of_universal_connector_submodules === value) {
                    this.luminaireLineFormFields.type_of_universal_connector_submodules = '';
                    this.luminaireLineFormFields.number_of_universal_connector_submodules = 0;
                } else if (this.luminaireLineFormFields.type_of_universal_connector_submodules_v2 === value) {
                    this.luminaireLineFormFields.type_of_universal_connector_submodules_v2 = '';
                    this.luminaireLineFormFields.number_of_universal_connector_submodules_v2 = 0;
                } else if (this.luminaireLineFormFields.type_of_universal_connector_submodules_v3 === value) {
                    this.luminaireLineFormFields.type_of_universal_connector_submodules_v3 = '';
                    this.luminaireLineFormFields.number_of_universal_connector_submodules_v3 = 0;
                }

                this.calculateLuminationLineForm();

            },

            warrantyDeselectIfSelected(value) {
                if (this.luminaireLineFormFields.type_of_warranties === value) {

                    this.luminaireLineFormFields.type_of_warranties = '';
                    this.luminaireLineFormFields.number_of_warranties = 0;

                    this.calculateLuminationLineForm();

                }
            },

            cableRouteDeselectIfSelected(value) {
                if (this.cableRouteYesOrNo === value) {
                    this.cableRouteYesOrNo = false;
                    this.luminaireLineFormFields.type_of_cable_route_168 = '';
                    this.luminaireLineFormFields.type_of_cable_route_336 = '';
                    this.luminaireLineFormFields.type_of_cable_route_504 = '';
                    this.luminaireLineFormFields.number_of_cable_routes_168 = 0;
                    this.luminaireLineFormFields.number_of_cable_routes_336 = 0;
                    this.luminaireLineFormFields.number_of_cable_routes_504 = 0;
                }
            },

            standAloneSensorDeselectIfSelected(value) {
                if (this.standAloneSensorYesOrNo === value) {
                    this.standAloneSensorYesOrNo = false;
                    this.luminaireLineFormFields.type_of_luminaire_control = '';
                    this.luminaireLineFormFields.type_of_luminaire_control_slave = '';
                    this.luminaireLineFormFields.number_of_luminaire_controls = 0;
                    this.luminaireLineFormFields.number_of_luminaire_control_slaves = 0;
                }

                if (this.getProductType(this.luminaireLineFormFields.type_of_luminaire_control, 'subtype')?.includes('casambi') || this.getProductType(this.luminaireLineFormFields.type_of_luminaire_control, 'subtype')?.includes('enlighted')) {
                    this.luminaireLineFormFields.type_of_luminaire_control = '';
                    this.luminaireLineFormFields.number_of_luminaire_controls = 0;
                }

                this.calculateLuminationLineForm();

            },

            integratedSensorDeselectIfSelected(value) {
                if (this.integratedSensorYesOrNo === value) {
                    this.integratedSensorYesOrNo = false;
                    this.luminaireLineFormFields.type_of_luminaire_control_submodule = '';
                    this.luminaireLineFormFields.type_of_luminaire_control_submodule_slave = '';
                    this.luminaireLineFormFields.number_of_luminaire_control_submodules = 0;
                    this.luminaireLineFormFields.number_of_luminaire_control_submodule_slaves = 0;
                }

                if (this.getProductType(this.luminaireLineFormFields.type_of_luminaire_control, 'subtype')?.includes('casambi') || this.getProductType(this.luminaireLineFormFields.type_of_luminaire_control, 'subtype')?.includes('enlighted')) {
                    this.luminaireLineFormFields.type_of_luminaire_control = '';
                    this.luminaireLineFormFields.number_of_luminaire_controls = 0;
                }

                this.calculateLuminationLineForm();

            },

            connectingCableDeselectIfSelected(value) {
                if (this.luminaireLineFormFields.type_of_connecting_cable === value) {
                    this.luminaireLineFormFields.type_of_connecting_cable = '';
                    this.luminaireLineFormFields.number_of_connecting_cable = 0;

                    this.calculateLuminationLineForm();
                }
            },

            connectingCableMiddleDeselectIfSelected(value) {
                if (this.luminaireLineFormFields.type_of_connecting_cable_middle === value) {
                    this.luminaireLineFormFields.type_of_connecting_cable_middle = '';
                    this.luminaireLineFormFields.number_of_connecting_cable_middle = 0;

                    this.calculateLuminationLineForm();
                }
            },

            loadPlanningDataOnEdit() {
                if (this.editPlanning) {
                    this.setLuminaireLineFormData();
                    this.validateLuminationLength();
                    this.getMountingRailTypeSuggestions();
                    this.setNumberOfMountingRails();
                    this.validateProductAddons();
                }
            },

            getProductType(id, type = 'type') {
                if (!id) return '';

                let products = Object.values(this.luminaireLineProducts).flat().filter(product => product != null);
                if (type === 'type') {
                    return products.find(product => product.id === id)?.product_type;
                } else if (type === 'subtype') {
                    return products.find(product => product.id === id)?.product_subtype;
                }
            },

            /**************************************************************************
             * VALIDATION
             **************************************************************************/

            validateStepThree() {

                let step_3_validated = false;

                // not valid if NOT authenticated OR max_step <= 2 OR form fields are not filled out fully
                if (
                    // Allgemeine
                    !this.authenticated
                    || this.luminaireLineFormFields.lumination_length <= 0
                    || this.getTotalQuantityOfMountingRails() <= 0

                    // Electrical Feeds
                    || this.luminaireLineFormFields.number_of_electrical_feeds_per_line <= 0
                    || (this.number_of_electrical_feeds_start_total + this.number_of_electrical_feeds_end_total + this.luminaireLineFormFields.number_of_electrical_feeds_middle) < this.luminaireLineFormFields.number_of_electrical_feeds_per_line
                    || (!this.luminaireLineFormFields.type_of_electrical_feeds_start && !this.luminaireLineFormFields.type_of_electrical_feeds_end && !this.luminaireLineFormFields.type_of_electrical_feeds_middle )

                    // Suspension
                    || (!this.luminaireLineFormFields.type_of_mounting_adapters && !this.luminaireLineFormFields.type_of_suspensions && !this.luminaireLineFormFields.type_of_ceiling_mounts)
                    || (this.luminaireLineFormFields.number_of_mounting_adapters + this.luminaireLineFormFields.number_of_suspensions + this.luminaireLineFormFields.number_of_ceiling_mounts <= 0)
                    || (this.luminaireLineFormFields.type_of_mounting_adapters && !this.luminaireLineFormFields.type_of_suspensions)
                    || (this.luminaireLineFormFields.type_of_mounting_adapters && this.luminaireLineFormFields.type_of_suspensions && this.luminaireLineFormFields.number_of_mounting_adapters <= 0 && this.luminaireLineFormFields.number_of_suspensions <= 0 && this.luminaireLineFormFields.number_of_ceiling_mounts > 0)
                    || (this.luminaireLineFormFields.type_of_ceiling_mounts && this.luminaireLineFormFields.number_of_ceiling_mounts <= 0 && (this.luminaireLineFormFields.number_of_mounting_adapters + this.luminaireLineFormFields.number_of_suspensions > 0))

                    // Mount connectors
                    || ( this.luminaireLineFormFields.type_of_mount_connectors && this.luminaireLineFormFields.number_of_mount_connectors <= 0 )

                    // Luminaire control & emergency light
                    || ( this.luminaireLineFormFields.type_of_luminaire_control && this.luminaireLineFormFields.number_of_luminaire_controls <= 0)
                    || ( this.luminaireLineFormFields.type_of_luminaire_control_slave && this.luminaireLineFormFields.number_of_luminaire_control_slaves <= 0)
                    || ( this.luminaireLineFormFields.type_of_emergency_light && this.luminaireLineFormFields.number_of_emergency_lights <= 0)

                    // Blindmodule Submodule Sensors
                    || ( this.luminaireLineFormFields.type_of_luminaire_control_submodule && this.luminaireLineFormFields.number_of_luminaire_control_submodules <= 0)
                    || ( this.luminaireLineFormFields.type_of_luminaire_control_submodule_slave && this.luminaireLineFormFields.number_of_luminaire_control_submodule_slaves <= 0)

                    // Universal adapters & connectors
                    || ( this.luminaireLineFormFields.type_of_universal_adapters_lg && this.luminaireLineFormFields.number_of_universal_adapters_lg <= 0)
                    || ( this.luminaireLineFormFields.type_of_universal_adapters_sm && this.luminaireLineFormFields.number_of_universal_adapters_sm <= 0)
                    || ( this.luminaireLineFormFields.type_of_universal_connectors && this.luminaireLineFormFields.number_of_universal_connectors <= 0)
                    || ( this.luminaireLineFormFields.type_of_universal_connectors_v2 && this.luminaireLineFormFields.number_of_universal_connectors_v2 <= 0)
                    || ( this.luminaireLineFormFields.type_of_universal_connectors_v3 && this.luminaireLineFormFields.number_of_universal_connectors_v3 <= 0)

                    || (this.product_configurator_id === 1 && !this.mountingRailStepIsValid)
                    || (this.product_configurator_id === 3 && !this.mountingRailWithConnectorsStepIsValid)
                    || !this.blindModuleStepIsValid
                    || !this.ledAndBlindModuleValid
                    || !this.electricalFeedsValid
                    || !this.mountingValid
                    || !this.emergencyLightValid
                    || !this.connectingCableMiddleValid
                    || !this.luminaireControlLiteValid
                    || !this.luminaireControlProValid
                    || !this.cableRoutesValid
                    || !this.universalAdapterValid
                    || !this.universalConnectorValid
                    || !this.universalConnectorValid_v2
                    || !this.universalConnectorValid_v3
                    || !this.universalConnectorSubmoduleValid
                    || !this.universalConnectorSubmoduleValid_v2
                    || !this.universalConnectorSubmoduleValid_v3
                    || !this.productAddonsValid
                    || !this.specialProductsValid

                    // tempLED RayLine
                    || ( this.product_configurator_id === 1
                        && (
                            (!this.luminaireLineFormFields.type_of_blind_modules && this.luminaireLineFormFields.number_of_blind_modules > 0)
                            || (!this.luminaireLineFormFields.type_of_mounting_rail_504 && !this.luminaireLineFormFields.type_of_mounting_rail_336 && !this.luminaireLineFormFields.type_of_mounting_rail_168)
                            || this.luminaireLineFormFields.number_of_modules_total <= 0
                            || (this.luminaireLineFormFields.number_of_led_modules + this.luminaireLineFormFields.number_of_blind_modules) !== this.luminaireLineFormFields.number_of_modules_total
                        )
                    )

                    // tempLED RayRail
                    || ( this.product_configurator_id === 3
                        && (
                            this.luminaireLineFormFields.number_of_modules_total > 0
                            || this.luminaireLineFormFields.number_of_blind_modules > 0
                            || this.luminaireLineFormFields.number_of_led_modules > 0
                            || (!this.luminaireLineFormFields.type_of_mounting_rail_504_0
                                && !this.luminaireLineFormFields.type_of_mounting_rail_504_1
                                && !this.luminaireLineFormFields.type_of_mounting_rail_504_2
                                && !this.luminaireLineFormFields.type_of_mounting_rail_504_3
                                && !this.luminaireLineFormFields.type_of_mounting_rail_336_0
                                && !this.luminaireLineFormFields.type_of_mounting_rail_336_1
                                && !this.luminaireLineFormFields.type_of_mounting_rail_336_2
                                && !this.luminaireLineFormFields.type_of_mounting_rail_168_0
                                && !this.luminaireLineFormFields.type_of_mounting_rail_168_1 )
                            || (this.luminaireLineFormFields.number_of_mounting_rail_504_0 + this.luminaireLineFormFields.number_of_mounting_rail_504_1 + this.luminaireLineFormFields.number_of_mounting_rail_504_2 + this.luminaireLineFormFields.number_of_mounting_rail_504_3 + this.luminaireLineFormFields.number_of_mounting_rail_336_0 + this.luminaireLineFormFields.number_of_mounting_rail_336_1 + this.luminaireLineFormFields.number_of_mounting_rail_336_2 + this.luminaireLineFormFields.number_of_mounting_rail_168_0 + this.luminaireLineFormFields.number_of_mounting_rail_168_1 !== this.luminaireLineFormFields.number_of_mounting_rails_total)
                        )
                    )


                ) {
                    step_3_validated = 'step_3_not_valid';
                } else {
                    step_3_validated = 'step_3_valid';
                }

                this.stepThreeValidated = step_3_validated;

            },

            validateLuminationLength () {
                this.luminationLengthValid = this.luminaireLineFormFields.lumination_length > 0;
            },

            validateProductAddons () {

                if ( (this.luminaireControlLiteValid
                        && this.luminaireControlProValid
                        && this.cableRoutesValid
                        && this.universalAdapterValid
                        && this.universalConnectorValid
                        && this.universalConnectorValid_v2
                        && this.universalConnectorValid_v3
                        && this.universalConnectorSubmoduleValid
                        && this.universalConnectorSubmoduleValid_v2
                        && this.universalConnectorSubmoduleValid_v3
                        && this.connectingCableMiddleValid
                        && this.specialProductsValid

                    )
                    || !this.anyProductAddonSelected)
                {
                    this.productAddonsValid = true;
                } else
                {
                    this.productAddonsValid = false;
                }

            },

            validateLuminaireLine() {

                if ( this.product_configurator_id === 3
                    || ( this.luminaireLineFormFields.lumination_length_suggestion > 1
                    && this.luminaireLineFormFields.lumination_length > 0
                    && this.emergencyLightValid )
                ) {
                    this.mountingRailStepIsValid = true;
                } else {
                    this.mountingRailStepIsValid = false;
                }

                if (this.product_configurator_id === 3
                    || (this.selectedMountingRailTypeSuggestion
                    && this.luminaireLineFormFields.number_of_led_modules > 0
                    && this.luminaireLineFormFields.number_of_blind_modules >= 0
                    && (this.luminaireLineFormFields.number_of_modules_total - this.luminaireLineFormFields.number_of_led_modules === this.luminaireLineFormFields.number_of_blind_modules)
                    )
                ) {
                    this.blindModuleStepIsValid = true;
                } else {
                    this.blindModuleStepIsValid = false;
                }

                if (this.product_configurator_id === 3
                    && this.selectedMountingRailTypeSuggestion
                    && ((this.getTotalQuantityOfMountingRails(168) * 168 + this.getTotalQuantityOfMountingRails(336) * 336 + this.getTotalQuantityOfMountingRails(504) * 504 === this.luminaireLineFormFields.lumination_length)
                        || this.product_configurator_id !== 1)
                    && this.getTotalQuantityOfMountingRails() > 0
                    && this.getMissingMountingRailsByType(168).missing + this.getMissingMountingRailsByType(336).missing + this.getMissingMountingRailsByType(504).missing === 0
                ) {
                    this.mountingRailWithConnectorsStepIsValid = true;
                } else {
                    this.mountingRailWithConnectorsStepIsValid = false;
                }

                if ( this.product_configurator_id === 3
                    || (this.luminaireLineFormFields.number_of_modules_total > 0
                        && (this.luminaireLineFormFields.number_of_led_modules + this.luminaireLineFormFields.number_of_blind_modules) === this.luminaireLineFormFields.number_of_modules_total
                        && this.blindModuleStepIsValid )
                )
                {
                    this.ledAndBlindModuleValid = true;
                } else {
                    this.ledAndBlindModuleValid = false;
                }

                if (this.luminaireLineFormFields.number_of_led_modules > 0
                    && this.luminaireLineFormFields.number_of_led_modules > this.luminaireLineFormFields.number_of_modules_total
                    && !this.ledAndBlindModuleValid)
                {
                    this.luminaireLineFormFields.number_of_led_modules = this.luminaireLineFormFields.number_of_modules_total;
                    this.setNumberOfBlindModules();
                }

                if (this.luminaireLineFormFields.number_of_electrical_feeds_per_line > 0
                    && (this.number_of_electrical_feeds_start_total + this.number_of_electrical_feeds_end_total + this.luminaireLineFormFields.number_of_electrical_feeds_middle) >= this.luminaireLineFormFields.number_of_electrical_feeds_per_line
                    && (this.luminaireLineFormFields.type_of_electrical_feeds_start || this.luminaireLineFormFields.type_of_electrical_feeds_end || this.luminaireLineFormFields.type_of_electrical_feeds_middle) )
                {
                    this.electricalFeedsValid = true;
                } else {
                    this.electricalFeedsValid = false;
                }

                if (
                    (
                        (
                            this.luminaireLineFormFields.number_of_suspensions > 0
                            && this.luminaireLineFormFields.type_of_suspensions
                            && this.luminaireLineFormFields.number_of_mounting_adapters > 0
                            && this.luminaireLineFormFields.type_of_mounting_adapters
                            && this.luminaireLineFormFields.number_of_ceiling_mounts === 0
                            && !this.luminaireLineFormFields.type_of_ceiling_mounts
                        ) || (
                            this.luminaireLineFormFields.number_of_suspensions === 0
                            && !this.luminaireLineFormFields.type_of_suspensions
                            && this.luminaireLineFormFields.number_of_mounting_adapters === 0
                            && !this.luminaireLineFormFields.type_of_mounting_adapters
                            && this.luminaireLineFormFields.number_of_ceiling_mounts > 0
                            && this.luminaireLineFormFields.type_of_ceiling_mounts
                        )
                    ) && (
                        (this.luminaireLineFormFields.number_of_mounting_rails_total > 1
                            && this.luminaireLineFormFields.number_of_mount_connectors > 0
                            && this.luminaireLineFormFields.type_of_mount_connectors
                        ) || (
                            this.luminaireLineFormFields.number_of_mounting_rails_total <= 1
                            && this.luminaireLineFormFields.number_of_mount_connectors === 0
                            && !this.luminaireLineFormFields.type_of_mount_connectors
                        )
                    )
                )
                {
                    this.mountingValid = true;
                } else {
                    this.mountingValid = false;
                }

                if (( this.luminaireLineFormFields.type_of_emergency_light && this.luminaireLineFormFields.number_of_emergency_lights > 0 && this.luminaireLineFormFields.number_of_emergency_lights <= this.luminaireLineFormFields.number_of_led_modules)
                    || (!this.luminaireLineFormFields.type_of_emergency_light && this.luminaireLineFormFields.number_of_emergency_lights === 0)
                    // check if emergency_light_standalone then number of emergency lights must be > 0 and number of mounting rails 168 must be >= number of emergency lights
                )
                {
                    this.emergencyLightValid = true;
                } else {
                    this.emergencyLightValid = false;
                }

                if ( ( this.luminaireLineFormFields.type_of_connecting_cable_middle && ( (this.selectedSerie.includes('max') && this.luminaireLineFormFields.number_of_connecting_cable_middle > 1) || (!this.selectedSerie.includes('max') && this.luminaireLineFormFields.number_of_connecting_cable_middle > 0) ) )
                    || (!this.luminaireLineFormFields.type_of_connecting_cable_middle && this.luminaireLineFormFields.number_of_connecting_cable_middle === 0))
                {
                    this.connectingCableMiddleValid = true;
                } else {
                    this.connectingCableMiddleValid = false;
                }

                // Luminaire control lite
                if (
                    (
                        (this.luminaireLineFormFields.type_of_luminaire_control && this.luminaireControlIsPresenceDetector(this.luminaireLineFormFields.type_of_luminaire_control) && (this.luminaireLineFormFields.number_of_luminaire_controls + this.luminaireLineFormFields.number_of_luminaire_control_slaves > 0))
                        || (!this.luminaireLineFormFields.type_of_luminaire_control && this.luminaireLineFormFields.number_of_luminaire_controls === 0)
                        || (this.luminaireLineFormFields.type_of_luminaire_control && !this.luminaireControlIsPresenceDetector(this.luminaireLineFormFields.type_of_luminaire_control) && this.luminaireLineFormFields.number_of_luminaire_controls > 0)
                    )
                    &&
                    (
                        (this.luminaireLineFormFields.type_of_luminaire_control_slave && this.luminaireLineFormFields.number_of_luminaire_control_slaves > 0)
                        || (!this.luminaireLineFormFields.type_of_luminaire_control_slave && this.luminaireLineFormFields.number_of_luminaire_control_slaves === 0)
                    )
                    &&
                    (
                        ( (this.luminaireLineFormFields.type_of_luminaire_control_submodule && (this.luminaireLineFormFields.number_of_luminaire_control_submodules + this.luminaireLineFormFields.number_of_luminaire_control_submodule_slaves > 0))
                        || (!this.luminaireLineFormFields.type_of_luminaire_control_submodule && this.luminaireLineFormFields.number_of_luminaire_control_submodules === 0) )
                        && (this.luminaireLineFormFields.number_of_luminaire_control_submodules + this.luminaireLineFormFields.number_of_luminaire_control_submodule_slaves + this.luminaireLineFormFields.number_of_universal_connector_submodules + this.luminaireLineFormFields.number_of_universal_connector_submodules_v2 + this.luminaireLineFormFields.number_of_universal_connector_submodules_v3 <= this.luminaireLineFormFields.number_of_blind_modules)
                    )
                    &&
                    (
                        (this.luminaireLineFormFields.type_of_luminaire_control_submodule_slave && this.luminaireLineFormFields.number_of_luminaire_control_submodule_slaves > 0)
                        || (!this.luminaireLineFormFields.type_of_luminaire_control_submodule_slave && this.luminaireLineFormFields.number_of_luminaire_control_submodule_slaves === 0)
                    )
                    &&
                    (
                        (((this.luminaireLineFormFields.type_of_luminaire_control && this.productIsSubtype(this.luminaireLineFormFields.type_of_luminaire_control, 'presence_detector')) || this.luminaireLineFormFields.type_of_luminaire_control_submodule)
                        && this.luminaireLineFormFields.number_of_luminaire_controls + this.luminaireLineFormFields.number_of_luminaire_control_submodules === 1
                        && this.luminaireLineFormFields.number_of_luminaire_control_slaves + this.luminaireLineFormFields.number_of_luminaire_control_submodule_slaves <= 3)

                        || (this.luminaireLineFormFields.type_of_luminaire_control && !this.productIsSubtype(this.luminaireLineFormFields.type_of_luminaire_control, 'presence_detector') && this.luminaireLineFormFields.number_of_luminaire_controls > 0)
                        || (!this.luminaireLineFormFields.type_of_luminaire_control && this.luminaireLineFormFields.number_of_luminaire_controls === 0)
                    )
                )
                {

                    this.luminaireControlLiteValid = true;
                } else {
                    this.luminaireControlLiteValid = false;
                }

                // Luminaire control pro
                if ((this.luminaireLineFormFields.type_of_luminaire_control && !this.luminaireControlIsPresenceDetector(this.luminaireLineFormFields.type_of_luminaire_control) && this.luminaireLineFormFields.number_of_luminaire_controls > 0)
                    || (!this.luminaireLineFormFields.type_of_luminaire_control && this.luminaireLineFormFields.number_of_luminaire_controls === 0)
                    || (this.luminaireLineFormFields.type_of_luminaire_control && this.luminaireControlIsPresenceDetector(this.luminaireLineFormFields.type_of_luminaire_control) && this.luminaireLineFormFields.number_of_luminaire_controls > 0) )
                {
                    this.luminaireControlProValid = true;
                } else {
                    this.luminaireControlProValid = false;
                }

                if ( (this.luminaireLineFormFields.type_of_cable_route_168 || this.luminaireLineFormFields.type_of_cable_route_336 || this.luminaireLineFormFields.type_of_cable_route_504) && (this.luminaireLineFormFields.number_of_cable_routes_168 + this.luminaireLineFormFields.number_of_cable_routes_336 + this.luminaireLineFormFields.number_of_cable_routes_504 === this.luminaireLineFormFields.number_of_mounting_rails_total)
                    || (!this.luminaireLineFormFields.type_of_cable_route_168 && !this.luminaireLineFormFields.type_of_cable_route_336 && !this.luminaireLineFormFields.type_of_cable_route_504) && (this.luminaireLineFormFields.number_of_cable_routes_168 + this.luminaireLineFormFields.number_of_cable_routes_336 + this.luminaireLineFormFields.number_of_cable_routes_504 === 0))
                {
                    this.cableRoutesValid = true;
                } else {
                    this.cableRoutesValid = false;
                }

                // specialProductsValid
                // check: dass es sich von den blind modules ausgeht, dass bei jedem special product wenn vorhanden a quantity > 0, sku ! empty, price >= 0

                // check if each luminaireLineFormFiels.special_products has a quantity > 0, sku ! empty, price >= 0
                if(this.luminaireLineFormFields.special_products && this.luminaireLineFormFields.special_products.length > 0) {
                    this.specialProductsValid = this.luminaireLineFormFields.special_products.every(
                        product => product.quantity > 0 &&
                            product.sku !== '' &&
                            product.price >= 0
                    );
                } else {
                    this.specialProductsValid = true;
                }

                if ((( this.luminaireLineFormFields.type_of_universal_adapters_lg && this.luminaireLineFormFields.number_of_universal_adapters_lg > 0)
                        || ( !this.luminaireLineFormFields.type_of_universal_adapters_lg && this.luminaireLineFormFields.number_of_universal_adapters_lg === 0))
                    && (( this.luminaireLineFormFields.type_of_universal_adapters_sm && this.luminaireLineFormFields.number_of_universal_adapters_sm > 0)
                        || ( !this.luminaireLineFormFields.type_of_universal_adapters_sm && this.luminaireLineFormFields.number_of_universal_adapters_sm === 0))
                    )
                {
                    this.universalAdapterValid = true;
                } else {
                    this.universalAdapterValid = false;
                }

                if ( ( this.luminaireLineFormFields.type_of_universal_connectors && this.luminaireLineFormFields.number_of_universal_connectors > 0)
                        || ( !this.luminaireLineFormFields.type_of_universal_connectors && this.luminaireLineFormFields.number_of_universal_connectors === 0))
                {
                    this.universalConnectorValid = true;
                } else {
                    this.universalConnectorValid = false;
                }

                if ( ( this.luminaireLineFormFields.type_of_universal_connectors_v2 && this.luminaireLineFormFields.number_of_universal_connectors_v2 > 0)
                    || ( !this.luminaireLineFormFields.type_of_universal_connectors_v2 && this.luminaireLineFormFields.number_of_universal_connectors_v2 === 0))
                {
                    this.universalConnectorValid_v2 = true;
                } else {
                    this.universalConnectorValid_v2 = false;
                }

                if ( ( this.luminaireLineFormFields.type_of_universal_connectors_v3 && this.luminaireLineFormFields.number_of_universal_connectors_v3 > 0)
                    || ( !this.luminaireLineFormFields.type_of_universal_connectors_v3 && this.luminaireLineFormFields.number_of_universal_connectors_v3 === 0))
                {
                    this.universalConnectorValid_v3 = true;
                } else {
                    this.universalConnectorValid_v3 = false;
                }

                if ( ( ( this.luminaireLineFormFields.type_of_universal_connector_submodules && this.luminaireLineFormFields.number_of_universal_connector_submodules > 0)
                    || ( !this.luminaireLineFormFields.type_of_universal_connector_submodules && this.luminaireLineFormFields.number_of_universal_connector_submodules === 0) )
                    && (this.luminaireLineFormFields.number_of_luminaire_control_submodules + this.luminaireLineFormFields.number_of_universal_connector_submodules + this.luminaireLineFormFields.number_of_universal_connector_submodules_v2 + this.luminaireLineFormFields.number_of_universal_connector_submodules_v3 <= this.luminaireLineFormFields.number_of_blind_modules))
                {
                    this.universalConnectorSubmoduleValid = true;
                } else {
                    this.universalConnectorSubmoduleValid = false;
                }

                if ( ( ( this.luminaireLineFormFields.type_of_universal_connector_submodules_v2 && this.luminaireLineFormFields.number_of_universal_connector_submodules_v2 > 0)
                    || ( !this.luminaireLineFormFields.type_of_universal_connector_submodules_v2 && this.luminaireLineFormFields.number_of_universal_connector_submodules_v2 === 0) )
                    && (this.luminaireLineFormFields.number_of_luminaire_control_submodules + this.luminaireLineFormFields.number_of_universal_connector_submodules + this.luminaireLineFormFields.number_of_universal_connector_submodules_v2 + this.luminaireLineFormFields.number_of_universal_connector_submodules_v3 <= this.luminaireLineFormFields.number_of_blind_modules))
                {
                    this.universalConnectorSubmoduleValid_v2 = true;
                } else {
                    this.universalConnectorSubmoduleValid_v2 = false;
                }

                if ( ( ( this.luminaireLineFormFields.type_of_universal_connector_submodules_v3 && this.luminaireLineFormFields.number_of_universal_connector_submodules_v3 > 0)
                    || ( !this.luminaireLineFormFields.type_of_universal_connector_submodules_v3 && this.luminaireLineFormFields.number_of_universal_connector_submodules_v3 === 0) )
                    && (this.luminaireLineFormFields.number_of_luminaire_control_submodules + this.luminaireLineFormFields.number_of_universal_connector_submodules + this.luminaireLineFormFields.number_of_universal_connector_submodules_v2 + this.luminaireLineFormFields.number_of_universal_connector_submodules_v3 <= this.luminaireLineFormFields.number_of_blind_modules))
                {
                    this.universalConnectorSubmoduleValid_v3 = true;
                } else {
                    this.universalConnectorSubmoduleValid_v3 = false;
                }

                if (!this.luminaireLineFormFields.type_of_emergency_light && this.luminaireLineFormFields.number_of_emergency_lights === 0
                    && !this.luminaireLineFormFields.type_of_luminaire_control && this.luminaireLineFormFields.number_of_luminaire_controls === 0
                    && !this.luminaireLineFormFields.type_of_luminaire_control_slave && this.luminaireLineFormFields.number_of_luminaire_control_slaves === 0
                    && !this.luminaireLineFormFields.type_of_luminaire_control_submodule && this.luminaireLineFormFields.number_of_luminaire_control_submodules === 0
                    && !this.luminaireLineFormFields.type_of_luminaire_control_submodule_slave && this.luminaireLineFormFields.number_of_luminaire_control_submodule_slaves === 0
                    && !this.luminaireLineFormFields.type_of_universal_connectors && this.luminaireLineFormFields.number_of_universal_connectors === 0
                    && !this.luminaireLineFormFields.type_of_universal_connectors_v2 && this.luminaireLineFormFields.number_of_universal_connectors_v2 === 0
                    && !this.luminaireLineFormFields.type_of_universal_connectors_v3 && this.luminaireLineFormFields.number_of_universal_connectors_v3 === 0
                    && !this.luminaireLineFormFields.type_of_universal_connector_submodules && this.luminaireLineFormFields.number_of_universal_connector_submodules === 0
                    && !this.luminaireLineFormFields.type_of_universal_connector_submodules_v2 && this.luminaireLineFormFields.number_of_universal_connector_submodules_v2 === 0
                    && !this.luminaireLineFormFields.type_of_universal_connector_submodules_v3 && this.luminaireLineFormFields.number_of_universal_connector_submodules_v3 === 0
                    && (!this.luminaireLineFormFields.type_of_cable_route_168 && !this.luminaireLineFormFields.type_of_cable_route_336 && !this.luminaireLineFormFields.type_of_cable_route_504) && (this.luminaireLineFormFields.number_of_cable_routes_168 + this.luminaireLineFormFields.number_of_cable_routes_336 + this.luminaireLineFormFields.number_of_cable_routes_504 === 0)
                    && (!this.luminaireLineFormFields.type_of_universal_adapters_lg && this.luminaireLineFormFields.number_of_universal_adapters_lg === 0 && !this.luminaireLineFormFields.type_of_universal_adapters_sm && this.luminaireLineFormFields.number_of_universal_adapters_sm === 0 && !this.luminaireLineFormFields.type_of_universal_connectors && this.luminaireLineFormFields.number_of_universal_connectors === 0 )
                )
                {
                    this.anyProductAddonSelected = false;
                } else {
                    this.anyProductAddonSelected = true;
                }

            },

        },

        computed: {

            ...mapGetters({
                authenticated: 'auth/authenticated',
                user: 'auth/user',
                permissions: 'auth/permissions'
            }),

            availableBlindModulesCount() {
                let submodulesCount = 0;
                this.helpers.number_of_submodules_db_titles.forEach((title) => {
                    if (this.luminaireLineFormFields[title]) {
                        submodulesCount += this.luminaireLineFormFields[title];
                    }
                });

                return this.luminaireLineFormFields.number_of_blind_modules - submodulesCount - this.specialProductsCount;
            },

            specialProductsCount() {
                if (this.luminaireLineFormFields.special_products && this.luminaireLineFormFields.special_products.length > 0) {
                    return this.luminaireLineFormFields.special_products.reduce((acc, product) => {
                        return acc + product.quantity;
                    }, 0);
                } else {
                    return 0;
                }
            },

            sensorSystemMasterCount() {
                let quantity = this.luminaireLineFormFields.number_of_luminaire_control_submodules;

                if (this.luminaireLineFormFields.type_of_luminaire_control && this.luminaireControlIsPresenceDetector(this.luminaireLineFormFields.type_of_luminaire_control)) {
                    quantity += this.luminaireLineFormFields.number_of_luminaire_controls;
                }
                return quantity;
            },

            sensorSystemSlaveCount() {
                return this.luminaireLineFormFields.number_of_luminaire_control_slaves + this.luminaireLineFormFields.number_of_luminaire_control_submodule_slaves;
            },

            availableSlavesCount() {
                if (this.sensorSystemMasterCount > 0) {
                    return 3 - (this.sensorSystemSlaveCount);
                } else {
                    return 1000;
                }
            },

            availableIntegratedSlavesCount() {
                if (this.availableSlavesCount > this.availableBlindModulesCount) {
                    return this.availableBlindModulesCount;
                } else {
                    return this.availableSlavesCount;
                }
            },

            luminaireLengthImage() {
                if (this.selectedSerie === 'eco') {
                    return this.$i18n.locale === 'en'
                        ? this.asset('img/luminaire-selection-tool/beleuchtungslaenge-v2_en.png')
                        : this.asset('img/luminaire-selection-tool/beleuchtungslaenge-v2.png');
                }

                return this.$i18n.locale === 'en'
                    ? this.asset('img/luminaire-selection-tool/beleuchtungslaenge-max-v2_en.png')
                    : this.asset('img/luminaire-selection-tool/beleuchtungslaenge-max-v2.png');
            },

        },

        watch: {

            luminaireLineFormFields: {
                handler(val){
                    this.getMountingRailTypeSuggestions();
                    this.validateLuminaireLine();
                    this.validateLuminationLength();
                    this.validateProductAddons();
                    this.validateStepThree();
                    this.$emit('update-ltt-form', val);
                    this.activateTooltips();
                },
                deep: true
            },

            selectedHousingColor: function(value) {
                // if is eloxal
                if (value && value === 4 && (this.luminaireLineFormFields.type_of_universal_connectors_v2 || this.luminaireLineFormFields.type_of_universal_connectors_v3)) {
                    this.luminaireLineFormFields.type_of_universal_connectors_v2 = null;
                    this.luminaireLineFormFields.number_of_universal_connectors_v2 = 0;
                    this.luminaireLineFormFields.type_of_universal_connectors_v3 = null;
                    this.luminaireLineFormFields.number_of_universal_connectors_v3 = 0;
                }

            },

            selectedSerie: function(newVal, oldVal) {
                if (newVal.includes('max') && oldVal.includes('eco')) {
                    this.fixNumberConnectingCableMiddle();
                }

                this.fixEmergencyLightSelection();
                this.fixUniversalConnectorSubmodulesSelection();
            },

            finalPlanningPrice: function(value) {
                this.$emit('update-final-planning-price', value);
            },

            luminaireLinePrices: {
                handler(val, oldVal){
                    this.$emit('update-luminaire-line-prices', val);
                },
                deep: true
            },

            stepThreeValidated: function(value) {
                this.$emit('update-step-3-validated', value);
            },

            planning_id: function(value) {
                this.luminaireLineFormFields.planning_id = value;
            },

            planningFormFields: function(value) {
                //this.validateLuminationLength();
                this.validateStepThree();
            },

            luminaireLineProducts: function (value) {
                this.calculateLuminationLineForm();

            },

            mountingRailTypeSuggestions: function (value) {
                let keys = Object.keys(value);
                if (!keys.includes(this.selectedMountingRailTypeSuggestion)) {
                    this.selectedMountingRailTypeSuggestion = 'optimal';
                }
            },

            lltDataLoaded: function (value) {
                this.loadPlanningDataOnEdit();
                this.validateStepThree();
            },


        },
    }
</script>
